import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  FilterDate: any;
  JSON: any;
  SafeInt: number;
};

export type AdfAudienceIntegrationConfiguration = {
  emails: Array<Scalars['String']>;
};

export type AdfAudienceIntegrationConfigurationInput = {
  emails: Array<Scalars['String']>;
};

export enum ActionType {
  AudienceExported = 'AudienceExported',
  Created = 'Created',
  Deleted = 'Deleted',
  InviteAccepted = 'InviteAccepted',
  InviteRejected = 'InviteRejected',
  Updated = 'Updated'
}

export enum ActivityLevel {
  Audience = 'Audience',
  Organization = 'Organization'
}

export type ActivitySummaryConnection = {
  /** A list of nodes. */
  nodes: Array<EntityLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type AddOnCompletedInput = {
  addOnType: AudienceAddOn;
  additionId?: InputMaybe<Scalars['ID']>;
  audienceId: Scalars['ID'];
};

export type AddPeopleAudienceCustomerListInput = {
  audienceId: Scalars['ID'];
  delimiter?: InputMaybe<Scalars['String']>;
  s3FileUri: Scalars['String'];
  selectedColumns: AudienceCustomerListColumnMappingsInput;
};

export type AddPeopleAudienceGlobalInput = {
  additionalRequestedCount: Scalars['Int'];
  audienceId: Scalars['ID'];
};

export type AdditionalInfo = {
  all?: Maybe<Array<KeyValue>>;
  known?: Maybe<KnownAdditionalInfo>;
};

export type AdditionalInfoAggregates = {
  all?: Maybe<Array<KeyAggregate>>;
  known?: Maybe<KnownAdditionalInfoAggregates>;
};

export type AdminAudiencePixelSettingsUpdateInput = {
  id: Scalars['ID'];
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
};

export type AdminUpdateOrganizationInput = {
  adfProviderInfo?: InputMaybe<Scalars['String']>;
  businessDataEnabled?: InputMaybe<Scalars['Boolean']>;
  customerListEnabled?: InputMaybe<Scalars['Boolean']>;
  disableEmailValidation?: InputMaybe<Scalars['Boolean']>;
  globalSearchEnabled?: InputMaybe<Scalars['Boolean']>;
  globalSearchLimit?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  lookalikeEnabled?: InputMaybe<Scalars['Boolean']>;
  lookalikeSearchLimit?: InputMaybe<Scalars['Int']>;
  /** @deprecated Please use paymentStatus instead of this field. */
  paidSubscription?: InputMaybe<Scalars['Boolean']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  pixelDomain?: InputMaybe<Scalars['String']>;
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
  pulseEnabled?: InputMaybe<Scalars['Boolean']>;
  subscriptionOverride?: InputMaybe<Scalars['Boolean']>;
  whiteLabelImageUrl?: InputMaybe<Scalars['String']>;
};

export type AppConfiguration = {
  pulseDateRange: DateRange;
  pulseSubscriptionAmount: Scalars['Int'];
  pulseTopicVersion: Scalars['Int'];
};

export type AppConfigurationInput = {
  pulseDateRange?: InputMaybe<DateRangeInput>;
  pulseSubscriptionAmount?: InputMaybe<Scalars['Int']>;
  pulseTopicVersion?: InputMaybe<Scalars['Int']>;
};

export type AttributionSource = {
  count: Scalars['Int'];
  source: Scalars['String'];
};

export type AttributionSources = {
  attributions: Array<AttributionSource>;
};

export type Audience = BaseAudience & {
  /**
   * Get the most X attribution sources grouped by utmGroup (where X is specified by the count parameter) and the unique
   * people count for each attribution source.
   */
  attributionSourceCounts: AttributionSources;
  audienceOnlyAccess: Scalars['Boolean'];
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition: AudienceCondition;
  createdAt: Scalars['Date'];
  createdByUserId: Scalars['ID'];
  creator: BaseUser;
  customFields: Array<CustomField>;
  deletedAt?: Maybe<Scalars['Date']>;
  filters?: Maybe<Array<PersonFilter>>;
  id: Scalars['ID'];
  info?: Maybe<AudienceInfo>;
  /**
   * Gets a page of integrations for the given arguments.
   * Also, audience integrations can be filtered by name.
   */
  integrationsPage: AudienceIntegrationConnection;
  /**
   * Get the most visited X paths for the provided filters (where X is specified by the count parameter). In order to
   * get the root ones, don't pass a pathPrefix filter. This query will return the top X paths of level Y + 1, where Y
   * is the level of the prefix passed, if any. No pathPrefix filter will return "/a", "/b", etc, and passing "/a" will
   * return "/a/a", "/a/b", etc.
   *
   * The result object will have the total number of unique users, including the number of visits to the pathPrefix, and
   * each path object will have the total number of unique users for that path. The same user can appear in more than a
   * path entry.
   */
  journeyTopPaths: JourneyPaths;
  /** Get the most visited X URLs for the provided filters (where X is specified by the count parameter). */
  journeyTopUrls: Array<Scalars['String']>;
  /** Gets paginated journeys for a pixel audience. */
  journeys?: Maybe<PageViewConnection>;
  lookalikesCount: Scalars['Int'];
  /** Gets a page of lookalikes for the given arguments. */
  lookalikesPage: AudienceConnection;
  name: Scalars['String'];
  organization: BaseOrganization;
  organizationId: Scalars['ID'];
  parentAudience?: Maybe<BaseAudience>;
  pendingInvites?: Maybe<Array<Invite>>;
  /** Scans full audience people. */
  people?: Maybe<PersonConnection>;
  peopleCount?: Maybe<Scalars['Int']>;
  /** Gets counts of people for the given field. Fields compatible with this query are "category-like" fields. */
  peopleCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /** Gets counts of people for the provided date field. Counts are returned in buckets defined by the provided date interval. */
  peopleDateHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /**
   * Gets counts of people for the provided number field. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   * bucketKeyFormat ("{from} - {to}" by default): format for the bucket key.
   */
  peopleNumberHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Gets a page of people for the given arguments. NOTE: For a cursor-based pagination, use the people query instead. */
  peoplePage?: Maybe<PersonConnection>;
  /** Gets a paginated journey of a given person for a pixel audience. */
  personJourney?: Maybe<PageViewConnection>;
  /**
   * Gets paged counts of journeys for a person grouped by a field.
   * This query will always return "totalCount" with a value.
   */
  personJourneyGroups?: Maybe<BucketConnection>;
  pixelSettings?: Maybe<AudiencePixelSettings>;
  processingResult?: Maybe<Scalars['String']>;
  processingResultInfo?: Maybe<ProcessingResultInfo>;
  processingStatus?: Maybe<AudienceProcessingStatus>;
  quotaInfo?: Maybe<AudienceQuotaInfo>;
  /**
   * Returns the S3 Path for a new S3 integration.
   * For existing integrations, please use the destinationS3URI from the configuration
   */
  s3IntegrationTestPath: Scalars['String'];
  /** @deprecated Please use the segmentsPage query instead of this. */
  segments: Array<Audience>;
  segmentsCount: Scalars['Int'];
  /** Gets a page of segments for the given arguments. */
  segmentsPage: AudienceConnection;
  systemQueryInfo?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Date'];
  userRoles?: Maybe<Array<AudienceUserRole>>;
  verifyEmails?: Maybe<Scalars['Boolean']>;
};


export type AudienceAttributionSourceCountsArgs = {
  count?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  utmGroup: UtmGroup;
};


export type AudienceIntegrationsPageArgs = {
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type AudienceJourneyTopPathsArgs = {
  count: Scalars['Int'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
};


export type AudienceJourneyTopUrlsArgs = {
  count: Scalars['Int'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
};


export type AudienceJourneysArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int'];
};


export type AudienceLookalikesPageArgs = {
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
};


export type AudiencePeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  first: Scalars['Int'];
  sort?: InputMaybe<Array<SortFieldInput>>;
};


export type AudiencePeopleCountsArgs = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
};


export type AudiencePeopleDateHistogramArgs = {
  field: FilterDateField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval: DateIntervalInput;
  max?: InputMaybe<Scalars['Date']>;
  min?: InputMaybe<Scalars['Date']>;
};


export type AudiencePeopleNumberHistogramArgs = {
  bucketKeyFormat?: InputMaybe<Scalars['String']>;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
};


export type AudiencePeoplePageArgs = {
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<SortFieldInput>>>;
};


export type AudiencePersonJourneyArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int'];
  personId: Scalars['ID'];
};


export type AudiencePersonJourneyGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  groupBy: JourneyGroupByInput;
  personId: Scalars['ID'];
};


export type AudienceSegmentsPageArgs = {
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
};


export type AudienceSystemQueryInfoArgs = {
  options?: InputMaybe<SystemAudienceQueryInfoOptions>;
};

export enum AudienceAddOn {
  EmailValidation = 'EmailValidation'
}

export type AudienceBilling = {
  dayOfMonth: Scalars['Int'];
};

export type AudienceBillingInput = {
  dayOfMonth: Scalars['Int'];
};

export type AudienceCategory = {
  categoryCode: Scalars['Int'];
  categoryName: Scalars['String'];
  categoryPath: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  relevance?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type AudienceCategoryInput = {
  code: Scalars['Int'];
  relevance?: InputMaybe<Scalars['Int']>;
};

export enum AudienceCondition {
  CustomerList = 'CustomerList',
  Global = 'Global',
  Lookalike = 'Lookalike',
  Pixel = 'Pixel',
  Pulse = 'Pulse',
  Segment = 'Segment'
}

export type AudienceConnection = {
  edges: Array<AudienceEdge>;
  nodes: Array<Audience>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AudienceCustomerListColumnMappings = {
  customFields?: Maybe<Array<AudienceCustomerListCustomFieldColumnMapping>>;
  email?: Maybe<Scalars['Int']>;
  emailField?: Maybe<Scalars['String']>;
  emailMd5?: Maybe<Scalars['Int']>;
  emailMd5Field?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['Int']>;
  phoneField?: Maybe<Scalars['String']>;
};

export type AudienceCustomerListColumnMappingsInput = {
  customFields?: InputMaybe<Array<AudienceCustomerListCustomFieldColumnMappingInput>>;
  email?: InputMaybe<Scalars['Int']>;
  emailField?: InputMaybe<Scalars['String']>;
  emailMd5?: InputMaybe<Scalars['Int']>;
  emailMd5Field?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['Int']>;
  phoneField?: InputMaybe<Scalars['String']>;
};

export type AudienceCustomerListCustomField = {
  field: Scalars['String'];
  fieldType: CustomFieldType;
  pending?: Maybe<Scalars['Boolean']>;
};

export type AudienceCustomerListCustomFieldColumnMapping = {
  /** The column number in the CSV file provided by the user */
  column: Scalars['Int'];
  /** The name of the custom field in the audience provided by the user */
  field: Scalars['String'];
  /** The type of the custom field */
  fieldType: CustomFieldType;
  /** The original column name in the CSV file provided by the user */
  originalField?: Maybe<Scalars['String']>;
};

export type AudienceCustomerListCustomFieldColumnMappingInput = {
  /** The column number in the CSV file provided by the user */
  column: Scalars['Int'];
  /** The name of the custom field in the audience provided by the user */
  field: Scalars['String'];
  /** The type of the custom field */
  fieldType: CustomFieldType;
  /** The original column name in the CSV file provided by the user */
  originalField?: InputMaybe<Scalars['String']>;
};

export type AudienceCustomerListInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<CustomerListAdditionsArrayInfo>>;
  customFields?: Maybe<Array<AudienceCustomerListCustomField>>;
  /** @deprecated Moved to additions info */
  delimiter?: Maybe<Scalars['String']>;
  failedAdditions?: Maybe<Array<CustomerListFailedAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']>;
  lastProcessedAt?: Maybe<Scalars['Date']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']>;
  /** @deprecated Moved to additions info */
  mapping: AudienceCustomerListColumnMappings;
  /** @deprecated Moved to additions info */
  matchedCount?: Maybe<Scalars['Int']>;
  processingAdditionInfo?: Maybe<CustomerListProcessingAdditionInfo>;
  s3FileUri: Scalars['String'];
  /** @deprecated Moved to additions info */
  totalCount?: Maybe<Scalars['Int']>;
};

export type AudienceCustomerListInput = {
  delimiter?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  s3FileUri: Scalars['String'];
  selectedColumns: AudienceCustomerListColumnMappingsInput;
  verifyEmails?: InputMaybe<Scalars['Boolean']>;
};

export type AudienceDateFilterInput = {
  field: AudienceFilterDateField;
  operator: DateOperatorsInput;
};

export type AudienceEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Audience>;
};

export enum AudienceFilterDateField {
  CreatedAt = 'CreatedAt',
  LastNewMatchDate = 'LastNewMatchDate'
}

export type AudienceFilterInput = {
  dateFilter?: InputMaybe<AudienceDateFilterInput>;
  numberFilter?: InputMaybe<AudienceNumberFilterInput>;
};

export enum AudienceFilterNumberField {
  QuotaUsagePercentage = 'QuotaUsagePercentage'
}

export type AudienceGlobalInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<GlobalAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']>;
  lastProcessedAt?: Maybe<Scalars['Date']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']>;
  processingAdditionInfo?: Maybe<GlobalProcessingAdditionInfo>;
};

export type AudienceGlobalInput = {
  filters: Array<PersonFilterInput>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  requestedCount?: InputMaybe<Scalars['Int']>;
  verifyEmails?: InputMaybe<Scalars['Boolean']>;
};

export type AudienceInfo = AudienceCustomerListInfo | AudienceGlobalInfo | AudienceLookalikeInfo | AudiencePixelInfo | AudiencePulseInfo;

export type AudienceIntegration = {
  audience: Audience;
  configuration: AudienceIntegrationConfiguration;
  createdAt: Scalars['Date'];
  createdByUserId?: Maybe<Scalars['ID']>;
  creator?: Maybe<User>;
  id: Scalars['ID'];
  integrationType: AudienceIntegrationType;
  lastRunAt?: Maybe<Scalars['Date']>;
  lastRunResult?: Maybe<Scalars['String']>;
  lastRunSucceeded?: Maybe<Scalars['Boolean']>;
  lastSuccessfulRunAt?: Maybe<Scalars['Date']>;
  lastSyncedAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
};

export type AudienceIntegrationConfiguration = AdfAudienceIntegrationConfiguration | BeeswaxAudienceIntegrationConfiguration | FacebookCustomAudienceAudienceIntegrationConfiguration | GoogleCustomerMatchAudienceIntegrationConfiguration | HighLevelAudienceIntegrationConfiguration | MailchimpAudienceIntegrationConfiguration | S3AudienceIntegrationConfiguration | TealiumAudienceIntegrationConfiguration | ZapierAudienceIntegrationConfiguration;

export type AudienceIntegrationConfigurationInput = {
  adf?: InputMaybe<AdfAudienceIntegrationConfigurationInput>;
  beeswax?: InputMaybe<BeeswaxAudienceIntegrationConfigurationInput>;
  facebookCustomAudience?: InputMaybe<FacebookCustomAudienceAudienceIntegrationConfigurationInput>;
  googleCustomerMatch?: InputMaybe<GoogleCustomerMatchAudienceIntegrationConfigurationInput>;
  highLevel?: InputMaybe<HighLevelAudienceIntegrationConfigurationInput>;
  mailchimp?: InputMaybe<MailchimpAudienceIntegrationConfigurationInput>;
  s3?: InputMaybe<S3AudienceIntegrationConfigurationInput>;
  tealium?: InputMaybe<TealiumAudienceIntegrationConfigurationInput>;
  zapier?: InputMaybe<ZapierAudienceIntegrationConfigurationInput>;
};

export type AudienceIntegrationConnection = {
  edges: Array<AudienceIntegrationEdge>;
  nodes: Array<AudienceIntegration>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type AudienceIntegrationEdge = {
  cursor: Scalars['String'];
  node?: Maybe<AudienceIntegration>;
};

export type AudienceIntegrationInput = {
  audienceId: Scalars['ID'];
  configuration: AudienceIntegrationConfigurationInput;
  integrationType: AudienceIntegrationType;
  name: Scalars['String'];
};

export type AudienceIntegrationLastRunInfoInput = {
  id: Scalars['ID'];
  lastSyncedAt?: InputMaybe<Scalars['Date']>;
  result?: InputMaybe<Scalars['String']>;
  succeeded: Scalars['Boolean'];
};

export type AudienceIntegrationMetadata = {
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  integrationType: AudienceIntegrationType;
};

export type AudienceIntegrationTestInput = {
  audienceId: Scalars['ID'];
  configuration: AudienceIntegrationConfigurationInput;
  integrationId?: InputMaybe<Scalars['ID']>;
  integrationType: AudienceIntegrationType;
  name: Scalars['String'];
};

export type AudienceIntegrationTestResult = {
  /** @deprecated Please use the 'message' property instead. */
  failureReason?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum AudienceIntegrationType {
  Adf = 'ADF',
  Beeswax = 'Beeswax',
  FacebookCustomAudience = 'FacebookCustomAudience',
  GoogleCustomerMatch = 'GoogleCustomerMatch',
  HighLevel = 'HighLevel',
  Mailchimp = 'Mailchimp',
  S3 = 'S3',
  Tealium = 'Tealium',
  Zapier = 'Zapier'
}

export type AudienceIntegrationUpdateInput = {
  configuration?: InputMaybe<AudienceIntegrationConfigurationInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type AudienceLookalikeCountInput = {
  baseAudienceId: Scalars['ID'];
  dateRange?: InputMaybe<DateRangeInput>;
  similarityPercentage: Scalars['Int'];
};

export type AudienceLookalikeInfo = {
  dateRange?: Maybe<DateRange>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']>;
  matchedCount?: Maybe<Scalars['Int']>;
  requestedCount: Scalars['Int'];
  similarityPercentage: Scalars['Int'];
};

export type AudienceLookalikeInput = {
  baseAudienceId: Scalars['ID'];
  dateRange?: InputMaybe<DateRangeInput>;
  name: Scalars['String'];
  requestedCount: Scalars['Int'];
  similarityPercentage: Scalars['Int'];
  verifyEmails?: InputMaybe<Scalars['Boolean']>;
};

export type AudienceMatchCount = {
  audience: BaseAudience;
  count: Scalars['Int'];
};

export type AudienceNumberFilterInput = {
  field: AudienceFilterNumberField;
  operator: NumberOperatorsInput;
};

export type AudiencePixelCodeSnippets = {
  body: Scalars['String'];
  head: Scalars['String'];
};

export type AudiencePixelEditInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pixelEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type AudiencePixelInfo = {
  categoriesProcessed: Scalars['Boolean'];
};

export type AudiencePixelInput = {
  billing: AudienceBillingInput;
  /** @deprecated Please use hostAndPath instead of this. */
  host?: InputMaybe<Scalars['String']>;
  hostAndPath?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  pixelMatchingCadence?: InputMaybe<PixelMatchingCadence>;
  quota?: InputMaybe<AudienceQuotaInput>;
  quotaEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type AudiencePixelSettings = {
  billing: AudienceBilling;
  codeSnippets?: Maybe<AudiencePixelCodeSnippets>;
  host: Scalars['String'];
  hostAndPath: Scalars['String'];
  lastNewMatchDate?: Maybe<Scalars['Date']>;
  location?: Maybe<Location>;
  pixelDisabledAt?: Maybe<Scalars['Date']>;
  /** @deprecated Please use pixelStatus instead of this. */
  pixelEnabled: Scalars['Boolean'];
  pixelId: Scalars['String'];
  pixelMatchingCadence: PixelMatchingCadence;
  pixelReachedQuotaAt?: Maybe<Scalars['Date']>;
  pixelSetupStatus?: Maybe<PixelSetupStatus>;
  pixelStatus: AudiencePixelStatus;
  quota: AudienceQuota;
  quotaEnabled: Scalars['Boolean'];
  sendsPixelStatsEmail?: Maybe<Scalars['Boolean']>;
};


export type AudiencePixelSettingsSendsPixelStatsEmailArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']>;
};

export type AudiencePixelSettingsUpdateInput = {
  hostAndPath?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pixelEnabled?: InputMaybe<Scalars['Boolean']>;
  quota?: InputMaybe<AudienceQuotaInput>;
  quotaEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum AudiencePixelStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  QuotaReached = 'QuotaReached'
}

export enum AudienceProcessingStatus {
  Completed = 'Completed',
  Error = 'Error',
  Pending = 'Pending',
  Processing = 'Processing'
}

export type AudiencePulseInfo = BaseAdditionsInfo & {
  additions?: Maybe<Array<PulseAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']>;
  items: Array<PulseItem>;
  lastProcessedAt?: Maybe<Scalars['Date']>;
  lastProcessedDateRange?: Maybe<DateRange>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']>;
  processingAdditionInfo?: Maybe<PulseProcessingAdditionInfo>;
  subscriptionAmount: Scalars['Int'];
  subscriptionCount: Scalars['Int'];
  /** @deprecated topicIds is deprecated. Use items instead. */
  topicIds: Array<Scalars['String']>;
};

export type AudiencePulseInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<Array<PersonFilterInput>>;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  subCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  subscriptionCount: Scalars['Int'];
  topicIds: Array<Scalars['String']>;
  verifyEmails?: InputMaybe<Scalars['Boolean']>;
};

export type AudienceQuota = {
  /** @deprecated Please use the quotaEnabled instead of this. */
  enabled?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  period?: Maybe<AudienceQuotaPeriod>;
};

export type AudienceQuotaInfo = {
  currentCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  limit?: Maybe<Scalars['Int']>;
  period?: Maybe<AudienceQuotaPeriod>;
  pixelStatus: AudiencePixelStatus;
};

export type AudienceQuotaInput = {
  /** @deprecated Please use the quotaEnabled instead of this. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<AudienceQuotaPeriod>;
};

export enum AudienceQuotaPeriod {
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type AudienceSegmentInput = {
  filters: Array<PersonFilterInput>;
  name: Scalars['String'];
  parentAudienceId: Scalars['ID'];
};

export type AudienceUpdateInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type AudienceUserRole = {
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type AudiencesCount = {
  customerList: Scalars['Int'];
  global: Scalars['Int'];
  lookalike: Scalars['Int'];
  pixel: Scalars['Int'];
  pulse: Scalars['Int'];
};

export type AutoCustomerListCreationConfiguration = {
  mapping: AudienceCustomerListColumnMappings;
  verifyEmails: Scalars['Boolean'];
};

export enum AwsRegion {
  AfSouth1 = 'AfSouth1',
  ApEast1 = 'ApEast1',
  ApNortheast1 = 'ApNortheast1',
  ApNortheast2 = 'ApNortheast2',
  ApNortheast3 = 'ApNortheast3',
  ApSouth1 = 'ApSouth1',
  ApSouth2 = 'ApSouth2',
  ApSoutheast1 = 'ApSoutheast1',
  ApSoutheast2 = 'ApSoutheast2',
  ApSoutheast3 = 'ApSoutheast3',
  ApSoutheast4 = 'ApSoutheast4',
  CaCentral1 = 'CaCentral1',
  EuCentral1 = 'EuCentral1',
  EuCentral2 = 'EuCentral2',
  EuNorth1 = 'EuNorth1',
  EuSouth1 = 'EuSouth1',
  EuSouth2 = 'EuSouth2',
  EuWest1 = 'EuWest1',
  EuWest2 = 'EuWest2',
  EuWest3 = 'EuWest3',
  IlCentral1 = 'IlCentral1',
  MeCentral1 = 'MeCentral1',
  MeSouth1 = 'MeSouth1',
  SaEast1 = 'SaEast1',
  UsEast1 = 'UsEast1',
  UsEast2 = 'UsEast2',
  UsGovEast1 = 'UsGovEast1',
  UsGovWest1 = 'UsGovWest1',
  UsWest1 = 'UsWest1',
  UsWest2 = 'UsWest2'
}

export type BaseAdditionsArrayInfo = {
  date: Scalars['Date'];
  matchedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type BaseAdditionsInfo = {
  additions?: Maybe<Array<BaseAdditionsArrayInfo>>;
  isProcessingAddOns?: Maybe<Scalars['Boolean']>;
  lastProcessedAt?: Maybe<Scalars['Date']>;
  lastSuccessfullyProcessedAt?: Maybe<Scalars['Date']>;
  processingAdditionInfo?: Maybe<BaseProcessingAdditionInfo>;
};

export type BaseAudience = {
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition?: Maybe<AudienceCondition>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  filters?: Maybe<Array<PersonFilter>>;
  id: Scalars['ID'];
  info?: Maybe<AudienceInfo>;
  name?: Maybe<Scalars['String']>;
  parentAudience?: Maybe<BaseAudience>;
};

export type BaseOrganization = {
  businessDataEnabled?: Maybe<Scalars['Boolean']>;
  disableEmailValidation?: Maybe<Scalars['Boolean']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationType?: Maybe<OrganizationType>;
};


export type BaseOrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']>;
};

export type BaseProcessingAdditionInfo = {
  date: Scalars['Date'];
  requestedCount: Scalars['Int'];
};

export type BaseRole = {
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
};

export type BaseUser = {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type BeeswaxAudienceIntegrationConfiguration = {
  buzzKey: Scalars['String'];
  email: Scalars['String'];
  hemSalt?: Maybe<Scalars['String']>;
  lastUploadIds?: Maybe<Array<Scalars['String']>>;
  password?: Maybe<Scalars['String']>;
  segmentKey: Scalars['String'];
};

export type BeeswaxAudienceIntegrationConfigurationInput = {
  buzzKey?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hemSalt?: InputMaybe<Scalars['String']>;
  lastUploadIds?: InputMaybe<Array<Scalars['String']>>;
  password?: InputMaybe<Scalars['String']>;
  segmentKey?: InputMaybe<Scalars['String']>;
};

export type BeeswaxListSegmentsInput = {
  audienceIntegrationId?: InputMaybe<Scalars['ID']>;
  buzzKey?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  nextCursor?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type BeeswaxListSegmentsResult = {
  hasNextPage: Scalars['Boolean'];
  items: Array<BeeswaxSegment>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type BeeswaxSegment = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type BooleanFilter = {
  customField?: Maybe<Scalars['String']>;
  field?: Maybe<FilterBooleanField>;
  operator: BooleanOperators;
};

export type BooleanFilterInput = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterBooleanField>;
  operator: BooleanOperatorsInput;
};

export type BooleanOperators = {
  eq?: Maybe<Scalars['Boolean']>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type BooleanOperatorsInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type Browser = {
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type BucketConnection = {
  /** A list of nodes. */
  nodes: Array<BucketElement>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type BucketElement = {
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type CompleteAudienceCustomerListInput = {
  audienceId: Scalars['ID'];
  processingResultInfo?: InputMaybe<CompleteAudienceCustomerListProcessingResultInfoInput>;
  requestedCount?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['String']>;
  succeeded: Scalars['Boolean'];
};

export type CompleteAudienceCustomerListProcessingResultInfoInput = {
  invalidEntries?: InputMaybe<Array<CustomerListInvalidEntryInput>>;
};

export type CompleteAudienceGlobalInput = {
  audienceId: Scalars['ID'];
  result?: InputMaybe<Scalars['String']>;
  succeeded: Scalars['Boolean'];
};

export type CompleteAudienceLookalikeInput = {
  audienceId: Scalars['ID'];
  result?: InputMaybe<Scalars['String']>;
  succeeded: Scalars['Boolean'];
};

export type CompleteAudiencePulseInput = {
  audienceId: Scalars['ID'];
  result?: InputMaybe<Scalars['String']>;
  succeeded: Scalars['Boolean'];
};

export enum ComponentKind {
  MeteredComponent = 'MeteredComponent',
  OnOffComponent = 'OnOffComponent',
  PrepaidUsageComponent = 'PrepaidUsageComponent',
  QuantityBasedComponent = 'QuantityBasedComponent'
}

export type Configuration = {
  clientApplicationId: Scalars['String'];
  domain: Scalars['String'];
  identityPoolId: Scalars['String'];
  region: Scalars['String'];
  userPoolId: Scalars['String'];
};

export type ConfirmPendingAudiencePulseInput = {
  id: Scalars['ID'];
  subscriptionCount: Scalars['Int'];
};

export type ConversationConnection = {
  agentSessionId: Scalars['String'];
  nodes: Array<ConversationMessage>;
  pageInfo: PageInfo;
};

export type ConversationMessage = {
  body?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  role: ConversationRole;
};

export enum ConversationRole {
  Assistant = 'Assistant',
  Other = 'Other',
  Tool = 'Tool',
  User = 'User'
}

export enum ConversationSection {
  PixelAudienceOverviewAmountOfVisits = 'PixelAudienceOverviewAmountOfVisits',
  PixelAudienceOverviewAttributionSources = 'PixelAudienceOverviewAttributionSources',
  PixelAudienceOverviewBusinessInsight = 'PixelAudienceOverviewBusinessInsight',
  PixelAudienceOverviewPixelCounts = 'PixelAudienceOverviewPixelCounts',
  PixelAudienceOverviewSegments = 'PixelAudienceOverviewSegments',
  PixelAudienceOverviewUserJourney = 'PixelAudienceOverviewUserJourney'
}

export type Coordinates = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CoordinatesInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentOrganizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  pixelDomain?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
};

export type CustomField = {
  fieldType: CustomFieldType;
  name: Scalars['String'];
};

export enum CustomFieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Integer = 'Integer',
  String = 'String'
}

export type CustomerListAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date'];
  delimiter?: Maybe<Scalars['String']>;
  mapping: AudienceCustomerListColumnMappings;
  matchedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  s3FileUri: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type CustomerListFailedAdditionsArrayInfo = {
  date: Scalars['Date'];
  delimiter?: Maybe<Scalars['String']>;
  error: Scalars['String'];
  mapping: AudienceCustomerListColumnMappings;
  s3FileUri: Scalars['String'];
};

export type CustomerListInvalidEntry = {
  columnName: Scalars['String'];
  fieldType: CustomFieldType;
  rowNumber: Scalars['Int'];
  value: Scalars['String'];
};

export type CustomerListInvalidEntryInput = {
  columnName: Scalars['String'];
  fieldType: CustomFieldType;
  rowNumber: Scalars['Int'];
  value: Scalars['String'];
};

export type CustomerListInvalidImportData = {
  invalidEntries: Array<CustomerListInvalidEntry>;
};

export type CustomerListProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date'];
  delimiter?: Maybe<Scalars['String']>;
  lastError?: Maybe<Scalars['String']>;
  mapping: AudienceCustomerListColumnMappings;
  requestedCount: Scalars['Int'];
  s3FileUri: Scalars['String'];
};

export type DateFilter = {
  customField?: Maybe<Scalars['String']>;
  field?: Maybe<FilterDateField>;
  operator: DateOperators;
};

export type DateFilterInput = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterDateField>;
  operator: DateOperatorsInput;
};

export type DateIntervalInput = {
  unit: DateIntervalUnit;
  value: Scalars['Int'];
};

export enum DateIntervalUnit {
  Day = 'Day',
  Hour = 'Hour',
  /** Only single calendar units are supported (that is, 1 month) */
  Month = 'Month',
  /** Only single calendar units are supported (that is, 1 quarter) */
  Quarter = 'Quarter',
  /** Only single calendar units are supported (that is, 1 week) */
  Week = 'Week',
  /** Only single calendar units are supported (that is, 1 year) */
  Year = 'Year'
}

export type DateOperators = {
  between?: Maybe<DateRange>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['FilterDate']>;
  gte?: Maybe<Scalars['FilterDate']>;
  lt?: Maybe<Scalars['FilterDate']>;
  lte?: Maybe<Scalars['FilterDate']>;
};

export type DateOperatorsInput = {
  between?: InputMaybe<DateRangeInput>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['FilterDate']>;
  gte?: InputMaybe<Scalars['FilterDate']>;
  lt?: InputMaybe<Scalars['FilterDate']>;
  lte?: InputMaybe<Scalars['FilterDate']>;
};

export type DateRange = {
  from: Scalars['FilterDate'];
  to: Scalars['FilterDate'];
};

export type DateRangeInput = {
  from: Scalars['FilterDate'];
  to: Scalars['FilterDate'];
};

export enum DistanceUnit {
  Kilometers = 'Kilometers',
  Miles = 'Miles'
}

export type DomainConfiguration = {
  domain: Scalars['String'];
  emailSender: Scalars['String'];
  emailTemplateData: Scalars['JSON'];
};

export type EntitiesCount = {
  audiences: Scalars['Int'];
  organizations: Scalars['Int'];
  users: Scalars['Int'];
};

export type EntityLog = {
  actedByUserType?: Maybe<UserType>;
  actionType: ActionType;
  actor?: Maybe<User>;
  audience?: Maybe<Audience>;
  createdAt: Scalars['Date'];
  entityId: Scalars['ID'];
  entityType: EntityType;
  field?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  user?: Maybe<User>;
};

export enum EntityType {
  Audience = 'Audience',
  AudienceIntegration = 'AudienceIntegration',
  AudienceIntegrationTemplate = 'AudienceIntegrationTemplate',
  Invite = 'Invite',
  Organization = 'Organization',
  User = 'User',
  UserAudience = 'UserAudience',
  UserOrganization = 'UserOrganization'
}

export enum ExportType {
  DigitalActivations = 'DigitalActivations',
  Emails = 'Emails',
  Journeys = 'Journeys',
  Maids = 'Maids',
  People = 'People'
}

export type ExtendedStringFilter = {
  field: FilterExtendedStringField;
  negate?: Maybe<Scalars['Boolean']>;
  operator: ExtendedStringOperators;
};

export type ExtendedStringFilterInput = {
  field: FilterExtendedStringField;
  negate?: InputMaybe<Scalars['Boolean']>;
  operator: ExtendedStringOperatorsInput;
};

export type ExtendedStringOperators = {
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
  regex?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
};

export type ExtendedStringOperatorsInput = {
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type FacebookCustomAudienceAudienceIntegrationConfiguration = {
  accessToken?: Maybe<Scalars['String']>;
  adAccountId: Scalars['String'];
  customAudienceId: Scalars['String'];
  daysToKeep: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  historicalDataSync: Scalars['Boolean'];
  name: Scalars['String'];
};

export type FacebookCustomAudienceAudienceIntegrationConfigurationInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  adAccountId: Scalars['String'];
  daysToKeep: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type FieldAggregate = {
  first: HistoricalValue;
  last: HistoricalValue;
};

export enum FieldCategory {
  Business = 'Business',
  Geo = 'Geo',
  Person = 'Person'
}

export enum FieldType {
  Boolean = 'Boolean',
  Date = 'Date',
  Number = 'Number',
  String = 'String'
}

export enum FileFormat {
  Csv = 'Csv',
  JsonLines = 'JsonLines'
}

export enum FilterBooleanField {
  AmexCard = 'AmexCard',
  BankCard = 'BankCard',
  CreditCard = 'CreditCard',
  Multilingual = 'Multilingual',
  OwnsInvestment = 'OwnsInvestment',
  OwnsStocksAndBonds = 'OwnsStocksAndBonds',
  PoliticalContributor = 'PoliticalContributor',
  PremiumAmexCardOwner = 'PremiumAmexCardOwner',
  PremiumCard = 'PremiumCard',
  PrimaryResidence = 'PrimaryResidence',
  Voter = 'Voter'
}

export type FilterConfiguration = {
  fieldAudienceTypes?: Maybe<Array<AudienceCondition>>;
  numberFilterConfiguration?: Maybe<NumberFilterConfiguration>;
  stringFilterConfiguration?: Maybe<StringFilterConfiguration>;
};

export enum FilterDateField {
  AdditionDate = 'AdditionDate',
  PixelFirstHitDate = 'PixelFirstHitDate',
  PixelHitDate = 'PixelHitDate'
}

export enum FilterExtendedStringField {
  PixelHitUrl = 'PixelHitUrl'
}

/** All these fields are guaranteed to have a 1:1 match in any of the FilterXField enums. */
export enum FilterField {
  AdditionDate = 'AdditionDate',
  AdultsInHousehold = 'AdultsInHousehold',
  Age = 'Age',
  AmexCard = 'AmexCard',
  BankCard = 'BankCard',
  Bebacks = 'Bebacks',
  Behaviors = 'Behaviors',
  BusinessEmail = 'BusinessEmail',
  ChildrenAgeRanges = 'ChildrenAgeRanges',
  ChildrenInHousehold = 'ChildrenInHousehold',
  City = 'City',
  CompanyCity = 'CompanyCity',
  CompanyDomain = 'CompanyDomain',
  CompanyEmployeeCount = 'CompanyEmployeeCount',
  CompanyName = 'CompanyName',
  CompanyRevenue = 'CompanyRevenue',
  CompanySic = 'CompanySic',
  CompanyState = 'CompanyState',
  CreditCard = 'CreditCard',
  CreditRange = 'CreditRange',
  Department = 'Department',
  Dma = 'Dma',
  DwellingType = 'DwellingType',
  Education = 'Education',
  Email = 'Email',
  EthnicGroup = 'EthnicGroup',
  FirstName = 'FirstName',
  Gender = 'Gender',
  Generation = 'Generation',
  HomeHeatType = 'HomeHeatType',
  HomeOwner = 'HomeOwner',
  HomePrice = 'HomePrice',
  HomePurchasedYearsAgo = 'HomePurchasedYearsAgo',
  HomeValue = 'HomeValue',
  HostAndPath = 'HostAndPath',
  HouseholdIncome = 'HouseholdIncome',
  HouseholdNetWorth = 'HouseholdNetWorth',
  IncomeLevels = 'IncomeLevels',
  Interests = 'Interests',
  JobTitle = 'JobTitle',
  Language = 'Language',
  LastName = 'LastName',
  MaritalStatus = 'MaritalStatus',
  MortgageAge = 'MortgageAge',
  MortgageAmount = 'MortgageAmount',
  MortgageLoanType = 'MortgageLoanType',
  MortgageRefinanceAge = 'MortgageRefinanceAge',
  MortgageRefinanceAmount = 'MortgageRefinanceAmount',
  MortgageRefinanceType = 'MortgageRefinanceType',
  Multilingual = 'Multilingual',
  NetWorth = 'NetWorth',
  NewCreditOfferedHousehold = 'NewCreditOfferedHousehold',
  NumberOfVehiclesInHousehold = 'NumberOfVehiclesInHousehold',
  OccupationDetail = 'OccupationDetail',
  OwnsInvestment = 'OwnsInvestment',
  OwnsStocksAndBonds = 'OwnsStocksAndBonds',
  PathPrefix = 'PathPrefix',
  PeopleInHousehold = 'PeopleInHousehold',
  Personality = 'Personality',
  Phone = 'Phone',
  PixelFirstHitDate = 'PixelFirstHitDate',
  PixelHitDate = 'PixelHitDate',
  PixelHitUrl = 'PixelHitUrl',
  PixelLastHitDate = 'PixelLastHitDate',
  PoliticalContributor = 'PoliticalContributor',
  PoliticalParty = 'PoliticalParty',
  PostalCode = 'PostalCode',
  PremiumAmexCardOwner = 'PremiumAmexCardOwner',
  PremiumCard = 'PremiumCard',
  PremiumIncomeHousehold = 'PremiumIncomeHousehold',
  PrimaryIndustry = 'PrimaryIndustry',
  PrimaryResidence = 'PrimaryResidence',
  PulseTopic = 'PulseTopic',
  Religion = 'Religion',
  SeniorityLevel = 'SeniorityLevel',
  State = 'State',
  Urbanicity = 'Urbanicity',
  UtmCampaign = 'UtmCampaign',
  UtmMedium = 'UtmMedium',
  UtmSource = 'UtmSource',
  UtmSourceAndMedium = 'UtmSourceAndMedium',
  VeteransInHousehold = 'VeteransInHousehold',
  Voter = 'Voter'
}

export enum FilterNumberField {
  AdultsInHousehold = 'AdultsInHousehold',
  Age = 'Age',
  Bebacks = 'Bebacks',
  ChildrenInHousehold = 'ChildrenInHousehold',
  HomePrice = 'HomePrice',
  HomePurchasedYearsAgo = 'HomePurchasedYearsAgo',
  HomeValue = 'HomeValue',
  MortgageAge = 'MortgageAge',
  MortgageAmount = 'MortgageAmount',
  MortgageRefinanceAge = 'MortgageRefinanceAge',
  MortgageRefinanceAmount = 'MortgageRefinanceAmount',
  NumberOfVehiclesInHousehold = 'NumberOfVehiclesInHousehold',
  PeopleInHousehold = 'PeopleInHousehold',
  VeteransInHousehold = 'VeteransInHousehold'
}

export enum FilterStringField {
  Behaviors = 'Behaviors',
  BusinessEmail = 'BusinessEmail',
  ChildrenAgeRanges = 'ChildrenAgeRanges',
  City = 'City',
  CompanyCity = 'CompanyCity',
  CompanyDomain = 'CompanyDomain',
  CompanyEmployeeCount = 'CompanyEmployeeCount',
  CompanyName = 'CompanyName',
  CompanyRevenue = 'CompanyRevenue',
  CompanySic = 'CompanySic',
  CompanyState = 'CompanyState',
  CreditRange = 'CreditRange',
  Department = 'Department',
  Dma = 'Dma',
  DwellingType = 'DwellingType',
  Education = 'Education',
  Email = 'Email',
  EthnicGroup = 'EthnicGroup',
  FirstName = 'FirstName',
  Gender = 'Gender',
  Generation = 'Generation',
  HomeHeatType = 'HomeHeatType',
  HomeOwner = 'HomeOwner',
  HostAndPath = 'HostAndPath',
  HouseholdIncome = 'HouseholdIncome',
  HouseholdNetWorth = 'HouseholdNetWorth',
  IncomeLevels = 'IncomeLevels',
  Interests = 'Interests',
  JobTitle = 'JobTitle',
  Language = 'Language',
  LastName = 'LastName',
  MaritalStatus = 'MaritalStatus',
  MortgageLoanType = 'MortgageLoanType',
  MortgageRefinanceType = 'MortgageRefinanceType',
  NetWorth = 'NetWorth',
  NewCreditOfferedHousehold = 'NewCreditOfferedHousehold',
  OccupationDetail = 'OccupationDetail',
  PathPrefix = 'PathPrefix',
  Personality = 'Personality',
  Phone = 'Phone',
  PoliticalParty = 'PoliticalParty',
  PostalCode = 'PostalCode',
  PremiumIncomeHousehold = 'PremiumIncomeHousehold',
  PrimaryIndustry = 'PrimaryIndustry',
  PulseTopic = 'PulseTopic',
  Religion = 'Religion',
  SeniorityLevel = 'SeniorityLevel',
  State = 'State',
  Urbanicity = 'Urbanicity',
  UtmCampaign = 'UtmCampaign',
  UtmMedium = 'UtmMedium',
  UtmSource = 'UtmSource',
  UtmSourceAndMedium = 'UtmSourceAndMedium'
}

export type GeoDistanceOperator = {
  distance: Scalars['Int'];
  location: Coordinates;
  unit: DistanceUnit;
};

export type GeoDistanceOperatorInput = {
  distance: Scalars['Int'];
  location: CoordinatesInput;
  unit: DistanceUnit;
};

export type GeoFilter = {
  excludedZipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator: GeoOperators;
  place?: Maybe<GeoFilterPlace>;
};

export type GeoFilterInput = {
  excludedZipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator: GeoOperatorsInput;
  place?: InputMaybe<GeoFilterPlaceInput>;
};

export type GeoFilterPlace = {
  address: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};

export type GeoFilterPlaceInput = {
  address: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
};

export type GeoLocation = {
  city?: Maybe<Scalars['String']>;
  continentCode?: Maybe<Scalars['String']>;
  continentName?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Coordinates>;
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  regionType?: Maybe<Scalars['String']>;
};

export type GeoOperators = {
  distance?: Maybe<GeoDistanceOperator>;
  polygon?: Maybe<Array<Coordinates>>;
};

export type GeoOperatorsInput = {
  distance?: InputMaybe<GeoDistanceOperatorInput>;
  /**
   * This array needs to have a size between 4 and 100 pairs of point locations. The last point must match the
   * first one in order to indicate the user closed the polygon.
   */
  polygon?: InputMaybe<Array<CoordinatesInput>>;
};

export type GlobalAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date'];
  matchedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type GlobalProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date'];
  requestedCount: Scalars['Int'];
};

export type GoogleAccessTokenInput = {
  accountId: Scalars['String'];
  neededScopes: Array<Scalars['String']>;
};

export type GoogleAccessTokenResult = {
  accessToken: Scalars['String'];
  expiryDate: Scalars['Date'];
  scopes: Array<Scalars['String']>;
};

export type GoogleAuthorizeInput = {
  authorizationCode: Scalars['String'];
  neededScopes: Array<Scalars['String']>;
};

export type GoogleAuthorizeResponse = {
  accessToken: Scalars['String'];
  accountId: Scalars['ID'];
  expiryDate: Scalars['Date'];
  scopes: Array<Scalars['String']>;
};

export type GoogleCustomerMatchAudienceIntegrationConfiguration = {
  customerId: Scalars['String'];
  daysToKeep: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  googleUserAccountId?: Maybe<Scalars['String']>;
  historicalDataSync: Scalars['Boolean'];
  lastOperationId?: Maybe<Scalars['String']>;
  managerCustomerId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: GoogleCustomerMatchConnectionStatus;
  userId?: Maybe<Scalars['String']>;
  userListId: Scalars['String'];
};

export type GoogleCustomerMatchAudienceIntegrationConfigurationInput = {
  customerId?: InputMaybe<Scalars['String']>;
  daysToKeep?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  googleUserAccountId?: InputMaybe<Scalars['String']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']>;
  lastOperationId?: InputMaybe<Scalars['String']>;
  managerCustomerId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum GoogleCustomerMatchConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export type GoogleToken = {
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type GoogleTokenInput = {
  code?: InputMaybe<Scalars['String']>;
  grantType: GrantType;
  refreshToken?: InputMaybe<Scalars['String']>;
};

export enum GrantType {
  AuthorizationCode = 'AuthorizationCode',
  RefreshToken = 'RefreshToken'
}

export type HighLevelAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  privateIntegrationToken?: Maybe<Scalars['String']>;
};

export type HighLevelAudienceIntegrationConfigurationInput = {
  locationId?: InputMaybe<Scalars['String']>;
  privateIntegrationToken?: InputMaybe<Scalars['String']>;
};

export type HistoricalValue = {
  date: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Invite = {
  acceptedAt?: Maybe<Scalars['Date']>;
  assignedRole: Role;
  audience?: Maybe<Audience>;
  audienceId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  createdByUserId: Scalars['ID'];
  declinedAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  inviter?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  roleId: Scalars['ID'];
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
  user?: Maybe<User>;
};

export type InviteInput = {
  audienceId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  organizationId?: InputMaybe<Scalars['ID']>;
  /** Role id referencing the assignedRole with custom permissions assigned to the user in the organization. */
  roleId?: InputMaybe<Scalars['ID']>;
};

export type InvoiceAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type InvoiceCustomer = {
  chargifyId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
};

export type InvoicePayment = {
  appliedAmount?: Maybe<Scalars['String']>;
  gatewayHandle?: Maybe<Scalars['String']>;
  gatewayTransactionId?: Maybe<Scalars['ID']>;
  gatewayUsed?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  originalAmount?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  prepayment?: Maybe<Scalars['Boolean']>;
  transactionId?: Maybe<Scalars['ID']>;
  transactionTime?: Maybe<Scalars['String']>;
};

export type InvoicePaymentMethod = {
  cardBrand?: Maybe<Scalars['String']>;
  cardExpiration?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  maskedCardNumber?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type InvoiceSeller = {
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum JourneyFilterDateField {
  Date = 'Date'
}

/** All these fields are guaranteed to have a 1:1 match in any of the JourneyFilterXField enums. */
export enum JourneyFilterField {
  Date = 'Date'
}

export type JourneyFilterInput = {
  dateFilter?: InputMaybe<DateFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

export enum JourneyGroupByField {
  HostAndPath = 'HostAndPath'
}

export type JourneyGroupByInput = {
  field: JourneyGroupByField;
};

export type JourneyPath = {
  count: Scalars['Int'];
  pathPrefix: Scalars['String'];
};

export type JourneyPaths = {
  count: Scalars['Int'];
  paths: Array<JourneyPath>;
};

export type JourneySortFieldInput = {
  ascending: Scalars['Boolean'];
  field: JourneyFilterField;
};

export type KeyAggregate = {
  aggregate: FieldAggregate;
  key: Scalars['String'];
};

export type KeyValue = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type KnownAdditionalInfo = {
  vin?: Maybe<Scalars['String']>;
};

export type KnownAdditionalInfoAggregates = {
  vin?: Maybe<FieldAggregate>;
};

export type Location = {
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: Maybe<Coordinates>;
  country: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  coordinates?: InputMaybe<CoordinatesInput>;
  country: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export enum LogicalOperator {
  And = 'And',
  Or = 'Or'
}

export type Maid = {
  maid: Scalars['String'];
  os: MaidOs;
};

export enum MaidOs {
  Android = 'Android',
  Ios = 'IOS'
}

export type MailchimpAudience = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type MailchimpAudienceIntegrationConfiguration = {
  apiKey?: Maybe<Scalars['String']>;
  audienceId: Scalars['String'];
  bypassHiddenPeopleFields: Scalars['Boolean'];
  daysToKeep: Scalars['Int'];
  historicalDataSync: Scalars['Boolean'];
  tag?: Maybe<Scalars['String']>;
};

export type MailchimpAudienceIntegrationConfigurationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  audienceId?: InputMaybe<Scalars['String']>;
  daysToKeep?: InputMaybe<Scalars['Int']>;
  historicalDataSync?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type MailchimpListAudiencesInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  audienceIntegrationId?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']>;
  /** Accepts an invite with the passed id */
  acceptInvite?: Maybe<Invite>;
  /** Allows the user to upload IP data in bulk */
  addAudienceVisits: Scalars['Boolean'];
  /** Adds people to a Customer List audience */
  addPeopleAudienceCustomerList?: Maybe<Audience>;
  /** Adds people to a Global audience */
  addPeopleAudienceGlobal?: Maybe<Audience>;
  /** Confirms a pending audience */
  adminConfirmPendingAudiencePulse?: Maybe<Audience>;
  /** Updates the organization with *id* for Admin users or users with Super Owner role, using the passed params */
  adminUpdateOrganization?: Maybe<Organization>;
  /** Updates a Pixel audience's settings with admin permissions */
  adminUpdatePixelAudienceSettings?: Maybe<Audience>;
  /** Creates a Customer List audience */
  createAudienceCustomerList?: Maybe<Audience>;
  /** Creates a Global audience */
  createAudienceGlobal?: Maybe<Audience>;
  /** Creates an audience integration */
  createAudienceIntegration?: Maybe<AudienceIntegration>;
  /** Creates a Lookalike audience */
  createAudienceLookalike?: Maybe<Audience>;
  /** Creates a Pixel audience */
  createAudiencePixel?: Maybe<Audience>;
  /** Creates a Pulse audience */
  createAudiencePulse?: Maybe<Audience>;
  /** Creates a Segment audience */
  createAudienceSegment?: Maybe<Audience>;
  /** Creates an invite with the passed params and the authenticated user as the inviter */
  createInvite?: Maybe<Invite>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /**
   * Creates a subscription with the passed params and the authenticated user as the creator. In order to get the
   * created subscription information use the "subscriptionInfo" query.
   */
  createSubscription?: Maybe<Scalars['Boolean']>;
  /** Creates an user with with the information sent from global */
  createUser?: Maybe<User>;
  /** Declines an invite with the id */
  declineInvite?: Maybe<Invite>;
  /** Deletes an audience */
  deleteAudience?: Maybe<Scalars['Boolean']>;
  /** Deletes an audience integration */
  deleteAudienceIntegration?: Maybe<Scalars['Boolean']>;
  /** Deletes an invite with the id */
  deleteInvite?: Maybe<Invite>;
  /** Discards a failed Customer List audience load */
  discardFailedAudienceCustomerListLoad?: Maybe<Audience>;
  /**
   * Edits a Pixel audience
   * @deprecated Please use updateAudience to update the audience itself or updatePixelAudienceSettings to update audience's pixel settings.
   */
  editAudiencePixel?: Maybe<Audience>;
  /** Authorize with Google OAuth and store encrypted refresh token */
  googleAuthorize: GoogleAuthorizeResponse;
  /** Generate access token from stored refresh token for specific Google account and scopes */
  googleGenerateAccessToken: GoogleAccessTokenResult;
  /**
   * Returns one or more Google tokens for the provided parameters. For more info check
   * https://cloud.google.com/apigee/docs/api-platform/security/oauth/access-tokens
   * @deprecated Use googleAuthorize and googleGenerateAccessToken instead
   */
  googleToken?: Maybe<GoogleToken>;
  /** Removes user from the audience */
  removeAudienceMember?: Maybe<Scalars['Boolean']>;
  /** Removes the member with *userId* from the organization with *id* */
  removeMember?: Maybe<Scalars['Boolean']>;
  /** Resends an invite with the passed id */
  resendInvite?: Maybe<Invite>;
  /** Send an email to the support team with the given arguments. */
  sendSupportEmail?: Maybe<Scalars['Boolean']>;
  /**
   * Adds people to a pixel audience count. Returns the new total count of the audience.
   * Only available for internal use.
   */
  systemAddAudiencePeopleCount?: Maybe<Scalars['Int']>;
  systemAddOnCompleted: Scalars['Boolean'];
  /**
   * Iterates over Pulse audiences.
   * For each audience, it creates a count record related to the new date range and calls the worker to add people to it.
   */
  systemAddPeopleAudiencesPulse: PageInfo;
  /** Completes a Customer List audience */
  systemCompleteCustomerListAudience?: Maybe<Audience>;
  /** Completes a Global audience */
  systemCompleteGlobalAudience?: Maybe<Audience>;
  /** Completes a Lookalike audience */
  systemCompleteLookalikeAudience?: Maybe<Audience>;
  /** Completes a Pulse audience */
  systemCompletePulseAudience?: Maybe<Audience>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates an User with User Admin permissions */
  systemCreateUser?: Maybe<User>;
  /** Deletes an Organization with Org Admin permissions */
  systemDeleteOrganization?: Maybe<Scalars['Boolean']>;
  /**
   * Iterates over Audiences with quota enabled that end at the specified date.
   * Adds the pixels as active again.
   */
  systemResetAudiencesQuota: PageInfo;
  /** Restores a deleted Organization with Org Admin permissions */
  systemRestoreOrganization?: Maybe<Scalars['Boolean']>;
  systemUpdateAppConfiguration: Scalars['Boolean'];
  /** Update the categories for an audience. Only available for internal use. */
  systemUpdateAudienceCategories: Scalars['Boolean'];
  /** For internal use only, updates the last run info after an AudienceIntegration has executed */
  systemUpdateAudienceIntegrationLastRunInfo?: Maybe<AudienceIntegration>;
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates the pixel setup status of a Pixel audience */
  systemUpdatePixelSetupStatus: Scalars['Boolean'];
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  /** Tests an audience integration */
  testAudienceIntegration: AudienceIntegrationTestResult;
  /** Updates an audience */
  updateAudience?: Maybe<Audience>;
  /** Update the categories for an audience */
  updateAudienceCategories: Scalars['Boolean'];
  /** Updates an audience integration */
  updateAudienceIntegration?: Maybe<AudienceIntegration>;
  updateMe?: Maybe<User>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /** Updates a Pixel audience's settings */
  updatePixelAudienceSettings?: Maybe<Audience>;
  /** Updates the role of a user in an organization */
  updateUserRole: UserRole;
};


export type MutationAcceptInviteArgs = {
  id: Scalars['ID'];
};


export type MutationAddAudienceVisitsArgs = {
  audienceId: Scalars['ID'];
  visits: Array<VisitInput>;
};


export type MutationAddPeopleAudienceCustomerListArgs = {
  addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput;
};


export type MutationAddPeopleAudienceGlobalArgs = {
  addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput;
};


export type MutationAdminConfirmPendingAudiencePulseArgs = {
  confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input?: InputMaybe<AdminUpdateOrganizationInput>;
};


export type MutationAdminUpdatePixelAudienceSettingsArgs = {
  audiencePixelSettingsParams: AdminAudiencePixelSettingsUpdateInput;
};


export type MutationCreateAudienceCustomerListArgs = {
  audienceCustomerListParams: AudienceCustomerListInput;
};


export type MutationCreateAudienceGlobalArgs = {
  audienceGlobalParams: AudienceGlobalInput;
};


export type MutationCreateAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationInput;
};


export type MutationCreateAudienceLookalikeArgs = {
  audienceLookalikeParams: AudienceLookalikeInput;
};


export type MutationCreateAudiencePixelArgs = {
  audiencePixelParams: AudiencePixelInput;
};


export type MutationCreateAudiencePulseArgs = {
  audiencePulseParams: AudiencePulseInput;
};


export type MutationCreateAudienceSegmentArgs = {
  audienceSegmentParams: AudienceSegmentInput;
};


export type MutationCreateInviteArgs = {
  inviteParams?: InputMaybe<InviteInput>;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
};


export type MutationCreateSubscriptionArgs = {
  subscriptionParams: SubscriptionInput;
};


export type MutationCreateUserArgs = {
  user?: InputMaybe<CreateUserInput>;
};


export type MutationDeclineInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAudienceArgs = {
  audienceId: Scalars['ID'];
};


export type MutationDeleteAudienceIntegrationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDiscardFailedAudienceCustomerListLoadArgs = {
  id: Scalars['ID'];
};


export type MutationEditAudiencePixelArgs = {
  audiencePixelParams: AudiencePixelEditInput;
};


export type MutationGoogleAuthorizeArgs = {
  input: GoogleAuthorizeInput;
};


export type MutationGoogleGenerateAccessTokenArgs = {
  input: GoogleAccessTokenInput;
};


export type MutationGoogleTokenArgs = {
  input: GoogleTokenInput;
};


export type MutationRemoveAudienceMemberArgs = {
  audienceId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveMemberArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationResendInviteArgs = {
  id: Scalars['ID'];
};


export type MutationSendSupportEmailArgs = {
  message: Scalars['String'];
};


export type MutationSystemAddAudiencePeopleCountArgs = {
  peopleCount: Scalars['Int'];
  pixelId: Scalars['String'];
};


export type MutationSystemAddOnCompletedArgs = {
  addOnCompletedInput?: InputMaybe<AddOnCompletedInput>;
};


export type MutationSystemAddPeopleAudiencesPulseArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type MutationSystemCompleteCustomerListAudienceArgs = {
  completionParams: CompleteAudienceCustomerListInput;
};


export type MutationSystemCompleteGlobalAudienceArgs = {
  completionParams: CompleteAudienceGlobalInput;
};


export type MutationSystemCompleteLookalikeAudienceArgs = {
  completionParams: CompleteAudienceLookalikeInput;
};


export type MutationSystemCompletePulseAudienceArgs = {
  completionParams: CompleteAudiencePulseInput;
};


export type MutationSystemCreateOrganizationArgs = {
  input?: InputMaybe<SystemOrganizationInput>;
  userId: Scalars['ID'];
};


export type MutationSystemCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationSystemDeleteOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemResetAudiencesQuotaArgs = {
  after?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
};


export type MutationSystemRestoreOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateAppConfigurationArgs = {
  newConfigurationInput: AppConfigurationInput;
};


export type MutationSystemUpdateAudienceCategoriesArgs = {
  input: UpdateSystemAudienceCategoriesInput;
};


export type MutationSystemUpdateAudienceIntegrationLastRunInfoArgs = {
  lastRunInfo: AudienceIntegrationLastRunInfoInput;
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdatePixelSetupStatusArgs = {
  audienceId: Scalars['ID'];
  isValid: Scalars['Boolean'];
  url: Scalars['String'];
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationTestAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationTestInput;
};


export type MutationUpdateAudienceArgs = {
  audienceUpdateParams: AudienceUpdateInput;
};


export type MutationUpdateAudienceCategoriesArgs = {
  audienceId: Scalars['ID'];
  categoryCodes: Array<Scalars['Int']>;
};


export type MutationUpdateAudienceIntegrationArgs = {
  integrationParams: AudienceIntegrationUpdateInput;
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateOrganizationInput>;
};


export type MutationUpdatePixelAudienceSettingsArgs = {
  audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

export type NumberFilter = {
  customField?: Maybe<Scalars['String']>;
  field?: Maybe<FilterNumberField>;
  operator: NumberOperators;
};

export type NumberFilterConfiguration = {
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

export type NumberFilterInput = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterNumberField>;
  operator: NumberOperatorsInput;
};

export type NumberOperators = {
  between?: Maybe<NumberRange>;
  eq?: Maybe<Scalars['Float']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Maybe<Scalars['Float']>>>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
};

export type NumberOperatorsInput = {
  between?: InputMaybe<NumberRangeInput>;
  eq?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type NumberRange = {
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

export type NumberRangeInput = {
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type Os = {
  name?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type Organization = BaseOrganization & {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  adfProviderInfo?: Maybe<Scalars['String']>;
  audiencesCount?: Maybe<Scalars['Int']>;
  autoCustomerListCreationConfiguration?: Maybe<AutoCustomerListCreationConfiguration>;
  businessDataEnabled?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUserId?: Maybe<Scalars['ID']>;
  creator?: Maybe<User>;
  customerListEnabled?: Maybe<Scalars['Boolean']>;
  defaultUser?: Maybe<User>;
  disableEmailValidation?: Maybe<Scalars['Boolean']>;
  globalSearchEnabled?: Maybe<Scalars['Boolean']>;
  globalSearchLimit?: Maybe<Scalars['Int']>;
  hiddenPeopleFields: Array<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  internalInfo?: Maybe<Scalars['JSON']>;
  legalName?: Maybe<Scalars['String']>;
  lookalikeEnabled?: Maybe<Scalars['Boolean']>;
  lookalikeSearchLimit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationType: OrganizationType;
  /** @deprecated Please use paymentStatus instead of this field. */
  paidSubscription?: Maybe<Scalars['Boolean']>;
  parentOrganization?: Maybe<BaseOrganization>;
  paymentStatus?: Maybe<PaymentStatus>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  phone?: Maybe<Scalars['String']>;
  pixelDomain?: Maybe<Scalars['String']>;
  pixelMatchingCadence?: Maybe<PixelMatchingCadence>;
  pulseEnabled?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  subscriptionOverride?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  whiteLabelImageUrl?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type OrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationConnection = {
  edges: Array<OrganizationEdge>;
  nodes: Array<Organization>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationEdge = {
  cursor: Scalars['String'];
  node?: Maybe<Organization>;
};

export enum OrganizationType {
  Agency = 'Agency',
  Customer = 'Customer',
  WhiteLabel = 'WhiteLabel'
}

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageView = {
  additionalInfo?: Maybe<AdditionalInfo>;
  browser?: Maybe<Browser>;
  date: Scalars['Date'];
  gaSessionId?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  hostAndPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ip: Scalars['String'];
  ipLocation?: Maybe<GeoLocation>;
  os?: Maybe<Os>;
  person: Person;
  personId: Scalars['ID'];
  tealiumVisitorId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  userAgent?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type PageViewConnection = {
  nodes: Array<PageView>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum PaymentStatus {
  Free = 'Free',
  Paid = 'Paid',
  PaidPaused = 'PaidPaused'
}

export type PeopleSnaphostGeoResult = {
  count: Scalars['Int'];
  postalCodes: Array<Maybe<Scalars['String']>>;
};

export type PeopleSnapshot = {
  geoResults?: Maybe<Array<Maybe<PeopleSnaphostGeoResult>>>;
  people: Array<Maybe<Person>>;
  postalCodeCounts?: Maybe<Array<Maybe<PostalCodeCount>>>;
  totalCount: Scalars['Int'];
};

export type PeriodUsageInfo = {
  audienceIdCount: Scalars['Int'];
  currentPeriodUsageInCents: Scalars['Int'];
  resolveIdCount: Scalars['Int'];
};

export enum Permission {
  BypassActivationHiddenPeopleFields = 'BypassActivationHiddenPeopleFields',
  ConfirmPendingAudience = 'ConfirmPendingAudience',
  CreateAudience = 'CreateAudience',
  CreateAudienceIntegration = 'CreateAudienceIntegration',
  CreateAudienceSegment = 'CreateAudienceSegment',
  CreateInvite = 'CreateInvite',
  CreateOrganization = 'CreateOrganization',
  DeleteAudience = 'DeleteAudience',
  DeleteAudienceIntegration = 'DeleteAudienceIntegration',
  DeleteInvite = 'DeleteInvite',
  DeleteMember = 'DeleteMember',
  DeleteOrganization = 'DeleteOrganization',
  ExportData = 'ExportData',
  ReadAudience = 'ReadAudience',
  ReadAudienceIntegration = 'ReadAudienceIntegration',
  ReadInvite = 'ReadInvite',
  ReadInvoices = 'ReadInvoices',
  ReadOrganization = 'ReadOrganization',
  ReadPerson = 'ReadPerson',
  ReadSubscriptionInfo = 'ReadSubscriptionInfo',
  ResendInvite = 'ResendInvite',
  SuperOwner = 'SuperOwner',
  UpdateAudience = 'UpdateAudience',
  UpdateAudienceAdminSettings = 'UpdateAudienceAdminSettings',
  UpdateAudienceIntegration = 'UpdateAudienceIntegration',
  UpdateOrganization = 'UpdateOrganization',
  UpdateOrganizationAdminSettings = 'UpdateOrganizationAdminSettings',
  UpdateUserRole = 'UpdateUserRole'
}

export type Person = {
  addrAbrev?: Maybe<Scalars['String']>;
  addrPrimary?: Maybe<Scalars['String']>;
  addrSecy?: Maybe<Scalars['String']>;
  addrStreet?: Maybe<Scalars['String']>;
  addrSuffix?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  adultsInHousehold?: Maybe<Scalars['Int']>;
  age?: Maybe<Scalars['Int']>;
  bebacks?: Maybe<Scalars['Int']>;
  beeswaxIds?: Maybe<Array<Scalars['String']>>;
  behaviors?: Maybe<Array<Maybe<Scalars['String']>>>;
  businessEmail?: Maybe<Scalars['String']>;
  businessEmailLastSeen?: Maybe<Scalars['Date']>;
  businessEmailValidationStatus?: Maybe<Scalars['String']>;
  carrierRoute?: Maybe<Scalars['String']>;
  childrenAgeRanges?: Maybe<Array<Maybe<Scalars['String']>>>;
  childrenBetweenAges0_3?: Maybe<Scalars['Int']>;
  childrenBetweenAges4_6?: Maybe<Scalars['Int']>;
  childrenBetweenAges7_9?: Maybe<Scalars['Int']>;
  childrenBetweenAges10_12?: Maybe<Scalars['Int']>;
  childrenBetweenAges13_18?: Maybe<Scalars['Int']>;
  childrenInHousehold?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<Scalars['String']>;
  companyCity?: Maybe<Scalars['String']>;
  companyDomain?: Maybe<Scalars['String']>;
  companyEmployeeCount?: Maybe<Scalars['String']>;
  companyLastUpdated?: Maybe<Scalars['Date']>;
  companyLinkedInUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyPhone?: Maybe<Scalars['String']>;
  companyRevenue?: Maybe<Scalars['String']>;
  companySic?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyState?: Maybe<Scalars['String']>;
  companyZip?: Maybe<Scalars['String']>;
  congressionalDistrict?: Maybe<Scalars['Int']>;
  countyName?: Maybe<Scalars['String']>;
  creditRange?: Maybe<Scalars['String']>;
  customBooleanFields?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  customDateFields?: Maybe<Array<Maybe<Scalars['Date']>>>;
  customIntegerFields?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** @deprecated Use customIntegerFields instead */
  customNumberFields?: Maybe<Array<Maybe<Scalars['Int']>>>;
  customStringFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  department?: Maybe<Scalars['String']>;
  dma?: Maybe<Scalars['Int']>;
  dnc?: Maybe<Scalars['Boolean']>;
  dpbc?: Maybe<Scalars['Int']>;
  dpv?: Maybe<Scalars['Int']>;
  dwellingType?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  educationHistory?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailVerificationDate?: Maybe<Scalars['Date']>;
  ethnicGroup?: Maybe<Scalars['String']>;
  fipsCountyCode?: Maybe<Scalars['Int']>;
  fipsStateCode?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  generation?: Maybe<Scalars['String']>;
  hemMd5?: Maybe<Scalars['String']>;
  hemMd5Uppercase?: Maybe<Scalars['String']>;
  hemSha1?: Maybe<Scalars['String']>;
  hemSha1Uppercase?: Maybe<Scalars['String']>;
  hemSha256?: Maybe<Scalars['String']>;
  hemSha256Uppercase?: Maybe<Scalars['String']>;
  hemsMd5?: Maybe<Array<Scalars['String']>>;
  hemsMd5Uppercase?: Maybe<Array<Scalars['String']>>;
  hemsSha1?: Maybe<Array<Scalars['String']>>;
  hemsSha1Uppercase?: Maybe<Array<Scalars['String']>>;
  hemsSha256?: Maybe<Array<Scalars['String']>>;
  hemsSha256Uppercase?: Maybe<Array<Scalars['String']>>;
  homeHeatType?: Maybe<Scalars['String']>;
  homeOwner?: Maybe<Scalars['String']>;
  homePrice?: Maybe<Scalars['Int']>;
  homePurchasedYearsAgo?: Maybe<Scalars['Int']>;
  homeValue?: Maybe<Scalars['Int']>;
  householdIncome?: Maybe<Scalars['String']>;
  householdNetWorth?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  incomeLevels?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<Scalars['String']>>>;
  ipAddresses?: Maybe<Array<Scalars['String']>>;
  isMultilingual?: Maybe<Scalars['Boolean']>;
  isPoliticalContributor?: Maybe<Scalars['Boolean']>;
  isPrimaryResidence?: Maybe<Scalars['Boolean']>;
  isVoter?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  jobTitleLastUpdated?: Maybe<Scalars['Date']>;
  /** Gets a paginated journey of the person for the pixel audience with "audienceId". */
  journey?: Maybe<PageViewConnection>;
  /**
   * Gets paged counts of journeys for a person grouped by a field.
   * This query returns a null "totalCount" value. To get the value about that,
   * please use "Audience.personJourneyGroups".
   */
  journeyGroups?: Maybe<BucketConnection>;
  language?: Maybe<Scalars['String']>;
  lastBusinessUpdated?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  maid?: Maybe<Scalars['String']>;
  maidOs?: Maybe<MaidOs>;
  maids?: Maybe<Array<Maid>>;
  maritalStatus?: Maybe<Scalars['String']>;
  mortgageAge?: Maybe<Scalars['Int']>;
  mortgageAmount?: Maybe<Scalars['Int']>;
  mortgageLoanType?: Maybe<Scalars['String']>;
  mortgageRefinanceAge?: Maybe<Scalars['Int']>;
  mortgageRefinanceAmount?: Maybe<Scalars['Int']>;
  mortgageRefinanceType?: Maybe<Scalars['String']>;
  msa?: Maybe<Scalars['Int']>;
  netWorth?: Maybe<Scalars['String']>;
  newCreditOfferedHousehold?: Maybe<Scalars['String']>;
  numberOfVehiclesInHousehold?: Maybe<Scalars['Int']>;
  occupationDetail?: Maybe<Scalars['String']>;
  optIn?: Maybe<Scalars['Boolean']>;
  optInDate?: Maybe<Scalars['Date']>;
  optInIp?: Maybe<Scalars['String']>;
  optInUrl?: Maybe<Scalars['String']>;
  ownsAmexCard?: Maybe<Scalars['Boolean']>;
  ownsBankCard?: Maybe<Scalars['Boolean']>;
  ownsCreditCard?: Maybe<Scalars['Boolean']>;
  ownsInvestment?: Maybe<Scalars['Boolean']>;
  ownsPremiumAmexCard?: Maybe<Scalars['Boolean']>;
  ownsPremiumCard?: Maybe<Scalars['Boolean']>;
  ownsStocksAndBonds?: Maybe<Scalars['Boolean']>;
  peopleInHousehold?: Maybe<Scalars['Int']>;
  personality?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneUpdateDate?: Maybe<Scalars['Date']>;
  pixelAdditionalInfo?: Maybe<AdditionalInfoAggregates>;
  pixelFirstHitDate?: Maybe<Scalars['Date']>;
  pixelId?: Maybe<Scalars['String']>;
  pixelLastHitDate?: Maybe<Scalars['Date']>;
  pixelLastIpLocation?: Maybe<GeoLocation>;
  politicalParty?: Maybe<Scalars['String']>;
  premiumIncomeHousehold?: Maybe<Scalars['String']>;
  primaryIndustry?: Maybe<Scalars['String']>;
  professionalAddress?: Maybe<Scalars['String']>;
  professionalAddress2?: Maybe<Scalars['String']>;
  professionalCity?: Maybe<Scalars['String']>;
  professionalState?: Maybe<Scalars['String']>;
  professionalZip?: Maybe<Scalars['String']>;
  professionalZip4?: Maybe<Scalars['String']>;
  religion?: Maybe<Scalars['String']>;
  scf?: Maybe<Scalars['Int']>;
  seniorityLevel?: Maybe<Scalars['String']>;
  social?: Maybe<Social>;
  state?: Maybe<Scalars['String']>;
  urbanicity?: Maybe<Scalars['String']>;
  veteransInHousehold?: Maybe<Scalars['Int']>;
  workHistory?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  zip4?: Maybe<Scalars['String']>;
};


export type PersonCustomBooleanFieldsArgs = {
  fields: Array<Scalars['String']>;
};


export type PersonCustomDateFieldsArgs = {
  fields: Array<Scalars['String']>;
};


export type PersonCustomIntegerFieldsArgs = {
  fields: Array<Scalars['String']>;
};


export type PersonCustomNumberFieldsArgs = {
  fields: Array<Scalars['String']>;
};


export type PersonCustomStringFieldsArgs = {
  fields: Array<Scalars['String']>;
};


export type PersonJourneyArgs = {
  first: Scalars['Int'];
  sort?: InputMaybe<Array<JourneySortFieldInput>>;
};


export type PersonJourneyGroupsArgs = {
  first: Scalars['Int'];
  groupBy: JourneyGroupByInput;
};

export type PersonCompoundFilter = {
  filters: Array<PersonFilter>;
  operator: LogicalOperator;
};

export type PersonCompoundFilterInput = {
  filters: Array<PersonFilterInput>;
  operator: LogicalOperator;
};

export type PersonConnection = {
  /** A list of nodes. */
  nodes: Array<Person>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int'];
};

export type PersonField = {
  category: FieldCategory;
  configuration?: Maybe<FilterConfiguration>;
  filterField: FilterField;
  title: Scalars['String'];
  type: FieldType;
};

export type PersonFilter = {
  booleanFilter?: Maybe<BooleanFilter>;
  compoundFilter?: Maybe<PersonCompoundFilter>;
  dateFilter?: Maybe<DateFilter>;
  extendedStringFilter?: Maybe<ExtendedStringFilter>;
  geoFilter?: Maybe<GeoFilter>;
  numberFilter?: Maybe<NumberFilter>;
  stringFilter?: Maybe<StringFilter>;
};

export type PersonFilterInput = {
  booleanFilter?: InputMaybe<BooleanFilterInput>;
  compoundFilter?: InputMaybe<PersonCompoundFilterInput>;
  dateFilter?: InputMaybe<DateFilterInput>;
  extendedStringFilter?: InputMaybe<ExtendedStringFilterInput>;
  geoFilter?: InputMaybe<GeoFilterInput>;
  numberFilter?: InputMaybe<NumberFilterInput>;
  stringFilter?: InputMaybe<StringFilterInput>;
};

export type PixelMatchCounts = {
  highestTraffic?: Maybe<AudienceMatchCount>;
  lowestTraffic?: Maybe<AudienceMatchCount>;
  matchCount: Scalars['Int'];
};

export enum PixelMatchingCadence {
  FourHours = 'FourHours',
  TwentyFourHours = 'TwentyFourHours'
}

export type PixelSetupStatus = {
  checkDate?: Maybe<Scalars['Date']>;
  firstSuccessfulCheckDate?: Maybe<Scalars['Date']>;
  isValid?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type PixelStatusCount = {
  nearQuotaReached: Scalars['Int'];
  quotaReached: Scalars['Int'];
  withoutRecentMatches: Scalars['Int'];
};

export type PostalCodeCount = {
  count: Scalars['Int'];
  postalCode: Scalars['String'];
};

export type PreviousBalanceData = {
  capturedAt?: Maybe<Scalars['Date']>;
  invoices?: Maybe<Array<PreviousBalanceInvoice>>;
};

export type PreviousBalanceInvoice = {
  number?: Maybe<Scalars['String']>;
  outstandingAmount?: Maybe<Scalars['String']>;
  uid?: Maybe<Scalars['String']>;
};

export enum PricingScheme {
  PerUnit = 'PerUnit',
  Stairstep = 'Stairstep',
  Tiered = 'Tiered',
  Volume = 'Volume'
}

export type ProcessingResultInfo = CustomerListInvalidImportData;

export type ProductComponent = {
  allowFractionalQuantities?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Date']>;
  defaultPricePointId?: Maybe<Scalars['Int']>;
  defaultPricePointName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  downgradeCharge?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  hideDateRangeOnInvoice?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind?: Maybe<ComponentKind>;
  name?: Maybe<Scalars['String']>;
  pricePointCount?: Maybe<Scalars['Int']>;
  pricePointsUrl?: Maybe<Scalars['String']>;
  prices?: Maybe<Array<ProductComponentPrices>>;
  pricingScheme?: Maybe<PricingScheme>;
  productFamilyId: Scalars['ID'];
  productFamilyName?: Maybe<Scalars['String']>;
  recurring?: Maybe<Scalars['Boolean']>;
  taxCode?: Maybe<Scalars['String']>;
  taxable?: Maybe<Scalars['Boolean']>;
  unitName?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['String']>;
  upgradeCharge?: Maybe<Scalars['String']>;
  useSiteExchangeRate?: Maybe<Scalars['Boolean']>;
};

export type ProductComponentPrices = {
  componentId?: Maybe<Scalars['ID']>;
  endingQuantity?: Maybe<Scalars['Int']>;
  formattedUnitPrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  pricePointId?: Maybe<Scalars['Int']>;
  startingQuantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['String']>;
};

export enum ProductIntervalUnit {
  Day = 'Day',
  Month = 'Month'
}

export type PromptPersonFilterInput = {
  audienceDescription: Scalars['String'];
  audienceId?: InputMaybe<Scalars['ID']>;
  currentDateHint?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type PromptPersonFilterOutput = {
  filters: Array<PersonFilter>;
  sessionId?: Maybe<Scalars['String']>;
};

export type PulseAdditionsArrayInfo = BaseAdditionsArrayInfo & {
  date: Scalars['Date'];
  dateRange: DateRange;
  matchedCount: Scalars['Int'];
  requestedCount: Scalars['Int'];
  subscriptionAmount: Scalars['Int'];
  subscriptionCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type PulseItem = {
  category: Scalars['String'];
  id: Scalars['String'];
  subCategory?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type PulseNode = {
  id: Scalars['String'];
  name: Scalars['String'];
  paths: Array<Scalars['String']>;
  signalCount: Scalars['SafeInt'];
};

export type PulseNodeConnection = {
  nodes: Array<PulseNode>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PulseProcessingAdditionInfo = BaseProcessingAdditionInfo & {
  date: Scalars['Date'];
  dateRange: DateRange;
  requestedCount: Scalars['Int'];
  subscriptionAmount: Scalars['Int'];
  subscriptionCount: Scalars['Int'];
};

export type Query = {
  _?: Maybe<Scalars['Boolean']>;
  activitySummaryPage?: Maybe<ActivitySummaryConnection>;
  /** Gets paginated journeys for a pixel audience. Only available for admin users. */
  adminJourneys?: Maybe<PageViewConnection>;
  /** Scans full audience people. Only available for admin users. */
  adminPeople?: Maybe<PersonConnection>;
  /** Gets a paginated journey of a given person for a pixel audience. Only available for admin users. */
  adminPersonJourney?: Maybe<PageViewConnection>;
  appConfiguration: AppConfiguration;
  /** Gets an audience by id */
  audience?: Maybe<Audience>;
  audienceIntegration?: Maybe<AudienceIntegration>;
  /**
   * Using the average vector of a base audience (Pixel or Customer List),
   * get the number of people with a similarity greater or equal than X
   */
  audienceLookalikeCount: Scalars['Int'];
  /**
   * Gets a page of audiences given a pair of after/first or before/last values. Note than for the first page there's no
   * need to provide an after/before cursor.
   * Also, audiences can be filtered by:
   *   - organization
   *   - text
   *   - condition
   *   - filters
   *   - pixelStatus
   *   - creationDateRange
   */
  audiences: AudienceConnection;
  audiencesCount?: Maybe<AudiencesCount>;
  /**
   * Gets a page of audiences for the given arguments. NOTE: For a cursor-based pagination, use the audiences query instead.
   * Also, audiences can be filtered by:
   *   - organization
   *   - text
   *   - condition
   *   - filters
   *   - pixelStatus
   *   - creationDateRange
   */
  audiencesPage: AudienceConnection;
  /** Lists Beeswax segments. */
  beeswaxListSegments: BeeswaxListSegmentsResult;
  /** Get the configuration for a specific tenant based on the domain */
  configuration?: Maybe<Configuration>;
  /** Get the domain configurations for a list of domains */
  domainConfigurations: Array<Maybe<DomainConfiguration>>;
  entitiesCount?: Maybe<EntitiesCount>;
  getConversationMessages: ConversationConnection;
  integrations: Array<AudienceIntegrationMetadata>;
  /** Get invite information. */
  invite?: Maybe<Invite>;
  /** Get all the organization invoices */
  invoices?: Maybe<Array<SubscriptionInvoice>>;
  listOrganizationRoles: Array<RestrictedAccessRole>;
  /** Lists Mailchimp audiences. */
  mailchimpListAudiences: Array<MailchimpAudience>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /** Retrieves accessible organizations with an optional search query string, organization type or by an ancestor organization id. */
  organizationsPage: OrganizationConnection;
  /** Gets counts of people for the given field. Fields compatible with this query are "category-like" fields. */
  peopleCounts?: Maybe<Array<Maybe<BucketElement>>>;
  /**
   * Gets paged counts for values of the given field. Fields compatible with this query are "category-like" fields.
   * This query will always return "totalCount" with a value.
   */
  peopleFieldCounts: BucketConnection;
  peopleFields?: Maybe<Array<Maybe<PersonField>>>;
  /**
   * Gets counts of people for the provided number field. Counts are returned in buckets defined by the provided interval.
   * minCountPerBucket (0 by default): returns only buckets with at least minCountPerBucket documents.
   * bucketKeyFormat ("{from} - {to}" by default): format for the bucket key.
   */
  peopleNumberHistogram?: Maybe<Array<Maybe<BucketElement>>>;
  /** Returns the total count of people for a set of filters and an optional parent audience id */
  peopleSnapshot?: Maybe<PeopleSnapshot>;
  /** Gets the person by id for a specific audience. */
  person?: Maybe<Person>;
  pixelMatchCounts?: Maybe<PixelMatchCounts>;
  pixelMatchDateHistogram?: Maybe<Array<BucketElement>>;
  pixelStatusCount?: Maybe<PixelStatusCount>;
  /** Get all subscription products */
  products?: Maybe<Array<SubscriptionProduct>>;
  promptPersonFilter?: Maybe<PromptPersonFilterOutput>;
  /**
   * Gets the nodes of the pulse tree. Based on the parent paths, it returns the child nodes.
   * If parentPaths is empty, we load categories. If it has a single value, we load the category's sub-categories. If it has two values, we load the sub-category's topics.
   */
  pulseNodes: PulseNodeConnection;
  /** Gets the pulse node signal count. */
  pulseNodesSignalCount: Scalars['SafeInt'];
  /** Get the organization subscription */
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  /** Gets an audience by the pixel id */
  systemAudienceByPixel?: Maybe<Audience>;
  /** Gets an audience quota information by pixel id. Only available for internal use. */
  systemAudienceQuotaInfo?: Maybe<AudienceQuotaInfo>;
  /**
   * Gets audiences by ids. Returns null for non-existent IDs at the corresponding position.
   * Only available for internal use.
   */
  systemAudiences: Array<Maybe<Audience>>;
  /** Retrieves encrypted refresh token and scopes for a user's Google account (internal usage only) */
  systemGoogleAuth: SystemGoogleAuthResponse;
  /** Get invite information. Only available for internal use. */
  systemInvite?: Maybe<Invite>;
  /** Get organization information. Only available for internal use. */
  systemOrganization?: Maybe<Organization>;
  /** Returns the number of email of all new matches between the specified dates (inclusive). */
  systemPixelAudienceEmailsCount: Scalars['Int'];
  /** Get user information. Only available for internal use. */
  systemUser?: Maybe<User>;
  /** Get UserOrganization information. Only available for internal use. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /** List all the users in the system. Only available for internal use. */
  systemUsers?: Maybe<UserConnection>;
};


export type QueryActivitySummaryPageArgs = {
  activityLevel?: InputMaybe<ActivityLevel>;
  dateRange: DateOperatorsInput;
  organizationId?: InputMaybe<Scalars['ID']>;
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
};


export type QueryAdminJourneysArgs = {
  after?: InputMaybe<Scalars['String']>;
  audienceId: Scalars['ID'];
  filters?: InputMaybe<Array<JourneyFilterInput>>;
  first: Scalars['Int'];
  includeTotal?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAdminPeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  audienceId: Scalars['ID'];
  filters?: InputMaybe<Array<PersonFilterInput>>;
  first: Scalars['Int'];
  sort?: InputMaybe<Array<SortFieldInput>>;
};


export type QueryAdminPersonJourneyArgs = {
  after?: InputMaybe<Scalars['String']>;
  audienceId: Scalars['ID'];
  first: Scalars['Int'];
  personId: Scalars['ID'];
};


export type QueryAudienceArgs = {
  id: Scalars['ID'];
};


export type QueryAudienceIntegrationArgs = {
  id: Scalars['ID'];
};


export type QueryAudienceLookalikeCountArgs = {
  audienceLookalikeCountParams: AudienceLookalikeCountInput;
};


export type QueryAudiencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<AudienceCondition>;
  conditions?: InputMaybe<Array<AudienceCondition>>;
  creationDateRange?: InputMaybe<DateOperatorsInput>;
  filters?: InputMaybe<Array<AudienceFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryAudiencesCountArgs = {
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryAudiencesPageArgs = {
  condition?: InputMaybe<AudienceCondition>;
  conditions?: InputMaybe<Array<AudienceCondition>>;
  creationDateRange?: InputMaybe<DateOperatorsInput>;
  filters?: InputMaybe<Array<AudienceFilterInput>>;
  organizationId?: InputMaybe<Scalars['ID']>;
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryBeeswaxListSegmentsArgs = {
  input: BeeswaxListSegmentsInput;
};


export type QueryConfigurationArgs = {
  domain: Scalars['String'];
};


export type QueryDomainConfigurationsArgs = {
  domains: Array<Scalars['String']>;
};


export type QueryEntitiesCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  identifier: Scalars['String'];
  section: ConversationSection;
};


export type QueryInviteArgs = {
  id: Scalars['ID'];
};


export type QueryInvoicesArgs = {
  organizationId: Scalars['ID'];
};


export type QueryListOrganizationRolesArgs = {
  id: Scalars['ID'];
};


export type QueryMailchimpListAudiencesArgs = {
  input: MailchimpListAudiencesInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationsPageArgs = {
  ancestorOrganizationId?: InputMaybe<Scalars['ID']>;
  organizationType?: InputMaybe<OrganizationType>;
  pageItemsCount: Scalars['Int'];
  pageNumber: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QueryPeopleCountsArgs = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  parentAudienceId?: InputMaybe<Scalars['ID']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPeopleFieldCountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterStringField>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  first: Scalars['Int'];
  parentAudienceId?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPeopleNumberHistogramArgs = {
  bucketKeyFormat?: InputMaybe<Scalars['String']>;
  field: FilterNumberField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>>>;
  interval?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  minCountPerBucket?: InputMaybe<Scalars['Int']>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPeopleSnapshotArgs = {
  addingToGlobalAudienceId?: InputMaybe<Scalars['ID']>;
  filters: Array<InputMaybe<PersonFilterInput>>;
  parentAudienceId?: InputMaybe<Scalars['ID']>;
};


export type QueryPersonArgs = {
  audienceId: Scalars['ID'];
  personId: Scalars['ID'];
};


export type QueryPixelMatchCountsArgs = {
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryPixelMatchDateHistogramArgs = {
  interval: DateIntervalInput;
  max: Scalars['Date'];
  min: Scalars['Date'];
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryPixelStatusCountArgs = {
  organizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryPromptPersonFilterArgs = {
  promptPersonFilterParams: PromptPersonFilterInput;
};


export type QueryPulseNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  parentPaths?: InputMaybe<Array<Scalars['String']>>;
  searchQuery?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionInfoArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemAudienceByPixelArgs = {
  pixelClientId: Scalars['ID'];
};


export type QuerySystemAudienceQuotaInfoArgs = {
  pixelClientId: Scalars['String'];
};


export type QuerySystemAudiencesArgs = {
  systemAudiencesInput: SystemAudiencesInput;
};


export type QuerySystemGoogleAuthArgs = {
  input: SystemGoogleAuthInput;
};


export type QuerySystemInviteArgs = {
  id: Scalars['ID'];
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemPixelAudienceEmailsCountArgs = {
  audienceId: Scalars['ID'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type QuerySystemUserArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type RestrictedAccessAudience = BaseAudience & {
  baseAudience?: Maybe<BaseAudience>;
  categories?: Maybe<Array<AudienceCategory>>;
  condition?: Maybe<AudienceCondition>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  filters?: Maybe<Array<PersonFilter>>;
  id: Scalars['ID'];
  info?: Maybe<AudienceInfo>;
  name?: Maybe<Scalars['String']>;
  parentAudience?: Maybe<BaseAudience>;
};

export type RestrictedAccessOrganization = BaseOrganization & {
  businessDataEnabled?: Maybe<Scalars['Boolean']>;
  disableEmailValidation?: Maybe<Scalars['Boolean']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationType?: Maybe<OrganizationType>;
};


export type RestrictedAccessOrganizationDisableEmailValidationArgs = {
  retrieveFinalValue?: InputMaybe<Scalars['Boolean']>;
};

export type RestrictedAccessRole = BaseRole & {
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
};

export type RestrictedAccessUser = BaseUser & {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Role = BaseRole & {
  childOrgExtraPermissions?: Maybe<Array<Permission>>;
  createdAt: Scalars['Date'];
  hiddenPeopleFields?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization?: Maybe<RestrictedAccessOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
  permissions: Array<Permission>;
  updatedAt: Scalars['Date'];
};

export enum S3AudienceIntegrationBucketOwnership {
  Platform = 'Platform',
  /** Only for internal use, to be used on auto-created integrations for platform-owned buckets. */
  PlatformBucket = 'PlatformBucket',
  UserProvided = 'UserProvided'
}

export type S3AudienceIntegrationConfiguration = {
  accessKeyId?: Maybe<Scalars['String']>;
  addIdSuffix?: Maybe<Scalars['Boolean']>;
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']>;
  destinationKey?: Maybe<Scalars['String']>;
  destinationS3URI: Scalars['String'];
  exportType: ExportType;
  fileFormat: FileFormat;
  iamRoles?: Maybe<Array<Scalars['String']>>;
  ownership: S3AudienceIntegrationBucketOwnership;
  peopleColumns: Array<Scalars['String']>;
  region?: Maybe<AwsRegion>;
  secretAccessKey?: Maybe<Scalars['String']>;
};

export type S3AudienceIntegrationConfigurationInput = {
  /** These are only required for the "UserProvided" ownership type. */
  accessKeyId?: InputMaybe<Scalars['String']>;
  destinationKey?: InputMaybe<Scalars['String']>;
  destinationS3URI?: InputMaybe<Scalars['String']>;
  exportType?: InputMaybe<ExportType>;
  fileFormat?: InputMaybe<FileFormat>;
  /** This is only required for the "Platform" ownership type. */
  iamRoles?: InputMaybe<Array<Scalars['String']>>;
  ownership: S3AudienceIntegrationBucketOwnership;
  peopleColumns?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<AwsRegion>;
  secretAccessKey?: InputMaybe<Scalars['String']>;
};

export enum Scope {
  AudiencesAdmin = 'AudiencesAdmin',
  OrgsAdmin = 'OrgsAdmin',
  UserAdmin = 'UserAdmin'
}

export type Social = {
  facebook?: Maybe<Scalars['String']>;
  linkedIn?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
};

export type SortFieldInput = {
  ascending: Scalars['Boolean'];
  field: FilterField;
};

export type StringFilter = {
  customField?: Maybe<Scalars['String']>;
  field?: Maybe<FilterStringField>;
  negate?: Maybe<Scalars['Boolean']>;
  operator: StringOperators;
};

export type StringFilterConfiguration = {
  condition?: Maybe<LogicalOperator>;
  isExtendedStringFilter?: Maybe<Scalars['Boolean']>;
  onlyExistence?: Maybe<Scalars['Boolean']>;
};

export type StringFilterInput = {
  customField?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<FilterStringField>;
  negate?: InputMaybe<Scalars['Boolean']>;
  operator: StringOperatorsInput;
};

export type StringOperators = {
  eq?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  in?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StringOperatorsInput = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Subscription = {
  _?: Maybe<Scalars['Boolean']>;
};

export type SubscriptionCreditCard = {
  billingAddress?: Maybe<Scalars['String']>;
  billingAddress_2?: Maybe<Scalars['String']>;
  billingCity?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  currentVault?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['ID']>;
  customerVaultToken?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  expirationMonth?: Maybe<Scalars['Int']>;
  expirationYear?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  gatewayHandle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  maskedCardNumber?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  siteGatewaySettingId?: Maybe<Scalars['ID']>;
  vaultToken?: Maybe<Scalars['String']>;
};

export type SubscriptionCustomer = {
  address?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  ccEmails?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  phone?: Maybe<Scalars['String']>;
  portalCustomerCreatedAt?: Maybe<Scalars['Date']>;
  portalInviteLastAcceptedAt?: Maybe<Scalars['Date']>;
  portalInviteLastSentAt?: Maybe<Scalars['Date']>;
  reference?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
  taxExempt?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  vatNumber?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
  zip?: Maybe<Scalars['String']>;
};

export type SubscriptionGroup = {
  primary?: Maybe<Scalars['String']>;
  primarySubscriptionId?: Maybe<Scalars['ID']>;
  scheme?: Maybe<Scalars['String']>;
  uid: Scalars['ID'];
};

export type SubscriptionInfo = {
  activatedAt?: Maybe<Scalars['Date']>;
  automaticallyResumeAt?: Maybe<Scalars['Date']>;
  balanceInCents?: Maybe<Scalars['Int']>;
  cancelAtEndOfPeriod?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['Date']>;
  cancellationMessage?: Maybe<Scalars['String']>;
  cancellationMethod?: Maybe<Scalars['String']>;
  couponCode?: Maybe<Scalars['String']>;
  couponCodes?: Maybe<Array<Scalars['String']>>;
  couponUseCount?: Maybe<Scalars['Int']>;
  couponUsesAllowed?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Date']>;
  creditBalanceInCents?: Maybe<Scalars['Int']>;
  creditCard?: Maybe<SubscriptionCreditCard>;
  currency?: Maybe<Scalars['String']>;
  currentPeriodEndsAt?: Maybe<Scalars['Date']>;
  currentPeriodStartedAt?: Maybe<Scalars['Date']>;
  currentPeriodUsageInfo: PeriodUsageInfo;
  customer?: Maybe<SubscriptionCustomer>;
  delayedCancelAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  group?: Maybe<SubscriptionGroup>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  netTerms?: Maybe<Scalars['Int']>;
  nextAssessmentAt?: Maybe<Scalars['Date']>;
  nextProductHandle?: Maybe<Scalars['String']>;
  nextProductId?: Maybe<Scalars['ID']>;
  nextProductPricePointId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
  onHoldAt?: Maybe<Scalars['Date']>;
  payerId?: Maybe<Scalars['ID']>;
  paymentCollectionMethod?: Maybe<Scalars['String']>;
  paymentType?: Maybe<Scalars['String']>;
  prepaymentBalanceInCents?: Maybe<Scalars['Int']>;
  previousState?: Maybe<SubscriptionState>;
  product?: Maybe<SubscriptionProduct>;
  productPriceInCents?: Maybe<Scalars['Int']>;
  productPricePointId?: Maybe<Scalars['ID']>;
  productPricePointType?: Maybe<Scalars['String']>;
  productVersionNumber?: Maybe<Scalars['Int']>;
  reasonCode?: Maybe<Scalars['String']>;
  receivesInvoiceEmails?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  scheduledCancellationAt?: Maybe<Scalars['Date']>;
  signupPaymentId?: Maybe<Scalars['ID']>;
  signupRevenue?: Maybe<Scalars['String']>;
  snapDay?: Maybe<Scalars['String']>;
  state?: Maybe<SubscriptionState>;
  storedCredentialTransactionId?: Maybe<Scalars['ID']>;
  totalRevenueInCents?: Maybe<Scalars['Int']>;
  trialEndedAt?: Maybe<Scalars['Date']>;
  trialStartedAt?: Maybe<Scalars['Date']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SubscriptionInput = {
  externalSubscriptionId: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type SubscriptionInvoice = {
  billingAddress?: Maybe<InvoiceAddress>;
  collectionMethod?: Maybe<Scalars['String']>;
  consolidationLevel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  creditAmount?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer?: Maybe<InvoiceCustomer>;
  customerId: Scalars['ID'];
  discountAmount?: Maybe<Scalars['String']>;
  dueAmount?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  groupPrimarySubscriptionId?: Maybe<Scalars['ID']>;
  issueDate?: Maybe<Scalars['Date']>;
  memo?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['String']>;
  paidDate?: Maybe<Scalars['Date']>;
  parentInvoiceNumber?: Maybe<Scalars['Int']>;
  parentInvoiceUid?: Maybe<Scalars['String']>;
  paymentInstructions?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<InvoicePayment>>>;
  previousBalanceData?: Maybe<PreviousBalanceData>;
  productFamilyName?: Maybe<Scalars['String']>;
  productInterval?: Maybe<Scalars['Int']>;
  productIntervalUnit?: Maybe<ProductIntervalUnit>;
  productName?: Maybe<Scalars['String']>;
  publicUrl?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  seller?: Maybe<InvoiceSeller>;
  sequenceNumber?: Maybe<Scalars['Int']>;
  shippingAddress?: Maybe<InvoiceAddress>;
  siteId: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['ID'];
  subtotalAmount?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['String']>;
  uid: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SubscriptionProduct = {
  accountingCode?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['Date']>;
  budgetPerPeriod?: Maybe<Scalars['Int']>;
  components?: Maybe<Array<Maybe<ProductComponent>>>;
  createdAt?: Maybe<Scalars['Date']>;
  defaultProductPricePointId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  expirationInterval?: Maybe<Scalars['Int']>;
  expirationIntervalUnit?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  initialChargeAfterTrial?: Maybe<Scalars['Boolean']>;
  initialChargeInCents?: Maybe<Scalars['Int']>;
  interval?: Maybe<Scalars['Int']>;
  intervalUnit?: Maybe<ProductIntervalUnit>;
  name?: Maybe<Scalars['String']>;
  priceInCents?: Maybe<Scalars['Int']>;
  productFamily?: Maybe<SubscriptionProductFamily>;
  productPricePointHandle?: Maybe<Scalars['String']>;
  productPricePointId?: Maybe<Scalars['ID']>;
  productPricePointName?: Maybe<Scalars['String']>;
  publicSignupPages?: Maybe<Array<SubscriptionPublicSignupPage>>;
  requestBillingAddress?: Maybe<Scalars['Boolean']>;
  requestCreditCard?: Maybe<Scalars['Boolean']>;
  requireBillingAddress?: Maybe<Scalars['Boolean']>;
  requireCreditCard?: Maybe<Scalars['Boolean']>;
  requireShippingAddress?: Maybe<Scalars['Boolean']>;
  returnParams?: Maybe<Scalars['String']>;
  taxCode?: Maybe<Scalars['String']>;
  taxable?: Maybe<Scalars['Boolean']>;
  trialInterval?: Maybe<Scalars['Int']>;
  trialIntervalUnit?: Maybe<Scalars['String']>;
  trialPriceInCents?: Maybe<Scalars['Int']>;
  updateReturnParams?: Maybe<Scalars['String']>;
  updateReturnUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  useSiteExchangeRate?: Maybe<Scalars['Boolean']>;
  versionNumber?: Maybe<Scalars['Int']>;
};

export type SubscriptionProductFamily = {
  accountingCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SubscriptionPublicSignupPage = {
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
  returnParams?: Maybe<Scalars['String']>;
  returnUrl?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum SubscriptionState {
  Active = 'Active',
  Assessing = 'Assessing',
  AwaitingSignup = 'AwaitingSignup',
  Canceled = 'Canceled',
  Expired = 'Expired',
  FailedToCreate = 'FailedToCreate',
  OnHold = 'OnHold',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Pending = 'Pending',
  SoftFailure = 'SoftFailure',
  Suspended = 'Suspended',
  TrialEnded = 'TrialEnded',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export type SystemAudienceQueryInfoOptions = {
  additionId?: InputMaybe<Scalars['ID']>;
  getAdditionsFromDaysAgo?: InputMaybe<Scalars['Int']>;
};

export type SystemAudiencesInput = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  pixelIds?: InputMaybe<Array<Scalars['String']>>;
};

export type SystemGoogleAuthInput = {
  googleAccountId: Scalars['String'];
  userId: Scalars['ID'];
};

export type SystemGoogleAuthResponse = {
  refreshToken: Scalars['String'];
  scopes: Array<Scalars['String']>;
};

export type SystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentOrganizationId: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  pixelDomain?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type TealiumAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields: Scalars['Boolean'];
  checkIfExistingCustomer: Scalars['Boolean'];
  customEntries: Scalars['JSON'];
  emailAttributeName?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  events: TealiumEventsConfiguration;
  parameterNames: TealiumParameterNames;
  redshiftDatabase?: Maybe<Scalars['String']>;
  redshiftHost?: Maybe<Scalars['String']>;
  redshiftPassword?: Maybe<Scalars['String']>;
  redshiftPort?: Maybe<Scalars['Int']>;
  redshiftUser?: Maybe<Scalars['String']>;
};

export type TealiumAudienceIntegrationConfigurationInput = {
  checkIfExistingCustomer?: InputMaybe<Scalars['Boolean']>;
  customEntries: Scalars['JSON'];
  emailAttributeName?: InputMaybe<Scalars['String']>;
  endpoint: Scalars['String'];
  events?: InputMaybe<TealiumEventsConfigurationInput>;
  parameterNames: TealiumParameterNamesInput;
  redshiftDatabase?: InputMaybe<Scalars['String']>;
  redshiftHost?: InputMaybe<Scalars['String']>;
  redshiftPassword?: InputMaybe<Scalars['String']>;
  redshiftPort?: InputMaybe<Scalars['Int']>;
  redshiftUser?: InputMaybe<Scalars['String']>;
};

export type TealiumEventsConfiguration = {
  existingCustomer?: Maybe<Scalars['String']>;
  nonExistingCustomer?: Maybe<Scalars['String']>;
  static?: Maybe<Scalars['String']>;
};

export type TealiumEventsConfigurationInput = {
  existingCustomer?: InputMaybe<Scalars['String']>;
  nonExistingCustomer?: InputMaybe<Scalars['String']>;
  static?: InputMaybe<Scalars['String']>;
};

export type TealiumParameterNames = {
  email: Scalars['String'];
  hashedEmail: Scalars['String'];
  hashedPhone: Scalars['String'];
  phone: Scalars['String'];
};

export type TealiumParameterNamesInput = {
  email: Scalars['String'];
  hashedEmail: Scalars['String'];
  hashedPhone: Scalars['String'];
  phone: Scalars['String'];
};

export enum UtmGroup {
  Campaign = 'Campaign',
  Medium = 'Medium',
  Source = 'Source',
  SourceAndMedium = 'SourceAndMedium'
}

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  adfProviderInfo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pixelDomain?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemAudienceCategoriesInput = {
  audienceId: Scalars['ID'];
  categories: Array<AudienceCategoryInput>;
  deleteMissing?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  adfProviderInfo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  pixelDomain?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  scopes?: InputMaybe<Array<Scope>>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateUserRoleInput = {
  organizationId: Scalars['ID'];
  roleId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type User = BaseUser & {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  invites?: Maybe<Array<Invite>>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Organization>>;
  phone?: Maybe<Scalars['String']>;
  scopes?: Maybe<Array<Scope>>;
  userRoles?: Maybe<Array<UserRole>>;
  whiteLabelImageUrl?: Maybe<Scalars['String']>;
};

export type UserConnection = {
  edges: Array<UserEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['String'];
  node: User;
};

export type UserOrganization = {
  assignedRole: Role;
  id: Scalars['ID'];
  invite?: Maybe<Invite>;
  organization?: Maybe<Organization>;
  user?: Maybe<User>;
};

export type UserRole = {
  assignedRole: Role;
  createdAt?: Maybe<Scalars['String']>;
  hiddenPeopleFields?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export enum UserType {
  Admin = 'Admin',
  Internal = 'Internal',
  Salesforce = 'Salesforce',
  Standard = 'Standard',
  Unauthenticated = 'Unauthenticated'
}

export type VisitInput = {
  additionalParams?: InputMaybe<Scalars['JSON']>;
  ip: Scalars['String'];
  timestamp?: InputMaybe<Scalars['Date']>;
  url?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};

export type ZapierAudienceIntegrationConfiguration = {
  bypassHiddenPeopleFields?: Maybe<Scalars['Boolean']>;
  connectionTimestamp?: Maybe<Scalars['Date']>;
  historicalDataSync: Scalars['Boolean'];
  hookURL?: Maybe<Scalars['String']>;
  status: ZapierConnectionStatus;
  zapID?: Maybe<Scalars['ID']>;
};

export type ZapierAudienceIntegrationConfigurationInput = {
  historicalDataSync?: InputMaybe<Scalars['Boolean']>;
  hookURL?: InputMaybe<Scalars['String']>;
  zapID?: InputMaybe<Scalars['ID']>;
};

export enum ZapierConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected'
}

export type CreateAudienceCustomerListMutationVariables = Exact<{
  audienceCustomerListParams: AudienceCustomerListInput;
}>;


export type CreateAudienceCustomerListMutation = { createAudienceCustomerList?: { id: string, name: string } | null };

export type ActivitySummaryPageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  dateRange: DateOperatorsInput;
  organizationId?: InputMaybe<Scalars['ID']>;
  activityLevel?: InputMaybe<ActivityLevel>;
}>;


export type ActivitySummaryPageQuery = { activitySummaryPage?: { totalCount: number, nodes: Array<{ actedByUserType?: UserType | null, actionType: ActionType, createdAt: any, entityId: string, entityType: EntityType, field?: string | null, newValue?: string | null, oldValue?: string | null, actor?: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | null, audience?: { id: string, name: string } | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null, user?: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | null }> } | null };

export type AddPeopleAudienceCustomerListMutationVariables = Exact<{
  addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput;
}>;


export type AddPeopleAudienceCustomerListMutation = { addPeopleAudienceCustomerList?: { id: string, name: string } | null };

export type AddAudienceVisitsMutationVariables = Exact<{
  addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput;
}>;


export type AddAudienceVisitsMutation = { addPeopleAudienceGlobal?: { id: string } | null };

export type AppConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type AppConfigurationQuery = { appConfiguration: { pulseSubscriptionAmount: number, pulseDateRange: { from: any, to: any } } };

export type AttributionSourceCountsQueryQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  utmGroup: UtmGroup;
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
  count?: InputMaybe<Scalars['Int']>;
}>;


export type AttributionSourceCountsQueryQuery = { audience?: { attributionSourceCounts: { attributions: Array<{ count: number, source: string }> } } | null };

export type AudienceIntegrationQueryVariables = Exact<{
  audienceIntegrationId: Scalars['ID'];
}>;


export type AudienceIntegrationQuery = { audienceIntegration?: { id: string, integrationType: AudienceIntegrationType, name: string, lastSuccessfulRunAt?: any | null, lastRunSucceeded?: boolean | null, lastRunAt?: any | null, configuration: { emails: Array<string> } | { buzzKey: string, email: string, segmentKey: string, hemSalt?: string | null } | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId: string, historicalDataSync: boolean, daysToKeep: number } | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId: string, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus } | { privateIntegrationToken?: string | null, locationId: string } | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean } | { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3URI: string, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> } | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } } | { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus }, creator?: { firstName?: string | null, lastName?: string | null } | null } | null };

export type AdfAudienceIntegrationConfigurationFragment = { emails: Array<string> };

export type S3AudienceIntegrationConfigurationFragment = { secretAccessKey?: string | null, region?: AwsRegion | null, ownership: S3AudienceIntegrationBucketOwnership, iamRoles?: Array<string> | null, destinationS3URI: string, accessKeyId?: string | null, exportType: ExportType, fileFormat: FileFormat, peopleColumns: Array<string> };

export type ZapierAudienceIntegrationConfigurationFragment = { connectionTimestamp?: any | null, historicalDataSync: boolean, status: ZapierConnectionStatus };

export type FacebookAudienceIntegrationConfigurationFragment = { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId: string, historicalDataSync: boolean, daysToKeep: number };

export type GoogleAdsAudienceIntegrationConfigurationFragment = { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId: string, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, googleUserAccountId?: string | null, googleAdsStatus: GoogleCustomerMatchConnectionStatus };

export type HighLevelIntegrationConfigurationFragment = { privateIntegrationToken?: string | null, locationId: string };

export type TealiumIntegrationConfigurationFragment = { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } };

export type MailchimpAudienceIntegrationConfigurationFragment = { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean };

export type BeeswaxAudienceIntegrationConfigurationFragment = { buzzKey: string, email: string, segmentKey: string, hemSalt?: string | null };

export type TestAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationTestInput;
}>;


export type TestAudienceIntegrationMutation = { testAudienceIntegration: { success: boolean, message?: string | null } };

export type AudienceIntegrationsQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
}>;


export type AudienceIntegrationsQuery = { audience?: { integrationsPage: { totalCount: number, nodes: Array<{ id: string, name: string, integrationType: AudienceIntegrationType, lastSuccessfulRunAt?: any | null, lastRunSucceeded?: boolean | null, lastRunAt?: any | null }> } } | null };

export type InvitesAudienceQueryVariables = Exact<{
  audienceId: Scalars['ID'];
}>;


export type InvitesAudienceQuery = { audience?: { id: string, pendingInvites?: Array<{ id: string, email: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null }> | null } | null };

export type JourneyTopPathsQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  count: Scalars['Int'];
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
}>;


export type JourneyTopPathsQuery = { audience?: { journeyTopPaths: { count: number, paths: Array<{ count: number, pathPrefix: string }> } } | null };

export type AudienceJourneyTopUrlsQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  count: Scalars['Int'];
  filters?: InputMaybe<Array<PersonFilterInput> | PersonFilterInput>;
}>;


export type AudienceJourneyTopUrlsQuery = { audience?: { journeyTopUrls: Array<string> } | null };

export type AudienceLookalikeCountQueryVariables = Exact<{
  audienceLookalikeCountParams: AudienceLookalikeCountInput;
}>;


export type AudienceLookalikeCountQuery = { audienceLookalikeCount: number };

export type BasicFilterFieldsFragment = { stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null };

type FilterFields_Audience_Fragment = { filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null };

type FilterFields_RestrictedAccessAudience_Fragment = { filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null };

export type FilterFieldsFragment = FilterFields_Audience_Fragment | FilterFields_RestrictedAccessAudience_Fragment;

type Categories_Audience_Fragment = { categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, info?: { categoriesProcessed: boolean } | {} | null };

type Categories_RestrictedAccessAudience_Fragment = { categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, info?: { categoriesProcessed: boolean } | {} | null };

export type CategoriesFragment = Categories_Audience_Fragment | Categories_RestrictedAccessAudience_Fragment;

export type LookalikeInfoFieldsFragment = { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null };

type AdditionsFields_CustomerListAdditionsArrayInfo_Fragment = { matchedCount: number, date: any };

type AdditionsFields_GlobalAdditionsArrayInfo_Fragment = { matchedCount: number, date: any };

type AdditionsFields_PulseAdditionsArrayInfo_Fragment = { matchedCount: number, date: any };

export type AdditionsFieldsFragment = AdditionsFields_CustomerListAdditionsArrayInfo_Fragment | AdditionsFields_GlobalAdditionsArrayInfo_Fragment | AdditionsFields_PulseAdditionsArrayInfo_Fragment;

export type GlobalInfoFieldsFragment = { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any }> | null };

export type PulseInfoFieldsFragment = { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any }> | null };

export type CustomerListColumnMappingsFieldsFragment = { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null };

export type CustomerListInfoFieldsFragment = { additions?: Array<{ matchedCount: number, date: any, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null };

export type AudienceOverviewQueryVariables = Exact<{
  audienceId: Scalars['ID'];
}>;


export type AudienceOverviewQuery = { audience?: { id: string, name: string, condition: AudienceCondition, createdAt: any, peopleCount?: number | null, processingStatus?: AudienceProcessingStatus | null, verifyEmails?: boolean | null, audienceOnlyAccess: boolean, segmentsCount: number, lookalikesCount: number, quotaInfo?: { currentCount?: number | null, limit?: number | null, period?: AudienceQuotaPeriod | null } | null, baseAudience?: { id: string, name: string, condition: AudienceCondition, parentAudience?: { id: string, name: string, condition: AudienceCondition, createdAt: any } | { id: string, name?: string | null, condition?: AudienceCondition | null, createdAt?: any | null } | null } | { id: string, name?: string | null, condition?: AudienceCondition | null, parentAudience?: { id: string, name: string, condition: AudienceCondition, createdAt: any } | { id: string, name?: string | null, condition?: AudienceCondition | null, createdAt?: any | null } | null } | null, userRoles?: Array<{ id: string, user: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } }> | null, organization: { __typename: 'Organization', imageUrl?: string | null, paidSubscription?: boolean | null, name?: string | null, id: string, hiddenPeopleFields: Array<string>, businessDataEnabled?: boolean | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?: { imageUrl?: string | null, id: string, name?: string | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?: { imageUrl?: string | null, id: string, name?: string | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null } | { id: string, name?: string | null } | null } | { id: string, name?: string | null } | null } | { __typename: 'RestrictedAccessOrganization', name?: string | null, id: string, imageUrl?: string | null, hiddenPeopleFields?: Array<string> | null, businessDataEnabled?: boolean | null, organizationType?: OrganizationType | null }, pixelSettings?: { pixelId: string, hostAndPath: string, pixelDisabledAt?: any | null, pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, pixelReachedQuotaAt?: any | null, quotaEnabled: boolean, pixelMatchingCadence: PixelMatchingCadence, quota: { limit?: number | null, period?: AudienceQuotaPeriod | null }, location?: { address?: string | null, city: string, state: string } | null, codeSnippets?: { head: string, body: string } | null, billing: { dayOfMonth: number } } | null, parentAudience?: { peopleCount?: number | null, id: string, name: string, createdAt: any, condition: AudienceCondition, pixelSettings?: { pixelMatchingCadence: PixelMatchingCadence } | null, info?: { additions?: Array<{ matchedCount: number, date: any, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null } | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any }> | null } | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null } | { categoriesProcessed: boolean } | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any }> | null } | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null } | { id: string, name?: string | null, createdAt?: any | null, condition?: AudienceCondition | null, info?: { additions?: Array<{ matchedCount: number, date: any, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null } | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any }> | null } | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null } | { categoriesProcessed: boolean } | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any }> | null } | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null } | null, segments: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }, organization: { id: string, name?: string | null } | { id: string, name?: string | null } }>, info?: { additions?: Array<{ matchedCount: number, date: any, mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } }> | null, processingAdditionInfo?: { mapping: { email?: number | null, emailField?: string | null, emailMd5?: number | null, emailMd5Field?: string | null, phone?: number | null, phoneField?: string | null, customFields?: Array<{ column: number, field: string, fieldType: CustomFieldType, originalField?: string | null }> | null } } | null } | { lastSuccessfullyProcessedAt?: any | null, additions?: Array<{ matchedCount: number, date: any }> | null } | { requestedCount: number, matchedCount?: number | null, similarityPercentage: number, dateRange?: { from: any, to: any } | null } | { categoriesProcessed: boolean } | { lastSuccessfullyProcessedAt?: any | null, subscriptionCount: number, subscriptionAmount: number, topicIds: Array<string>, lastProcessedDateRange?: { from: any, to: any } | null, items: Array<{ category: string, id: string, subCategory?: string | null, topic?: string | null }>, additions?: Array<{ matchedCount: number, date: any }> | null } | null, customFields: Array<{ name: string, fieldType: CustomFieldType }>, processingResultInfo?: { invalidEntries: Array<{ value: string, fieldType: CustomFieldType, columnName: string, rowNumber: number }> } | null, filters?: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> | null, categories?: Array<{ id: string, categoryName: string, categoryCode: number, relevance?: number | null }> | null } | null };

export type AudiencePeoplePageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  audienceId: Scalars['ID'];
  pageItemsCount: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  sort?: InputMaybe<Array<InputMaybe<SortFieldInput>> | InputMaybe<SortFieldInput>>;
  customBooleanFieldsFields: Array<Scalars['String']> | Scalars['String'];
  customDateFieldsFields: Array<Scalars['String']> | Scalars['String'];
  customIntegerFieldsFields: Array<Scalars['String']> | Scalars['String'];
  customStringFieldsFields: Array<Scalars['String']> | Scalars['String'];
}>;


export type AudiencePeoplePageQuery = { audience?: { peoplePage?: { totalCount: number, nodes: Array<{ address?: string | null, adultsInHousehold?: number | null, age?: number | null, behaviors?: Array<string | null> | null, bebacks?: number | null, childrenAgeRanges?: Array<string | null> | null, childrenBetweenAges0_3?: number | null, childrenBetweenAges10_12?: number | null, childrenBetweenAges13_18?: number | null, childrenBetweenAges4_6?: number | null, childrenBetweenAges7_9?: number | null, childrenInHousehold?: number | null, city?: string | null, creditRange?: string | null, dwellingType?: string | null, education?: string | null, email?: string | null, emailVerificationDate?: any | null, ethnicGroup?: string | null, firstName?: string | null, dnc?: boolean | null, dma?: number | null, optIn?: boolean | null, optInDate?: any | null, optInIp?: string | null, optInUrl?: string | null, gender?: string | null, generation?: string | null, homeHeatType?: string | null, homeOwner?: string | null, homePrice?: number | null, homePurchasedYearsAgo?: number | null, homeValue?: number | null, householdIncome?: string | null, householdNetWorth?: string | null, id: string, incomeLevels?: string | null, interests?: Array<string | null> | null, isMultilingual?: boolean | null, isPoliticalContributor?: boolean | null, isPrimaryResidence?: boolean | null, language?: string | null, lastName?: string | null, maid?: string | null, maidOs?: MaidOs | null, maritalStatus?: string | null, mortgageAge?: number | null, mortgageAmount?: number | null, mortgageLoanType?: string | null, mortgageRefinanceAge?: number | null, mortgageRefinanceAmount?: number | null, mortgageRefinanceType?: string | null, netWorth?: string | null, newCreditOfferedHousehold?: string | null, numberOfVehiclesInHousehold?: number | null, occupationDetail?: string | null, ownsAmexCard?: boolean | null, ownsBankCard?: boolean | null, ownsCreditCard?: boolean | null, ownsInvestment?: boolean | null, ownsPremiumAmexCard?: boolean | null, ownsPremiumCard?: boolean | null, ownsStocksAndBonds?: boolean | null, peopleInHousehold?: number | null, personality?: string | null, phone?: string | null, politicalParty?: string | null, premiumIncomeHousehold?: string | null, pixelLastHitDate?: any | null, pixelFirstHitDate?: any | null, religion?: string | null, state?: string | null, urbanicity?: string | null, veteransInHousehold?: number | null, zip?: string | null, companyName?: string | null, companyRevenue?: string | null, department?: string | null, jobTitle?: string | null, primaryIndustry?: string | null, seniorityLevel?: string | null, companyCity?: string | null, companyDomain?: string | null, companyEmployeeCount?: string | null, companySic?: Array<string | null> | null, companyState?: string | null, businessEmail?: string | null, zip4?: string | null, dpbc?: number | null, dpv?: number | null, carrierRoute?: string | null, fipsStateCode?: number | null, fipsCountyCode?: number | null, countyName?: string | null, customBooleanFields?: Array<boolean | null> | null, customDateFields?: Array<any | null> | null, customIntegerFields?: Array<number | null> | null, customStringFields?: Array<string | null> | null, beeswaxIds?: Array<string> | null, ipAddresses?: Array<string> | null, hemsMd5?: Array<string> | null, hemsSha1?: Array<string> | null, hemsSha256?: Array<string> | null, hemsMd5Uppercase?: Array<string> | null, hemsSha1Uppercase?: Array<string> | null, hemsSha256Uppercase?: Array<string> | null, pixelLastIpLocation?: { countryName?: string | null, countryCode?: string | null, regionName?: string | null, postalCode?: string | null, city?: string | null } | null, social?: { facebook?: string | null, linkedIn?: string | null, twitter?: string | null } | null, maids?: Array<{ maid: string, os: MaidOs }> | null }> } | null } | null };

export type AudiencePeopleCountsQueryVariables = Exact<{
  field: FilterStringField;
  audienceId: Scalars['ID'];
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
}>;


export type AudiencePeopleCountsQuery = { audience?: { peopleCounts?: Array<{ count: number, key: string } | null> | null } | null };

export type AudiencePeopleNumberHistogramQueryVariables = Exact<{
  field: FilterNumberField;
  audienceId: Scalars['ID'];
  interval?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
}>;


export type AudiencePeopleNumberHistogramQuery = { audience?: { peopleNumberHistogram?: Array<{ count: number, key: string } | null> | null } | null };

export type AudienceS3PathQueryVariables = Exact<{
  audienceId: Scalars['ID'];
}>;


export type AudienceS3PathQuery = { audience?: { s3IntegrationTestPath: string } | null };

export type AudiencesPageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  conditions?: InputMaybe<Array<AudienceCondition> | AudienceCondition>;
  pixelStatus?: InputMaybe<AudiencePixelStatus>;
  filters?: InputMaybe<Array<AudienceFilterInput> | AudienceFilterInput>;
}>;


export type AudiencesPageQuery = { audiencesPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, createdAt: any, peopleCount?: number | null, organizationId: string, processingStatus?: AudienceProcessingStatus | null, creator: { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null } | { id: string, firstName?: string | null, lastName?: string | null, imageUrl?: string | null }, organization: { id: string, name?: string | null } | { id: string, name?: string | null }, pixelSettings?: { pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, quotaEnabled: boolean } | null, parentAudience?: { id: string, createdAt: any, condition: AudienceCondition } | { id: string, createdAt?: any | null, condition?: AudienceCondition | null } | null, quotaInfo?: { currentCount?: number | null, limit?: number | null } | null }>, pageInfo: { hasNextPage: boolean } } };

export type AvailableGlobalPeopleCountQueryVariables = Exact<{
  filters: Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>;
  addingToGlobalAudienceId?: InputMaybe<Scalars['ID']>;
}>;


export type AvailableGlobalPeopleCountQuery = { peopleSnapshot?: { totalCount: number } | null };

export type BeeswaxListSegmentsQueryVariables = Exact<{
  input: BeeswaxListSegmentsInput;
}>;


export type BeeswaxListSegmentsQuery = { beeswaxListSegments: { hasNextPage: boolean, nextCursor?: string | null, items: Array<{ id: string, name?: string | null }> } };

export type AdminConfirmPendingAudiencePulseMutationVariables = Exact<{
  confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput;
}>;


export type AdminConfirmPendingAudiencePulseMutation = { adminConfirmPendingAudiencePulse?: { id: string } | null };

export type CreateAudienceGlobalMutationVariables = Exact<{
  audienceGlobalParams: AudienceGlobalInput;
}>;


export type CreateAudienceGlobalMutation = { createAudienceGlobal?: { id: string, name: string } | null };

export type CreateAudiencePixelMutationVariables = Exact<{
  audiencePixelParams: AudiencePixelInput;
}>;


export type CreateAudiencePixelMutation = { createAudiencePixel?: { id: string, name: string } | null };

export type CreateAudiencePulseMutationVariables = Exact<{
  audiencePulseParams: AudiencePulseInput;
}>;


export type CreateAudiencePulseMutation = { createAudiencePulse?: { name: string, id: string } | null };

export type CreateAudienceSegmentMutationVariables = Exact<{
  audienceSegmentParams: AudienceSegmentInput;
}>;


export type CreateAudienceSegmentMutation = { createAudienceSegment?: { id: string, name: string } | null };

export type CreateAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationInput;
}>;


export type CreateAudienceIntegrationMutation = { createAudienceIntegration?: { id: string, configuration: { emails: Array<string> } | { buzzKey: string, email: string, segmentKey: string, hemSalt?: string | null } | { name: string, description?: string | null, adAccountId: string, accessToken?: string | null, customAudienceId: string, historicalDataSync: boolean, daysToKeep: number } | { name: string, description?: string | null, customerId: string, managerCustomerId?: string | null, userListId: string, lastOperationId?: string | null, historicalDataSync: boolean, daysToKeep: number, status: GoogleCustomerMatchConnectionStatus, googleUserAccountId?: string | null } | { privateIntegrationToken?: string | null, locationId: string } | { apiKey?: string | null, audienceId: string, tag?: string | null, daysToKeep: number, historicalDataSync: boolean } | { destinationS3URI: string, iamRoles?: Array<string> | null, ownership: S3AudienceIntegrationBucketOwnership } | { checkIfExistingCustomer: boolean, redshiftHost?: string | null, redshiftPort?: number | null, redshiftUser?: string | null, redshiftPassword?: string | null, redshiftDatabase?: string | null, emailAttributeName?: string | null, customEntries: any, endpoint: string, events: { existingCustomer?: string | null, nonExistingCustomer?: string | null, static?: string | null }, parameterNames: { phone: string, email: string, hashedPhone: string, hashedEmail: string } } | {} } | null };

export type CreateAudienceLookalikeMutationVariables = Exact<{
  audienceLookalikeParams: AudienceLookalikeInput;
}>;


export type CreateAudienceLookalikeMutation = { createAudienceLookalike?: { id: string, name: string } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input?: InputMaybe<CreateOrganizationInput>;
}>;


export type CreateOrganizationMutation = { createOrganization?: { id: string } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  subscriptionParams: SubscriptionInput;
}>;


export type CreateSubscriptionMutation = { createSubscription?: boolean | null };

export type AudiencesCountQueryVariables = Exact<{
  dateRange?: InputMaybe<DateOperatorsInput>;
  dateRangePast?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type AudiencesCountQuery = { actualAudiencesCount?: { customerList: number, global: number, pixel: number, lookalike: number, pulse: number } | null, pastAudiencesCount?: { customerList: number, global: number, lookalike: number, pixel: number, pulse: number } | null };

export type EntitiesCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type EntitiesCountQuery = { entitiesCount?: { audiences: number, organizations: number, users: number } | null };

export type DeleteAudienceIntegrationMutationVariables = Exact<{
  deleteAudienceIntegrationId: Scalars['ID'];
}>;


export type DeleteAudienceIntegrationMutation = { deleteAudienceIntegration?: boolean | null };

export type DeleteAudienceMutationVariables = Exact<{
  audienceId: Scalars['ID'];
}>;


export type DeleteAudienceMutation = { deleteAudience?: boolean | null };

export type DiscardFailedAudienceCustomerListLoadMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DiscardFailedAudienceCustomerListLoadMutation = { discardFailedAudienceCustomerListLoad?: { id: string, processingStatus?: AudienceProcessingStatus | null } | null };

export type GetConversationMessagesQueryVariables = Exact<{
  section: ConversationSection;
  identifier: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetConversationMessagesQuery = { getConversationMessages: { agentSessionId: string, nodes: Array<{ id: string, body?: string | null, role: ConversationRole }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PeopleSnapshotQueryVariables = Exact<{
  filters: Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>;
  parentAudienceId?: InputMaybe<Scalars['ID']>;
}>;


export type PeopleSnapshotQuery = { peopleSnapshot?: { totalCount: number, geoResults?: Array<{ count: number, postalCodes: Array<string | null> } | null> | null, people: Array<{ id: string, firstName?: string | null, city?: string | null } | null>, postalCodeCounts?: Array<{ count: number, postalCode: string } | null> | null } | null };

export type GoogleAuthorizeMutationVariables = Exact<{
  input: GoogleAuthorizeInput;
}>;


export type GoogleAuthorizeMutation = { googleAuthorize: { accessToken: string, accountId: string, scopes: Array<string>, expiryDate: any } };

export type GoogleGenerateAccessTokenMutationVariables = Exact<{
  input: GoogleAccessTokenInput;
}>;


export type GoogleGenerateAccessTokenMutation = { googleGenerateAccessToken: { accessToken: string, expiryDate: any } };

export type GoogleTokenMutationVariables = Exact<{
  input: GoogleTokenInput;
}>;


export type GoogleTokenMutation = { googleToken?: { accessToken?: string | null, refreshToken?: string | null, tokenType?: string | null } | null };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { integrations: Array<{ description: string, imageUrl: string, integrationType: AudienceIntegrationType }> };

export type SendInviteMutationVariables = Exact<{
  inviteParams?: InputMaybe<InviteInput>;
}>;


export type SendInviteMutation = { createInvite?: { id: string, email: string } | null };

export type DeclineInviteMutationVariables = Exact<{
  declineInviteId: Scalars['ID'];
}>;


export type DeclineInviteMutation = { declineInvite?: { status: string, organizationId?: string | null } | null };

export type AcceptInviteMutationVariables = Exact<{
  acceptInviteId: Scalars['ID'];
}>;


export type AcceptInviteMutation = { acceptInvite?: { organizationId?: string | null, status: string } | null };

export type InvoicesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type InvoicesQuery = { invoices?: Array<{ totalAmount?: string | null, currency?: string | null, paidDate?: any | null, taxAmount?: string | null, productName?: string | null, productInterval?: number | null, productIntervalUnit?: ProductIntervalUnit | null, publicUrl?: string | null, payments?: Array<{ paymentMethod?: { maskedCardNumber?: string | null, cardBrand?: string | null } | null } | null> | null }> | null };

export type LookalikesPageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  audienceId: Scalars['ID'];
}>;


export type LookalikesPageQuery = { audience?: { lookalikesPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }, organization: { id: string, name?: string | null } | { id: string, name?: string | null }, parentAudience?: { id: string, condition: AudienceCondition } | { id: string, condition?: AudienceCondition | null } | null }> } } | null };

export type MailchimpListAudiencesQueryVariables = Exact<{
  input: MailchimpListAudiencesInput;
}>;


export type MailchimpListAudiencesQuery = { mailchimpListAudiences: Array<{ id: string, name?: string | null }> };

export type DisableEmailValidationFieldsFragment = { disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationQuery = { organization?: { addressLine1?: string | null, state?: string | null, id: string, name?: string | null, country?: string | null, city?: string | null, phone?: string | null, paidSubscription?: boolean | null, subscriptionOverride?: boolean | null, pixelDomain?: string | null, businessDataEnabled?: boolean | null, customerListEnabled?: boolean | null, globalSearchEnabled?: boolean | null, globalSearchLimit?: number | null, lookalikeEnabled?: boolean | null, lookalikeSearchLimit?: number | null, pulseEnabled?: boolean | null, zip?: string | null, hiddenPeopleFields: Array<string>, pixelMatchingCadence?: PixelMatchingCadence | null, imageUrl?: string | null, audiencesCount?: number | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?: { organizationType: OrganizationType, id: string, name?: string | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null, parentOrganization?: { organizationType: OrganizationType, id: string, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null } | { id: string } | null } | { id: string, name?: string | null } | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  input?: InputMaybe<UpdateOrganizationInput>;
}>;


export type EditOrganizationMutation = { updateOrganization?: { id: string } | null };

export type AdminUpdateOrganizationMutationVariables = Exact<{
  input?: InputMaybe<AdminUpdateOrganizationInput>;
}>;


export type AdminUpdateOrganizationMutation = { adminUpdateOrganization?: { id: string } | null };

export type InvitesOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type InvitesOrganizationQuery = { organization?: { id: string, pendingInvites?: Array<{ id: string, email: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } | null> | null } | null };

export type DeleteSentInviteMutationVariables = Exact<{
  deleteInviteId: Scalars['ID'];
}>;


export type DeleteSentInviteMutation = { deleteInvite?: { status: string } | null };

export type UserFieldsFragment = { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null };

export type UserRoleFieldsFragment = { id: string, name: string, organization?: { id: string, name?: string | null } | null };

export type MembersOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type MembersOrganizationQuery = { organization?: { id: string, userRoles?: Array<{ id: string, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } | null> | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveMemberMutation = { removeMember?: boolean | null };

export type UpdateUserRoleMutationVariables = Exact<{
  input: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { updateUserRole: { id: string, assignedRole: { id: string, name: string, organization?: { id: string, name?: string | null } | null } } };

export type OrganizationNameImageQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationNameImageQuery = { organization?: { name?: string | null, imageUrl?: string | null } | null };

export type OrganizationsPageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<OrganizationType>;
  ancestorOrganizationId?: InputMaybe<Scalars['ID']>;
}>;


export type OrganizationsPageQuery = { organizationsPage: { totalCount: number, nodes: Array<{ addressLine1?: string | null, audiencesCount?: number | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: any | null, subscriptionOverride?: boolean | null, id: string, imageUrl?: string | null, legalName?: string | null, name?: string | null, pixelMatchingCadence?: PixelMatchingCadence | null, paidSubscription?: boolean | null, businessDataEnabled?: boolean | null, pulseEnabled?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: any | null, hiddenPeopleFields: Array<string>, lookalikeEnabled?: boolean | null, zip?: string | null, organizationType: OrganizationType, disableEmailValidationOwn?: boolean | null, disableEmailValidationFinal?: boolean | null, userRoles?: Array<{ id: string, user?: { id: string } | null } | null> | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type ListOrganizationRolesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ListOrganizationRolesQuery = { listOrganizationRoles: Array<{ id: string, name: string, organization?: { id: string, name?: string | null } | null }> };

export type PeopleCountsQueryVariables = Exact<{
  field: FilterStringField;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
}>;


export type PeopleCountsQuery = { peopleCounts?: Array<{ key: string, count: number } | null> | null };

export type PeopleFieldsCountsQueryVariables = Exact<{
  field?: InputMaybe<FilterStringField>;
  customField?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
  parentAudienceId?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type PeopleFieldsCountsQuery = { peopleFieldCounts: { totalCount?: number | null, nodes: Array<{ count: number, key: string }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type PeopleFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type PeopleFieldsQuery = { peopleFields?: Array<{ category: FieldCategory, filterField: FilterField, title: string, type: FieldType, configuration?: { fieldAudienceTypes?: Array<AudienceCondition> | null, numberFilterConfiguration?: { from?: number | null, to?: number | null } | null, stringFilterConfiguration?: { condition?: LogicalOperator | null, onlyExistence?: boolean | null, isExtendedStringFilter?: boolean | null } | null } | null } | null> | null };

export type JourneyQueryVariables = Exact<{
  first: Scalars['Int'];
  personId: Scalars['ID'];
  audienceId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<JourneyFilterInput> | JourneyFilterInput>;
}>;


export type JourneyQuery = { audience?: { personJourney?: { nodes: Array<{ date: any, id: string, url: string, ip: string, utmCampaign?: string | null, tealiumVisitorId?: string | null, gaSessionId?: string | null, utmMedium?: string | null, utmSource?: string | null, os?: { name?: string | null, version?: string | null } | null, ipLocation?: { countryName?: string | null, countryCode?: string | null, regionName?: string | null, postalCode?: string | null, city?: string | null } | null, browser?: { name?: string | null, version?: string | null } | null }>, pageInfo: { endCursor?: string | null, hasNextPage: boolean } } | null } | null };

export type PersonJourneyGroupsQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  personId: Scalars['ID'];
  first: Scalars['Int'];
  groupBy: JourneyGroupByInput;
}>;


export type PersonJourneyGroupsQuery = { person?: { journeyGroups?: { totalCount?: number | null, nodes: Array<{ count: number, key: string }>, pageInfo: { hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null } | null };

export type PeopleNumberHistogramQueryVariables = Exact<{
  field: FilterNumberField;
  interval?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<InputMaybe<PersonFilterInput>> | InputMaybe<PersonFilterInput>>;
  takeIntoAccountSameFieldFilters?: InputMaybe<Scalars['Boolean']>;
}>;


export type PeopleNumberHistogramQuery = { peopleNumberHistogram?: Array<{ count: number, key: string } | null> | null };

export type PersonQueryVariables = Exact<{
  audienceId: Scalars['ID'];
  personId: Scalars['ID'];
}>;


export type PersonQuery = { person?: { id: string, email?: string | null, gender?: string | null, firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type PeopleDateHistogramQueryVariables = Exact<{
  field: FilterDateField;
  audienceId: Scalars['ID'];
  min?: InputMaybe<Scalars['Date']>;
  max?: InputMaybe<Scalars['Date']>;
  interval: DateIntervalInput;
}>;


export type PeopleDateHistogramQuery = { audience?: { peopleDateHistogram?: Array<{ key: string, count: number } | null> | null } | null };

export type PixelMatchCountsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateOperatorsInput>;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type PixelMatchCountsQuery = { pixelMatchCounts?: { matchCount: number, lowestTraffic?: { count: number, audience: { id: string } | { id: string } } | null, highestTraffic?: { count: number, audience: { id: string } | { id: string } } | null } | null };

export type PixelStatusCountQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type PixelStatusCountQuery = { pixelStatusCount?: { nearQuotaReached: number, quotaReached: number, withoutRecentMatches: number } | null };

export type PixelMatchDateHistogramQueryVariables = Exact<{
  min: Scalars['Date'];
  max: Scalars['Date'];
  interval: DateIntervalInput;
  organizationId?: InputMaybe<Scalars['ID']>;
}>;


export type PixelMatchDateHistogramQuery = { pixelMatchDateHistogram?: Array<{ count: number, key: string }> | null };

export type AudiencePixelSettingsQueryVariables = Exact<{
  audienceId: Scalars['ID'];
}>;


export type AudiencePixelSettingsQuery = { audience?: { id: string, name: string, createdAt: any, pixelSettings?: { hostAndPath: string, pixelEnabled: boolean, pixelStatus: AudiencePixelStatus, location?: { address?: string | null, city: string, state: string } | null, codeSnippets?: { head: string, body: string } | null, quota: { enabled?: boolean | null, limit?: number | null }, billing: { dayOfMonth: number } } | null } | null };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { products?: Array<{ id: string, name?: string | null, description?: string | null, priceInCents?: number | null, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, handle?: string | null, budgetPerPeriod?: number | null, productFamily?: { name?: string | null } | null, publicSignupPages?: Array<{ enabled?: boolean | null, url?: string | null }> | null, components?: Array<{ id: string, unitName?: string | null, unitPrice?: string | null } | null> | null }> | null };

export type PromptPersonFilterQueryVariables = Exact<{
  promptPersonFilterParams: PromptPersonFilterInput;
}>;


export type PromptPersonFilterQuery = { promptPersonFilter?: { sessionId?: string | null, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ compoundFilter?: { operator: LogicalOperator, filters: Array<{ stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null, stringFilter?: { field?: FilterStringField | null, customField?: string | null, negate?: boolean | null, operator: { in?: Array<string | null> | null, eq?: string | null, exists?: boolean | null } } | null, extendedStringFilter?: { field: FilterExtendedStringField, negate?: boolean | null, operator: { contains?: string | null, eq?: string | null, startsWith?: string | null } } | null, numberFilter?: { field?: FilterNumberField | null, customField?: string | null, operator: { eq?: number | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null, exists?: boolean | null, between?: { from?: number | null, to?: number | null } | null } } | null, booleanFilter?: { field?: FilterBooleanField | null, customField?: string | null, operator: { eq?: boolean | null, exists?: boolean | null } } | null, geoFilter?: { excludedZipCodes?: Array<string | null> | null, operator: { distance?: { distance: number, unit: DistanceUnit, location: { latitude: number, longitude: number } } | null, polygon?: Array<{ latitude: number, longitude: number }> | null }, place?: { address: string, postalCode?: string | null } | null } | null, dateFilter?: { field?: FilterDateField | null, customField?: string | null, operator: { exists?: boolean | null, gt?: any | null, lt?: any | null, gte?: any | null, lte?: any | null, between?: { from: any, to: any } | null } } | null }> } | null };

export type PulseNodesQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  parentPaths?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  searchQuery?: InputMaybe<Scalars['String']>;
}>;


export type PulseNodesQuery = { pulseNodes: { totalCount: number, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, nodes: Array<{ id: string, name: string, signalCount: number, paths: Array<string> }> } };

export type PulseNodesSignalCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PulseNodesSignalCountQuery = { pulseNodesSignalCount: number };

export type RemoveAudienceMemberMutationVariables = Exact<{
  audienceId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveAudienceMemberMutation = { removeAudienceMember?: boolean | null };

export type ResendInviteMutationVariables = Exact<{
  resendInviteId: Scalars['ID'];
}>;


export type ResendInviteMutation = { resendInvite?: { id: string } | null };

export type SegmentsPageQueryVariables = Exact<{
  pageNumber: Scalars['Int'];
  pageItemsCount: Scalars['Int'];
  audienceId: Scalars['ID'];
}>;


export type SegmentsPageQuery = { audience?: { segmentsPage: { totalCount: number, nodes: Array<{ id: string, name: string, condition: AudienceCondition, peopleCount?: number | null, organizationId: string, creator: { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null } | { id: string, imageUrl?: string | null, firstName?: string | null, lastName?: string | null }, organization: { id: string, name?: string | null } | { id: string, name?: string | null }, parentAudience?: { id: string, condition: AudienceCondition } | { id: string, condition?: AudienceCondition | null } | null }> } } | null };

export type SendSupportEmailMutationVariables = Exact<{
  message: Scalars['String'];
}>;


export type SendSupportEmailMutation = { sendSupportEmail?: boolean | null };

export type SubscriptionInfoFragment = { id: string, currency?: string | null, totalRevenueInCents?: number | null, currentPeriodEndsAt?: any | null, cancelAtEndOfPeriod?: string | null, creditBalanceInCents?: number | null, currentPeriodUsageInfo: { currentPeriodUsageInCents: number, audienceIdCount: number, resolveIdCount: number }, product?: { id: string, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, priceInCents?: number | null, name?: string | null, budgetPerPeriod?: number | null } | null, creditCard?: { cardType?: string | null, maskedCardNumber?: string | null, expirationMonth?: number | null, expirationYear?: number | null } | null };

export type SubscriptionInfoQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SubscriptionInfoQuery = { subscriptionInfo?: { id: string, currency?: string | null, totalRevenueInCents?: number | null, currentPeriodEndsAt?: any | null, cancelAtEndOfPeriod?: string | null, creditBalanceInCents?: number | null, currentPeriodUsageInfo: { currentPeriodUsageInCents: number, audienceIdCount: number, resolveIdCount: number }, product?: { id: string, intervalUnit?: ProductIntervalUnit | null, interval?: number | null, expirationInterval?: number | null, priceInCents?: number | null, name?: string | null, budgetPerPeriod?: number | null } | null, creditCard?: { cardType?: string | null, maskedCardNumber?: string | null, expirationMonth?: number | null, expirationYear?: number | null } | null } | null };

export type UpdateAudienceMutationVariables = Exact<{
  audienceUpdateParams: AudienceUpdateInput;
}>;


export type UpdateAudienceMutation = { updateAudience?: { id: string, name: string } | null };

export type UpdateAudienceCategoriesMutationVariables = Exact<{
  audienceId: Scalars['ID'];
  categoryCodes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateAudienceCategoriesMutation = { updateAudienceCategories: boolean };

export type UpdateAudienceIntegrationMutationVariables = Exact<{
  integrationParams: AudienceIntegrationUpdateInput;
}>;


export type UpdateAudienceIntegrationMutation = { updateAudienceIntegration?: { id: string } | null };

export type UpdateAudiencePixelSettingsMutationVariables = Exact<{
  audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput;
}>;


export type UpdateAudiencePixelSettingsMutation = { updatePixelAudienceSettings?: { id: string } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, scopes?: Array<Scope> | null, whiteLabelImageUrl?: string | null, organizations?: Array<{ id: string, name?: string | null, legalName?: string | null, organizationType: OrganizationType, imageUrl?: string | null, subscriptionOverride?: boolean | null, paidSubscription?: boolean | null, audiencesCount?: number | null, businessDataEnabled?: boolean | null, pulseEnabled?: boolean | null, globalSearchEnabled?: boolean | null, customerListEnabled?: boolean | null, lookalikeEnabled?: boolean | null, phone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, hiddenPeopleFields: Array<string>, state?: string | null, country?: string | null, zip?: string | null }> | null, invites?: Array<{ id: string, email: string, organizationId?: string | null, createdByUserId: string, status: string, createdAt: any, updatedAt: any, acceptedAt?: any | null, declinedAt?: any | null, deletedAt?: any | null, inviter?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, user?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null } | null, organization?: { id: string, name?: string | null, imageUrl?: string | null } | null }> | null, userRoles?: Array<{ id: string, hiddenPeopleFields?: Array<string> | null, organizationId?: string | null, assignedRole: { id: string, name: string, permissions: Array<Permission>, childOrgExtraPermissions?: Array<Permission> | null, hiddenPeopleFields?: Array<string> | null } }> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  user?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateMeMutation = { updateMe?: { id: string, firstName?: string | null, lastName?: string | null } | null };

export const AdfAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment ADFAudienceIntegrationConfiguration on ADFAudienceIntegrationConfiguration {
  emails
}
    `;
export const S3AudienceIntegrationConfigurationFragmentDoc = gql`
    fragment S3AudienceIntegrationConfiguration on S3AudienceIntegrationConfiguration {
  secretAccessKey
  region
  ownership
  iamRoles
  destinationS3URI
  accessKeyId
  exportType
  fileFormat
  peopleColumns
}
    `;
export const ZapierAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment ZapierAudienceIntegrationConfiguration on ZapierAudienceIntegrationConfiguration {
  connectionTimestamp
  historicalDataSync
  status
}
    `;
export const FacebookAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment FacebookAudienceIntegrationConfiguration on FacebookCustomAudienceAudienceIntegrationConfiguration {
  name
  description
  adAccountId
  accessToken
  customAudienceId
  historicalDataSync
  daysToKeep
}
    `;
export const GoogleAdsAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment GoogleAdsAudienceIntegrationConfiguration on GoogleCustomerMatchAudienceIntegrationConfiguration {
  name
  description
  customerId
  managerCustomerId
  userListId
  lastOperationId
  historicalDataSync
  daysToKeep
  googleAdsStatus: status
  googleUserAccountId
}
    `;
export const HighLevelIntegrationConfigurationFragmentDoc = gql`
    fragment HighLevelIntegrationConfiguration on HighLevelAudienceIntegrationConfiguration {
  privateIntegrationToken
  locationId
}
    `;
export const TealiumIntegrationConfigurationFragmentDoc = gql`
    fragment TealiumIntegrationConfiguration on TealiumAudienceIntegrationConfiguration {
  checkIfExistingCustomer
  redshiftHost
  redshiftPort
  redshiftUser
  redshiftPassword
  redshiftDatabase
  emailAttributeName
  events {
    existingCustomer
    nonExistingCustomer
    static
  }
  parameterNames {
    phone
    email
    hashedPhone
    hashedEmail
  }
  customEntries
  endpoint
}
    `;
export const MailchimpAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment MailchimpAudienceIntegrationConfiguration on MailchimpAudienceIntegrationConfiguration {
  apiKey
  audienceId
  tag
  daysToKeep
  historicalDataSync
}
    `;
export const BeeswaxAudienceIntegrationConfigurationFragmentDoc = gql`
    fragment BeeswaxAudienceIntegrationConfiguration on BeeswaxAudienceIntegrationConfiguration {
  buzzKey
  email
  segmentKey
  hemSalt
}
    `;
export const BasicFilterFieldsFragmentDoc = gql`
    fragment BasicFilterFields on PersonFilter {
  stringFilter {
    field
    customField
    negate
    operator {
      in
      eq
      exists
    }
  }
  extendedStringFilter {
    field
    negate
    operator {
      contains
      eq
      startsWith
    }
  }
  numberFilter {
    field
    customField
    operator {
      between {
        from
        to
      }
      eq
      gt
      lt
      gte
      lte
      exists
    }
  }
  booleanFilter {
    field
    customField
    operator {
      eq
      exists
    }
  }
  geoFilter {
    operator {
      distance {
        distance
        location {
          latitude
          longitude
        }
        unit
      }
      polygon {
        latitude
        longitude
      }
    }
    place {
      address
      postalCode
    }
    excludedZipCodes
  }
  dateFilter {
    field
    customField
    operator {
      exists
      between {
        from
        to
      }
      gt
      lt
      gte
      lte
    }
  }
}
    `;
export const FilterFieldsFragmentDoc = gql`
    fragment FilterFields on BaseAudience {
  filters {
    ...BasicFilterFields
    compoundFilter {
      filters {
        ...BasicFilterFields
        compoundFilter {
          filters {
            ...BasicFilterFields
          }
          operator
        }
      }
      operator
    }
  }
}
    ${BasicFilterFieldsFragmentDoc}`;
export const CategoriesFragmentDoc = gql`
    fragment Categories on BaseAudience {
  categories {
    id
    categoryName
    categoryCode
    relevance
  }
  info {
    ... on AudiencePixelInfo {
      categoriesProcessed
    }
  }
}
    `;
export const LookalikeInfoFieldsFragmentDoc = gql`
    fragment LookalikeInfoFields on AudienceLookalikeInfo {
  requestedCount
  matchedCount
  similarityPercentage
  dateRange {
    from
    to
  }
}
    `;
export const AdditionsFieldsFragmentDoc = gql`
    fragment AdditionsFields on BaseAdditionsArrayInfo {
  matchedCount
  date
}
    `;
export const GlobalInfoFieldsFragmentDoc = gql`
    fragment GlobalInfoFields on AudienceGlobalInfo {
  lastSuccessfullyProcessedAt
  additions {
    ...AdditionsFields
  }
}
    ${AdditionsFieldsFragmentDoc}`;
export const PulseInfoFieldsFragmentDoc = gql`
    fragment PulseInfoFields on AudiencePulseInfo {
  lastProcessedDateRange {
    from
    to
  }
  lastSuccessfullyProcessedAt
  subscriptionCount
  subscriptionAmount
  items {
    category
    id
    subCategory
    topic
  }
  topicIds
  additions {
    ...AdditionsFields
  }
}
    ${AdditionsFieldsFragmentDoc}`;
export const CustomerListColumnMappingsFieldsFragmentDoc = gql`
    fragment CustomerListColumnMappingsFields on AudienceCustomerListColumnMappings {
  email
  emailField
  emailMd5
  emailMd5Field
  phone
  phoneField
  customFields {
    column
    field
    fieldType
    originalField
  }
}
    `;
export const CustomerListInfoFieldsFragmentDoc = gql`
    fragment CustomerListInfoFields on AudienceCustomerListInfo {
  additions {
    ...AdditionsFields
    mapping {
      ...CustomerListColumnMappingsFields
    }
  }
  processingAdditionInfo {
    mapping {
      ...CustomerListColumnMappingsFields
    }
  }
}
    ${AdditionsFieldsFragmentDoc}
${CustomerListColumnMappingsFieldsFragmentDoc}`;
export const DisableEmailValidationFieldsFragmentDoc = gql`
    fragment DisableEmailValidationFields on Organization {
  disableEmailValidationOwn: disableEmailValidation(retrieveFinalValue: false)
  disableEmailValidationFinal: disableEmailValidation(retrieveFinalValue: true)
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  email
  phone
  imageUrl
}
    `;
export const UserRoleFieldsFragmentDoc = gql`
    fragment UserRoleFields on Role {
  id
  name
  organization {
    id
    name
  }
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on SubscriptionInfo {
  id
  currency
  totalRevenueInCents
  currentPeriodEndsAt
  cancelAtEndOfPeriod
  creditBalanceInCents
  currentPeriodUsageInfo {
    currentPeriodUsageInCents
    audienceIdCount
    resolveIdCount
  }
  product {
    id
    intervalUnit
    interval
    expirationInterval
    priceInCents
    name
    budgetPerPeriod
  }
  creditCard {
    cardType
    maskedCardNumber
    expirationMonth
    expirationYear
  }
}
    `;
export const CreateAudienceCustomerListDocument = gql`
    mutation CreateAudienceCustomerList($audienceCustomerListParams: AudienceCustomerListInput!) {
  createAudienceCustomerList(
    audienceCustomerListParams: $audienceCustomerListParams
  ) {
    id
    name
  }
}
    `;
export type CreateAudienceCustomerListMutationFn = Apollo.MutationFunction<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>;

/**
 * __useCreateAudienceCustomerListMutation__
 *
 * To run a mutation, you first call `useCreateAudienceCustomerListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceCustomerListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceCustomerListMutation, { data, loading, error }] = useCreateAudienceCustomerListMutation({
 *   variables: {
 *      audienceCustomerListParams: // value for 'audienceCustomerListParams'
 *   },
 * });
 */
export function useCreateAudienceCustomerListMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>(CreateAudienceCustomerListDocument, options);
      }
export type CreateAudienceCustomerListMutationHookResult = ReturnType<typeof useCreateAudienceCustomerListMutation>;
export type CreateAudienceCustomerListMutationResult = Apollo.MutationResult<CreateAudienceCustomerListMutation>;
export type CreateAudienceCustomerListMutationOptions = Apollo.BaseMutationOptions<CreateAudienceCustomerListMutation, CreateAudienceCustomerListMutationVariables>;
export const ActivitySummaryPageDocument = gql`
    query ActivitySummaryPage($pageNumber: Int!, $pageItemsCount: Int!, $dateRange: DateOperatorsInput!, $organizationId: ID, $activityLevel: ActivityLevel) {
  activitySummaryPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    dateRange: $dateRange
    organizationId: $organizationId
    activityLevel: $activityLevel
  ) {
    totalCount
    nodes {
      actedByUserType
      actionType
      actor {
        id
        imageUrl
        firstName
        lastName
      }
      audience {
        id
        name
      }
      createdAt
      entityId
      entityType
      field
      newValue
      oldValue
      organization {
        id
        name
        imageUrl
      }
      user {
        id
        firstName
        lastName
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useActivitySummaryPageQuery__
 *
 * To run a query within a React component, call `useActivitySummaryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySummaryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySummaryPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      dateRange: // value for 'dateRange'
 *      organizationId: // value for 'organizationId'
 *      activityLevel: // value for 'activityLevel'
 *   },
 * });
 */
export function useActivitySummaryPageQuery(baseOptions: Apollo.QueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>(ActivitySummaryPageDocument, options);
      }
export function useActivitySummaryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>(ActivitySummaryPageDocument, options);
        }
export type ActivitySummaryPageQueryHookResult = ReturnType<typeof useActivitySummaryPageQuery>;
export type ActivitySummaryPageLazyQueryHookResult = ReturnType<typeof useActivitySummaryPageLazyQuery>;
export type ActivitySummaryPageQueryResult = Apollo.QueryResult<ActivitySummaryPageQuery, ActivitySummaryPageQueryVariables>;
export const AddPeopleAudienceCustomerListDocument = gql`
    mutation AddPeopleAudienceCustomerList($addPeopleAudienceCustomerListParams: AddPeopleAudienceCustomerListInput!) {
  addPeopleAudienceCustomerList(
    addPeopleAudienceCustomerListParams: $addPeopleAudienceCustomerListParams
  ) {
    id
    name
  }
}
    `;
export type AddPeopleAudienceCustomerListMutationFn = Apollo.MutationFunction<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>;

/**
 * __useAddPeopleAudienceCustomerListMutation__
 *
 * To run a mutation, you first call `useAddPeopleAudienceCustomerListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPeopleAudienceCustomerListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPeopleAudienceCustomerListMutation, { data, loading, error }] = useAddPeopleAudienceCustomerListMutation({
 *   variables: {
 *      addPeopleAudienceCustomerListParams: // value for 'addPeopleAudienceCustomerListParams'
 *   },
 * });
 */
export function useAddPeopleAudienceCustomerListMutation(baseOptions?: Apollo.MutationHookOptions<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>(AddPeopleAudienceCustomerListDocument, options);
      }
export type AddPeopleAudienceCustomerListMutationHookResult = ReturnType<typeof useAddPeopleAudienceCustomerListMutation>;
export type AddPeopleAudienceCustomerListMutationResult = Apollo.MutationResult<AddPeopleAudienceCustomerListMutation>;
export type AddPeopleAudienceCustomerListMutationOptions = Apollo.BaseMutationOptions<AddPeopleAudienceCustomerListMutation, AddPeopleAudienceCustomerListMutationVariables>;
export const AddAudienceVisitsDocument = gql`
    mutation AddAudienceVisits($addPeopleAudienceGlobalParams: AddPeopleAudienceGlobalInput!) {
  addPeopleAudienceGlobal(
    addPeopleAudienceGlobalParams: $addPeopleAudienceGlobalParams
  ) {
    id
  }
}
    `;
export type AddAudienceVisitsMutationFn = Apollo.MutationFunction<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>;

/**
 * __useAddAudienceVisitsMutation__
 *
 * To run a mutation, you first call `useAddAudienceVisitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAudienceVisitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAudienceVisitsMutation, { data, loading, error }] = useAddAudienceVisitsMutation({
 *   variables: {
 *      addPeopleAudienceGlobalParams: // value for 'addPeopleAudienceGlobalParams'
 *   },
 * });
 */
export function useAddAudienceVisitsMutation(baseOptions?: Apollo.MutationHookOptions<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>(AddAudienceVisitsDocument, options);
      }
export type AddAudienceVisitsMutationHookResult = ReturnType<typeof useAddAudienceVisitsMutation>;
export type AddAudienceVisitsMutationResult = Apollo.MutationResult<AddAudienceVisitsMutation>;
export type AddAudienceVisitsMutationOptions = Apollo.BaseMutationOptions<AddAudienceVisitsMutation, AddAudienceVisitsMutationVariables>;
export const AppConfigurationDocument = gql`
    query AppConfiguration {
  appConfiguration {
    pulseDateRange {
      from
      to
    }
    pulseSubscriptionAmount
  }
}
    `;

/**
 * __useAppConfigurationQuery__
 *
 * To run a query within a React component, call `useAppConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppConfigurationQuery, AppConfigurationQueryVariables>(AppConfigurationDocument, options);
      }
export function useAppConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppConfigurationQuery, AppConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppConfigurationQuery, AppConfigurationQueryVariables>(AppConfigurationDocument, options);
        }
export type AppConfigurationQueryHookResult = ReturnType<typeof useAppConfigurationQuery>;
export type AppConfigurationLazyQueryHookResult = ReturnType<typeof useAppConfigurationLazyQuery>;
export type AppConfigurationQueryResult = Apollo.QueryResult<AppConfigurationQuery, AppConfigurationQueryVariables>;
export const AttributionSourceCountsQueryDocument = gql`
    query AttributionSourceCountsQuery($audienceId: ID!, $utmGroup: UTMGroup!, $filters: [PersonFilterInput!], $count: Int) {
  audience(id: $audienceId) {
    attributionSourceCounts(utmGroup: $utmGroup, filters: $filters, count: $count) {
      attributions {
        count
        source
      }
    }
  }
}
    `;

/**
 * __useAttributionSourceCountsQueryQuery__
 *
 * To run a query within a React component, call `useAttributionSourceCountsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionSourceCountsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionSourceCountsQueryQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      utmGroup: // value for 'utmGroup'
 *      filters: // value for 'filters'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAttributionSourceCountsQueryQuery(baseOptions: Apollo.QueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>(AttributionSourceCountsQueryDocument, options);
      }
export function useAttributionSourceCountsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>(AttributionSourceCountsQueryDocument, options);
        }
export type AttributionSourceCountsQueryQueryHookResult = ReturnType<typeof useAttributionSourceCountsQueryQuery>;
export type AttributionSourceCountsQueryLazyQueryHookResult = ReturnType<typeof useAttributionSourceCountsQueryLazyQuery>;
export type AttributionSourceCountsQueryQueryResult = Apollo.QueryResult<AttributionSourceCountsQueryQuery, AttributionSourceCountsQueryQueryVariables>;
export const AudienceIntegrationDocument = gql`
    query AudienceIntegration($audienceIntegrationId: ID!) {
  audienceIntegration(id: $audienceIntegrationId) {
    configuration {
      ...ADFAudienceIntegrationConfiguration
      ...S3AudienceIntegrationConfiguration
      ...ZapierAudienceIntegrationConfiguration
      ...FacebookAudienceIntegrationConfiguration
      ...GoogleAdsAudienceIntegrationConfiguration
      ...HighLevelIntegrationConfiguration
      ...MailchimpAudienceIntegrationConfiguration
      ...TealiumIntegrationConfiguration
      ...BeeswaxAudienceIntegrationConfiguration
    }
    id
    integrationType
    name
    creator {
      firstName
      lastName
    }
    lastSuccessfulRunAt
    lastRunSucceeded
    lastRunAt
  }
}
    ${AdfAudienceIntegrationConfigurationFragmentDoc}
${S3AudienceIntegrationConfigurationFragmentDoc}
${ZapierAudienceIntegrationConfigurationFragmentDoc}
${FacebookAudienceIntegrationConfigurationFragmentDoc}
${GoogleAdsAudienceIntegrationConfigurationFragmentDoc}
${HighLevelIntegrationConfigurationFragmentDoc}
${MailchimpAudienceIntegrationConfigurationFragmentDoc}
${TealiumIntegrationConfigurationFragmentDoc}
${BeeswaxAudienceIntegrationConfigurationFragmentDoc}`;

/**
 * __useAudienceIntegrationQuery__
 *
 * To run a query within a React component, call `useAudienceIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceIntegrationQuery({
 *   variables: {
 *      audienceIntegrationId: // value for 'audienceIntegrationId'
 *   },
 * });
 */
export function useAudienceIntegrationQuery(baseOptions: Apollo.QueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>(AudienceIntegrationDocument, options);
      }
export function useAudienceIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>(AudienceIntegrationDocument, options);
        }
export type AudienceIntegrationQueryHookResult = ReturnType<typeof useAudienceIntegrationQuery>;
export type AudienceIntegrationLazyQueryHookResult = ReturnType<typeof useAudienceIntegrationLazyQuery>;
export type AudienceIntegrationQueryResult = Apollo.QueryResult<AudienceIntegrationQuery, AudienceIntegrationQueryVariables>;
export const TestAudienceIntegrationDocument = gql`
    mutation TestAudienceIntegration($integrationParams: AudienceIntegrationTestInput!) {
  testAudienceIntegration(integrationParams: $integrationParams) {
    success
    message
  }
}
    `;
export type TestAudienceIntegrationMutationFn = Apollo.MutationFunction<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>;

/**
 * __useTestAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useTestAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAudienceIntegrationMutation, { data, loading, error }] = useTestAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useTestAudienceIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>(TestAudienceIntegrationDocument, options);
      }
export type TestAudienceIntegrationMutationHookResult = ReturnType<typeof useTestAudienceIntegrationMutation>;
export type TestAudienceIntegrationMutationResult = Apollo.MutationResult<TestAudienceIntegrationMutation>;
export type TestAudienceIntegrationMutationOptions = Apollo.BaseMutationOptions<TestAudienceIntegrationMutation, TestAudienceIntegrationMutationVariables>;
export const AudienceIntegrationsDocument = gql`
    query AudienceIntegrations($audienceId: ID!, $pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String) {
  audience(id: $audienceId) {
    integrationsPage(
      pageNumber: $pageNumber
      pageItemsCount: $pageItemsCount
      searchQuery: $searchQuery
    ) {
      nodes {
        id
        name
        integrationType
        lastSuccessfulRunAt
        lastRunSucceeded
        lastRunAt
      }
      totalCount
    }
  }
}
    `;

/**
 * __useAudienceIntegrationsQuery__
 *
 * To run a query within a React component, call `useAudienceIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceIntegrationsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAudienceIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>(AudienceIntegrationsDocument, options);
      }
export function useAudienceIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>(AudienceIntegrationsDocument, options);
        }
export type AudienceIntegrationsQueryHookResult = ReturnType<typeof useAudienceIntegrationsQuery>;
export type AudienceIntegrationsLazyQueryHookResult = ReturnType<typeof useAudienceIntegrationsLazyQuery>;
export type AudienceIntegrationsQueryResult = Apollo.QueryResult<AudienceIntegrationsQuery, AudienceIntegrationsQueryVariables>;
export const InvitesAudienceDocument = gql`
    query InvitesAudience($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    pendingInvites {
      id
      email
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
  }
}
    `;

/**
 * __useInvitesAudienceQuery__
 *
 * To run a query within a React component, call `useInvitesAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesAudienceQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useInvitesAudienceQuery(baseOptions: Apollo.QueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesAudienceQuery, InvitesAudienceQueryVariables>(InvitesAudienceDocument, options);
      }
export function useInvitesAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesAudienceQuery, InvitesAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesAudienceQuery, InvitesAudienceQueryVariables>(InvitesAudienceDocument, options);
        }
export type InvitesAudienceQueryHookResult = ReturnType<typeof useInvitesAudienceQuery>;
export type InvitesAudienceLazyQueryHookResult = ReturnType<typeof useInvitesAudienceLazyQuery>;
export type InvitesAudienceQueryResult = Apollo.QueryResult<InvitesAudienceQuery, InvitesAudienceQueryVariables>;
export const JourneyTopPathsDocument = gql`
    query JourneyTopPaths($audienceId: ID!, $count: Int!, $filters: [PersonFilterInput!]) {
  audience(id: $audienceId) {
    journeyTopPaths(count: $count, filters: $filters) {
      count
      paths {
        count
        pathPrefix
      }
    }
  }
}
    `;

/**
 * __useJourneyTopPathsQuery__
 *
 * To run a query within a React component, call `useJourneyTopPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyTopPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyTopPathsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      count: // value for 'count'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJourneyTopPathsQuery(baseOptions: Apollo.QueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>(JourneyTopPathsDocument, options);
      }
export function useJourneyTopPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>(JourneyTopPathsDocument, options);
        }
export type JourneyTopPathsQueryHookResult = ReturnType<typeof useJourneyTopPathsQuery>;
export type JourneyTopPathsLazyQueryHookResult = ReturnType<typeof useJourneyTopPathsLazyQuery>;
export type JourneyTopPathsQueryResult = Apollo.QueryResult<JourneyTopPathsQuery, JourneyTopPathsQueryVariables>;
export const AudienceJourneyTopUrlsDocument = gql`
    query AudienceJourneyTopUrls($audienceId: ID!, $count: Int!, $filters: [PersonFilterInput!]) {
  audience(id: $audienceId) {
    journeyTopUrls(count: $count, filters: $filters)
  }
}
    `;

/**
 * __useAudienceJourneyTopUrlsQuery__
 *
 * To run a query within a React component, call `useAudienceJourneyTopUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceJourneyTopUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceJourneyTopUrlsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      count: // value for 'count'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAudienceJourneyTopUrlsQuery(baseOptions: Apollo.QueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>(AudienceJourneyTopUrlsDocument, options);
      }
export function useAudienceJourneyTopUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>(AudienceJourneyTopUrlsDocument, options);
        }
export type AudienceJourneyTopUrlsQueryHookResult = ReturnType<typeof useAudienceJourneyTopUrlsQuery>;
export type AudienceJourneyTopUrlsLazyQueryHookResult = ReturnType<typeof useAudienceJourneyTopUrlsLazyQuery>;
export type AudienceJourneyTopUrlsQueryResult = Apollo.QueryResult<AudienceJourneyTopUrlsQuery, AudienceJourneyTopUrlsQueryVariables>;
export const AudienceLookalikeCountDocument = gql`
    query AudienceLookalikeCount($audienceLookalikeCountParams: AudienceLookalikeCountInput!) {
  audienceLookalikeCount(
    audienceLookalikeCountParams: $audienceLookalikeCountParams
  )
}
    `;

/**
 * __useAudienceLookalikeCountQuery__
 *
 * To run a query within a React component, call `useAudienceLookalikeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceLookalikeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceLookalikeCountQuery({
 *   variables: {
 *      audienceLookalikeCountParams: // value for 'audienceLookalikeCountParams'
 *   },
 * });
 */
export function useAudienceLookalikeCountQuery(baseOptions: Apollo.QueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>(AudienceLookalikeCountDocument, options);
      }
export function useAudienceLookalikeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>(AudienceLookalikeCountDocument, options);
        }
export type AudienceLookalikeCountQueryHookResult = ReturnType<typeof useAudienceLookalikeCountQuery>;
export type AudienceLookalikeCountLazyQueryHookResult = ReturnType<typeof useAudienceLookalikeCountLazyQuery>;
export type AudienceLookalikeCountQueryResult = Apollo.QueryResult<AudienceLookalikeCountQuery, AudienceLookalikeCountQueryVariables>;
export const AudienceOverviewDocument = gql`
    query AudienceOverview($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    name
    condition
    createdAt
    peopleCount
    processingStatus
    verifyEmails
    audienceOnlyAccess
    quotaInfo {
      currentCount
      limit
      period
    }
    baseAudience {
      id
      name
      condition
      parentAudience {
        id
        name
        condition
        createdAt
      }
    }
    userRoles {
      id
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
    }
    organization {
      name
      id
      imageUrl
      hiddenPeopleFields
      businessDataEnabled
      organizationType
      __typename
      ... on Organization {
        imageUrl
        ...DisableEmailValidationFields
        userRoles {
          id
          user {
            id
          }
        }
        paidSubscription
        parentOrganization {
          id
          name
          ... on Organization {
            imageUrl
            userRoles {
              id
              user {
                id
              }
            }
            parentOrganization {
              id
              name
              ... on Organization {
                imageUrl
                userRoles {
                  id
                  user {
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
    pixelSettings {
      pixelId
      hostAndPath
      pixelDisabledAt
      pixelEnabled
      pixelStatus
      pixelReachedQuotaAt
      quotaEnabled
      pixelMatchingCadence
      quota {
        limit
        period
      }
      location {
        address
        city
        state
      }
      codeSnippets {
        head
        body
      }
      billing {
        dayOfMonth
      }
    }
    parentAudience {
      id
      name
      createdAt
      condition
      ... on Audience {
        peopleCount
        pixelSettings {
          pixelMatchingCadence
        }
      }
      ...Categories
      ...FilterFields
      info {
        ... on AudiencePulseInfo {
          ...PulseInfoFields
        }
        ... on AudienceGlobalInfo {
          ...GlobalInfoFields
        }
        ... on AudienceLookalikeInfo {
          ...LookalikeInfoFields
        }
        ... on AudienceCustomerListInfo {
          ...CustomerListInfoFields
        }
      }
    }
    ...FilterFields
    segmentsCount
    lookalikesCount
    segments {
      id
      name
      creator {
        id
        imageUrl
        firstName
        lastName
      }
      organization {
        id
        name
      }
      condition
      peopleCount
      organizationId
    }
    ...Categories
    info {
      ... on AudienceLookalikeInfo {
        ...LookalikeInfoFields
      }
      ... on AudiencePulseInfo {
        ...PulseInfoFields
      }
      ... on AudienceGlobalInfo {
        ...GlobalInfoFields
      }
      ... on AudienceCustomerListInfo {
        ...CustomerListInfoFields
      }
    }
    customFields {
      name
      fieldType
    }
    processingResultInfo {
      ... on CustomerListInvalidImportData {
        invalidEntries {
          value
          fieldType
          columnName
          rowNumber
        }
      }
    }
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}
${CategoriesFragmentDoc}
${FilterFieldsFragmentDoc}
${PulseInfoFieldsFragmentDoc}
${GlobalInfoFieldsFragmentDoc}
${LookalikeInfoFieldsFragmentDoc}
${CustomerListInfoFieldsFragmentDoc}`;

/**
 * __useAudienceOverviewQuery__
 *
 * To run a query within a React component, call `useAudienceOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceOverviewQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudienceOverviewQuery(baseOptions: Apollo.QueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceOverviewQuery, AudienceOverviewQueryVariables>(AudienceOverviewDocument, options);
      }
export function useAudienceOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceOverviewQuery, AudienceOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceOverviewQuery, AudienceOverviewQueryVariables>(AudienceOverviewDocument, options);
        }
export type AudienceOverviewQueryHookResult = ReturnType<typeof useAudienceOverviewQuery>;
export type AudienceOverviewLazyQueryHookResult = ReturnType<typeof useAudienceOverviewLazyQuery>;
export type AudienceOverviewQueryResult = Apollo.QueryResult<AudienceOverviewQuery, AudienceOverviewQueryVariables>;
export const AudiencePeoplePageDocument = gql`
    query AudiencePeoplePage($pageNumber: Int!, $audienceId: ID!, $pageItemsCount: Int!, $searchQuery: String, $filters: [PersonFilterInput], $sort: [SortFieldInput], $customBooleanFieldsFields: [String!]!, $customDateFieldsFields: [String!]!, $customIntegerFieldsFields: [String!]!, $customStringFieldsFields: [String!]!) {
  audience(id: $audienceId) {
    peoplePage(
      pageNumber: $pageNumber
      pageItemsCount: $pageItemsCount
      searchQuery: $searchQuery
      filters: $filters
      sort: $sort
    ) {
      totalCount
      nodes {
        address
        adultsInHousehold
        age
        behaviors
        bebacks
        childrenAgeRanges
        childrenBetweenAges0_3
        childrenBetweenAges10_12
        childrenBetweenAges13_18
        childrenBetweenAges4_6
        childrenBetweenAges7_9
        childrenInHousehold
        city
        creditRange
        dwellingType
        education
        email
        emailVerificationDate
        pixelLastIpLocation {
          countryName
          countryCode
          regionName
          postalCode
          city
        }
        ethnicGroup
        firstName
        dnc
        dma
        optIn
        optInDate
        optInIp
        optInUrl
        gender
        generation
        homeHeatType
        homeOwner
        homePrice
        homePurchasedYearsAgo
        homeValue
        householdIncome
        householdNetWorth
        id
        incomeLevels
        interests
        isMultilingual
        isPoliticalContributor
        isPrimaryResidence
        language
        lastName
        maid
        maidOs
        maritalStatus
        mortgageAge
        mortgageAmount
        mortgageLoanType
        mortgageRefinanceAge
        mortgageRefinanceAmount
        mortgageRefinanceType
        netWorth
        newCreditOfferedHousehold
        numberOfVehiclesInHousehold
        occupationDetail
        ownsAmexCard
        ownsBankCard
        ownsCreditCard
        ownsInvestment
        ownsPremiumAmexCard
        ownsPremiumCard
        ownsStocksAndBonds
        peopleInHousehold
        personality
        phone
        politicalParty
        premiumIncomeHousehold
        pixelLastHitDate
        pixelFirstHitDate
        religion
        social {
          facebook
          linkedIn
          twitter
        }
        state
        urbanicity
        veteransInHousehold
        zip
        companyName
        companyRevenue
        department
        jobTitle
        primaryIndustry
        seniorityLevel
        companyCity
        companyDomain
        companyEmployeeCount
        companySic
        companyState
        businessEmail
        zip4
        zip
        dpbc
        dpv
        carrierRoute
        fipsStateCode
        fipsCountyCode
        countyName
        customBooleanFields(fields: $customBooleanFieldsFields)
        customDateFields(fields: $customDateFieldsFields)
        customIntegerFields(fields: $customIntegerFieldsFields)
        customStringFields(fields: $customStringFieldsFields)
        beeswaxIds
        ipAddresses
        maids {
          maid
          os
        }
        hemsMd5
        hemsSha1
        hemsSha256
        hemsMd5Uppercase
        hemsSha1Uppercase
        hemsSha256Uppercase
      }
    }
  }
}
    `;

/**
 * __useAudiencePeoplePageQuery__
 *
 * To run a query within a React component, call `useAudiencePeoplePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeoplePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeoplePageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      audienceId: // value for 'audienceId'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      customBooleanFieldsFields: // value for 'customBooleanFieldsFields'
 *      customDateFieldsFields: // value for 'customDateFieldsFields'
 *      customIntegerFieldsFields: // value for 'customIntegerFieldsFields'
 *      customStringFieldsFields: // value for 'customStringFieldsFields'
 *   },
 * });
 */
export function useAudiencePeoplePageQuery(baseOptions: Apollo.QueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>(AudiencePeoplePageDocument, options);
      }
export function useAudiencePeoplePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>(AudiencePeoplePageDocument, options);
        }
export type AudiencePeoplePageQueryHookResult = ReturnType<typeof useAudiencePeoplePageQuery>;
export type AudiencePeoplePageLazyQueryHookResult = ReturnType<typeof useAudiencePeoplePageLazyQuery>;
export type AudiencePeoplePageQueryResult = Apollo.QueryResult<AudiencePeoplePageQuery, AudiencePeoplePageQueryVariables>;
export const AudiencePeopleCountsDocument = gql`
    query AudiencePeopleCounts($field: FilterStringField!, $audienceId: ID!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  audience(id: $audienceId) {
    peopleCounts(
      field: $field
      filters: $filters
      takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    ) {
      count
      key
    }
  }
}
    `;

/**
 * __useAudiencePeopleCountsQuery__
 *
 * To run a query within a React component, call `useAudiencePeopleCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeopleCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeopleCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function useAudiencePeopleCountsQuery(baseOptions: Apollo.QueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>(AudiencePeopleCountsDocument, options);
      }
export function useAudiencePeopleCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>(AudiencePeopleCountsDocument, options);
        }
export type AudiencePeopleCountsQueryHookResult = ReturnType<typeof useAudiencePeopleCountsQuery>;
export type AudiencePeopleCountsLazyQueryHookResult = ReturnType<typeof useAudiencePeopleCountsLazyQuery>;
export type AudiencePeopleCountsQueryResult = Apollo.QueryResult<AudiencePeopleCountsQuery, AudiencePeopleCountsQueryVariables>;
export const AudiencePeopleNumberHistogramDocument = gql`
    query AudiencePeopleNumberHistogram($field: FilterNumberField!, $audienceId: ID!, $interval: Int, $min: Int, $max: Int, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  audience(id: $audienceId) {
    peopleNumberHistogram(
      field: $field
      interval: $interval
      min: $min
      max: $max
      filters: $filters
      takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    ) {
      count
      key
    }
  }
}
    `;

/**
 * __useAudiencePeopleNumberHistogramQuery__
 *
 * To run a query within a React component, call `useAudiencePeopleNumberHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePeopleNumberHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePeopleNumberHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      interval: // value for 'interval'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function useAudiencePeopleNumberHistogramQuery(baseOptions: Apollo.QueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>(AudiencePeopleNumberHistogramDocument, options);
      }
export function useAudiencePeopleNumberHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>(AudiencePeopleNumberHistogramDocument, options);
        }
export type AudiencePeopleNumberHistogramQueryHookResult = ReturnType<typeof useAudiencePeopleNumberHistogramQuery>;
export type AudiencePeopleNumberHistogramLazyQueryHookResult = ReturnType<typeof useAudiencePeopleNumberHistogramLazyQuery>;
export type AudiencePeopleNumberHistogramQueryResult = Apollo.QueryResult<AudiencePeopleNumberHistogramQuery, AudiencePeopleNumberHistogramQueryVariables>;
export const AudienceS3PathDocument = gql`
    query AudienceS3Path($audienceId: ID!) {
  audience(id: $audienceId) {
    s3IntegrationTestPath
  }
}
    `;

/**
 * __useAudienceS3PathQuery__
 *
 * To run a query within a React component, call `useAudienceS3PathQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceS3PathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceS3PathQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudienceS3PathQuery(baseOptions: Apollo.QueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceS3PathQuery, AudienceS3PathQueryVariables>(AudienceS3PathDocument, options);
      }
export function useAudienceS3PathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceS3PathQuery, AudienceS3PathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceS3PathQuery, AudienceS3PathQueryVariables>(AudienceS3PathDocument, options);
        }
export type AudienceS3PathQueryHookResult = ReturnType<typeof useAudienceS3PathQuery>;
export type AudienceS3PathLazyQueryHookResult = ReturnType<typeof useAudienceS3PathLazyQuery>;
export type AudienceS3PathQueryResult = Apollo.QueryResult<AudienceS3PathQuery, AudienceS3PathQueryVariables>;
export const AudiencesPageDocument = gql`
    query AudiencesPage($pageNumber: Int!, $pageItemsCount: Int!, $organizationId: ID, $searchQuery: String, $conditions: [AudienceCondition!], $pixelStatus: AudiencePixelStatus, $filters: [AudienceFilterInput!]) {
  audiencesPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    organizationId: $organizationId
    searchQuery: $searchQuery
    conditions: $conditions
    pixelStatus: $pixelStatus
    filters: $filters
  ) {
    nodes {
      id
      name
      condition
      createdAt
      peopleCount
      organizationId
      creator {
        id
        firstName
        lastName
        imageUrl
      }
      organization {
        id
        name
      }
      pixelSettings {
        pixelEnabled
        pixelStatus
        quotaEnabled
      }
      processingStatus
      parentAudience {
        id
        createdAt
        condition
      }
      quotaInfo {
        currentCount
        limit
      }
    }
    totalCount
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useAudiencesPageQuery__
 *
 * To run a query within a React component, call `useAudiencesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      organizationId: // value for 'organizationId'
 *      searchQuery: // value for 'searchQuery'
 *      conditions: // value for 'conditions'
 *      pixelStatus: // value for 'pixelStatus'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAudiencesPageQuery(baseOptions: Apollo.QueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
      }
export function useAudiencesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesPageQuery, AudiencesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesPageQuery, AudiencesPageQueryVariables>(AudiencesPageDocument, options);
        }
export type AudiencesPageQueryHookResult = ReturnType<typeof useAudiencesPageQuery>;
export type AudiencesPageLazyQueryHookResult = ReturnType<typeof useAudiencesPageLazyQuery>;
export type AudiencesPageQueryResult = Apollo.QueryResult<AudiencesPageQuery, AudiencesPageQueryVariables>;
export const AvailableGlobalPeopleCountDocument = gql`
    query AvailableGlobalPeopleCount($filters: [PersonFilterInput]!, $addingToGlobalAudienceId: ID) {
  peopleSnapshot(
    filters: $filters
    addingToGlobalAudienceId: $addingToGlobalAudienceId
  ) {
    totalCount
  }
}
    `;

/**
 * __useAvailableGlobalPeopleCountQuery__
 *
 * To run a query within a React component, call `useAvailableGlobalPeopleCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableGlobalPeopleCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableGlobalPeopleCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      addingToGlobalAudienceId: // value for 'addingToGlobalAudienceId'
 *   },
 * });
 */
export function useAvailableGlobalPeopleCountQuery(baseOptions: Apollo.QueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>(AvailableGlobalPeopleCountDocument, options);
      }
export function useAvailableGlobalPeopleCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>(AvailableGlobalPeopleCountDocument, options);
        }
export type AvailableGlobalPeopleCountQueryHookResult = ReturnType<typeof useAvailableGlobalPeopleCountQuery>;
export type AvailableGlobalPeopleCountLazyQueryHookResult = ReturnType<typeof useAvailableGlobalPeopleCountLazyQuery>;
export type AvailableGlobalPeopleCountQueryResult = Apollo.QueryResult<AvailableGlobalPeopleCountQuery, AvailableGlobalPeopleCountQueryVariables>;
export const BeeswaxListSegmentsDocument = gql`
    query BeeswaxListSegments($input: BeeswaxListSegmentsInput!) {
  beeswaxListSegments(input: $input) {
    items {
      id
      name
    }
    hasNextPage
    nextCursor
  }
}
    `;

/**
 * __useBeeswaxListSegmentsQuery__
 *
 * To run a query within a React component, call `useBeeswaxListSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeeswaxListSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeeswaxListSegmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBeeswaxListSegmentsQuery(baseOptions: Apollo.QueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>(BeeswaxListSegmentsDocument, options);
      }
export function useBeeswaxListSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>(BeeswaxListSegmentsDocument, options);
        }
export type BeeswaxListSegmentsQueryHookResult = ReturnType<typeof useBeeswaxListSegmentsQuery>;
export type BeeswaxListSegmentsLazyQueryHookResult = ReturnType<typeof useBeeswaxListSegmentsLazyQuery>;
export type BeeswaxListSegmentsQueryResult = Apollo.QueryResult<BeeswaxListSegmentsQuery, BeeswaxListSegmentsQueryVariables>;
export const AdminConfirmPendingAudiencePulseDocument = gql`
    mutation AdminConfirmPendingAudiencePulse($confirmPendingAudiencePulseParams: ConfirmPendingAudiencePulseInput!) {
  adminConfirmPendingAudiencePulse(
    confirmPendingAudiencePulseParams: $confirmPendingAudiencePulseParams
  ) {
    id
  }
}
    `;
export type AdminConfirmPendingAudiencePulseMutationFn = Apollo.MutationFunction<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>;

/**
 * __useAdminConfirmPendingAudiencePulseMutation__
 *
 * To run a mutation, you first call `useAdminConfirmPendingAudiencePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminConfirmPendingAudiencePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminConfirmPendingAudiencePulseMutation, { data, loading, error }] = useAdminConfirmPendingAudiencePulseMutation({
 *   variables: {
 *      confirmPendingAudiencePulseParams: // value for 'confirmPendingAudiencePulseParams'
 *   },
 * });
 */
export function useAdminConfirmPendingAudiencePulseMutation(baseOptions?: Apollo.MutationHookOptions<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>(AdminConfirmPendingAudiencePulseDocument, options);
      }
export type AdminConfirmPendingAudiencePulseMutationHookResult = ReturnType<typeof useAdminConfirmPendingAudiencePulseMutation>;
export type AdminConfirmPendingAudiencePulseMutationResult = Apollo.MutationResult<AdminConfirmPendingAudiencePulseMutation>;
export type AdminConfirmPendingAudiencePulseMutationOptions = Apollo.BaseMutationOptions<AdminConfirmPendingAudiencePulseMutation, AdminConfirmPendingAudiencePulseMutationVariables>;
export const CreateAudienceGlobalDocument = gql`
    mutation createAudienceGlobal($audienceGlobalParams: AudienceGlobalInput!) {
  createAudienceGlobal(audienceGlobalParams: $audienceGlobalParams) {
    id
    name
  }
}
    `;
export type CreateAudienceGlobalMutationFn = Apollo.MutationFunction<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>;

/**
 * __useCreateAudienceGlobalMutation__
 *
 * To run a mutation, you first call `useCreateAudienceGlobalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceGlobalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceGlobalMutation, { data, loading, error }] = useCreateAudienceGlobalMutation({
 *   variables: {
 *      audienceGlobalParams: // value for 'audienceGlobalParams'
 *   },
 * });
 */
export function useCreateAudienceGlobalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>(CreateAudienceGlobalDocument, options);
      }
export type CreateAudienceGlobalMutationHookResult = ReturnType<typeof useCreateAudienceGlobalMutation>;
export type CreateAudienceGlobalMutationResult = Apollo.MutationResult<CreateAudienceGlobalMutation>;
export type CreateAudienceGlobalMutationOptions = Apollo.BaseMutationOptions<CreateAudienceGlobalMutation, CreateAudienceGlobalMutationVariables>;
export const CreateAudiencePixelDocument = gql`
    mutation createAudiencePixel($audiencePixelParams: AudiencePixelInput!) {
  createAudiencePixel(audiencePixelParams: $audiencePixelParams) {
    id
    name
  }
}
    `;
export type CreateAudiencePixelMutationFn = Apollo.MutationFunction<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>;

/**
 * __useCreateAudiencePixelMutation__
 *
 * To run a mutation, you first call `useCreateAudiencePixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudiencePixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudiencePixelMutation, { data, loading, error }] = useCreateAudiencePixelMutation({
 *   variables: {
 *      audiencePixelParams: // value for 'audiencePixelParams'
 *   },
 * });
 */
export function useCreateAudiencePixelMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>(CreateAudiencePixelDocument, options);
      }
export type CreateAudiencePixelMutationHookResult = ReturnType<typeof useCreateAudiencePixelMutation>;
export type CreateAudiencePixelMutationResult = Apollo.MutationResult<CreateAudiencePixelMutation>;
export type CreateAudiencePixelMutationOptions = Apollo.BaseMutationOptions<CreateAudiencePixelMutation, CreateAudiencePixelMutationVariables>;
export const CreateAudiencePulseDocument = gql`
    mutation CreateAudiencePulse($audiencePulseParams: AudiencePulseInput!) {
  createAudiencePulse(audiencePulseParams: $audiencePulseParams) {
    name
    id
  }
}
    `;
export type CreateAudiencePulseMutationFn = Apollo.MutationFunction<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>;

/**
 * __useCreateAudiencePulseMutation__
 *
 * To run a mutation, you first call `useCreateAudiencePulseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudiencePulseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudiencePulseMutation, { data, loading, error }] = useCreateAudiencePulseMutation({
 *   variables: {
 *      audiencePulseParams: // value for 'audiencePulseParams'
 *   },
 * });
 */
export function useCreateAudiencePulseMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>(CreateAudiencePulseDocument, options);
      }
export type CreateAudiencePulseMutationHookResult = ReturnType<typeof useCreateAudiencePulseMutation>;
export type CreateAudiencePulseMutationResult = Apollo.MutationResult<CreateAudiencePulseMutation>;
export type CreateAudiencePulseMutationOptions = Apollo.BaseMutationOptions<CreateAudiencePulseMutation, CreateAudiencePulseMutationVariables>;
export const CreateAudienceSegmentDocument = gql`
    mutation createAudienceSegment($audienceSegmentParams: AudienceSegmentInput!) {
  createAudienceSegment(audienceSegmentParams: $audienceSegmentParams) {
    id
    name
  }
}
    `;
export type CreateAudienceSegmentMutationFn = Apollo.MutationFunction<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>;

/**
 * __useCreateAudienceSegmentMutation__
 *
 * To run a mutation, you first call `useCreateAudienceSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceSegmentMutation, { data, loading, error }] = useCreateAudienceSegmentMutation({
 *   variables: {
 *      audienceSegmentParams: // value for 'audienceSegmentParams'
 *   },
 * });
 */
export function useCreateAudienceSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>(CreateAudienceSegmentDocument, options);
      }
export type CreateAudienceSegmentMutationHookResult = ReturnType<typeof useCreateAudienceSegmentMutation>;
export type CreateAudienceSegmentMutationResult = Apollo.MutationResult<CreateAudienceSegmentMutation>;
export type CreateAudienceSegmentMutationOptions = Apollo.BaseMutationOptions<CreateAudienceSegmentMutation, CreateAudienceSegmentMutationVariables>;
export const CreateAudienceIntegrationDocument = gql`
    mutation CreateAudienceIntegration($integrationParams: AudienceIntegrationInput!) {
  createAudienceIntegration(integrationParams: $integrationParams) {
    configuration {
      ... on S3AudienceIntegrationConfiguration {
        destinationS3URI
        iamRoles
        ownership
      }
      ... on ADFAudienceIntegrationConfiguration {
        emails
      }
      ... on MailchimpAudienceIntegrationConfiguration {
        apiKey
        audienceId
        tag
        daysToKeep
        historicalDataSync
      }
      ... on FacebookCustomAudienceAudienceIntegrationConfiguration {
        name
        description
        adAccountId
        accessToken
        customAudienceId
        historicalDataSync
        daysToKeep
      }
      ... on GoogleCustomerMatchAudienceIntegrationConfiguration {
        name
        description
        customerId
        managerCustomerId
        userListId
        lastOperationId
        historicalDataSync
        daysToKeep
        status
        googleUserAccountId
      }
      ... on HighLevelAudienceIntegrationConfiguration {
        privateIntegrationToken
        locationId
      }
      ... on TealiumAudienceIntegrationConfiguration {
        checkIfExistingCustomer
        redshiftHost
        redshiftPort
        redshiftUser
        redshiftPassword
        redshiftDatabase
        emailAttributeName
        events {
          existingCustomer
          nonExistingCustomer
          static
        }
        parameterNames {
          phone
          email
          hashedPhone
          hashedEmail
        }
        customEntries
        endpoint
      }
      ... on BeeswaxAudienceIntegrationConfiguration {
        buzzKey
        email
        segmentKey
        hemSalt
      }
    }
    id
  }
}
    `;
export type CreateAudienceIntegrationMutationFn = Apollo.MutationFunction<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>;

/**
 * __useCreateAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceIntegrationMutation, { data, loading, error }] = useCreateAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useCreateAudienceIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>(CreateAudienceIntegrationDocument, options);
      }
export type CreateAudienceIntegrationMutationHookResult = ReturnType<typeof useCreateAudienceIntegrationMutation>;
export type CreateAudienceIntegrationMutationResult = Apollo.MutationResult<CreateAudienceIntegrationMutation>;
export type CreateAudienceIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateAudienceIntegrationMutation, CreateAudienceIntegrationMutationVariables>;
export const CreateAudienceLookalikeDocument = gql`
    mutation CreateAudienceLookalike($audienceLookalikeParams: AudienceLookalikeInput!) {
  createAudienceLookalike(audienceLookalikeParams: $audienceLookalikeParams) {
    id
    name
  }
}
    `;
export type CreateAudienceLookalikeMutationFn = Apollo.MutationFunction<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>;

/**
 * __useCreateAudienceLookalikeMutation__
 *
 * To run a mutation, you first call `useCreateAudienceLookalikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAudienceLookalikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAudienceLookalikeMutation, { data, loading, error }] = useCreateAudienceLookalikeMutation({
 *   variables: {
 *      audienceLookalikeParams: // value for 'audienceLookalikeParams'
 *   },
 * });
 */
export function useCreateAudienceLookalikeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>(CreateAudienceLookalikeDocument, options);
      }
export type CreateAudienceLookalikeMutationHookResult = ReturnType<typeof useCreateAudienceLookalikeMutation>;
export type CreateAudienceLookalikeMutationResult = Apollo.MutationResult<CreateAudienceLookalikeMutation>;
export type CreateAudienceLookalikeMutationOptions = Apollo.BaseMutationOptions<CreateAudienceLookalikeMutation, CreateAudienceLookalikeMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput) {
  createOrganization(input: $input) {
    id
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($subscriptionParams: SubscriptionInput!) {
  createSubscription(subscriptionParams: $subscriptionParams)
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      subscriptionParams: // value for 'subscriptionParams'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const AudiencesCountDocument = gql`
    query AudiencesCount($dateRange: DateOperatorsInput, $dateRangePast: DateOperatorsInput, $organizationId: ID) {
  actualAudiencesCount: audiencesCount(
    dateRange: $dateRange
    organizationId: $organizationId
  ) {
    customerList
    global
    pixel
    lookalike
    pulse
  }
  pastAudiencesCount: audiencesCount(
    dateRange: $dateRangePast
    organizationId: $organizationId
  ) {
    customerList
    global
    lookalike
    pixel
    pulse
  }
}
    `;

/**
 * __useAudiencesCountQuery__
 *
 * To run a query within a React component, call `useAudiencesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencesCountQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      dateRangePast: // value for 'dateRangePast'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAudiencesCountQuery(baseOptions?: Apollo.QueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencesCountQuery, AudiencesCountQueryVariables>(AudiencesCountDocument, options);
      }
export function useAudiencesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencesCountQuery, AudiencesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencesCountQuery, AudiencesCountQueryVariables>(AudiencesCountDocument, options);
        }
export type AudiencesCountQueryHookResult = ReturnType<typeof useAudiencesCountQuery>;
export type AudiencesCountLazyQueryHookResult = ReturnType<typeof useAudiencesCountLazyQuery>;
export type AudiencesCountQueryResult = Apollo.QueryResult<AudiencesCountQuery, AudiencesCountQueryVariables>;
export const EntitiesCountDocument = gql`
    query EntitiesCount($organizationId: ID) {
  entitiesCount(organizationId: $organizationId) {
    audiences
    organizations
    users
  }
}
    `;

/**
 * __useEntitiesCountQuery__
 *
 * To run a query within a React component, call `useEntitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEntitiesCountQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesCountQuery, EntitiesCountQueryVariables>(EntitiesCountDocument, options);
      }
export function useEntitiesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesCountQuery, EntitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesCountQuery, EntitiesCountQueryVariables>(EntitiesCountDocument, options);
        }
export type EntitiesCountQueryHookResult = ReturnType<typeof useEntitiesCountQuery>;
export type EntitiesCountLazyQueryHookResult = ReturnType<typeof useEntitiesCountLazyQuery>;
export type EntitiesCountQueryResult = Apollo.QueryResult<EntitiesCountQuery, EntitiesCountQueryVariables>;
export const DeleteAudienceIntegrationDocument = gql`
    mutation DeleteAudienceIntegration($deleteAudienceIntegrationId: ID!) {
  deleteAudienceIntegration(id: $deleteAudienceIntegrationId)
}
    `;
export type DeleteAudienceIntegrationMutationFn = Apollo.MutationFunction<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>;

/**
 * __useDeleteAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceIntegrationMutation, { data, loading, error }] = useDeleteAudienceIntegrationMutation({
 *   variables: {
 *      deleteAudienceIntegrationId: // value for 'deleteAudienceIntegrationId'
 *   },
 * });
 */
export function useDeleteAudienceIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>(DeleteAudienceIntegrationDocument, options);
      }
export type DeleteAudienceIntegrationMutationHookResult = ReturnType<typeof useDeleteAudienceIntegrationMutation>;
export type DeleteAudienceIntegrationMutationResult = Apollo.MutationResult<DeleteAudienceIntegrationMutation>;
export type DeleteAudienceIntegrationMutationOptions = Apollo.BaseMutationOptions<DeleteAudienceIntegrationMutation, DeleteAudienceIntegrationMutationVariables>;
export const DeleteAudienceDocument = gql`
    mutation DeleteAudience($audienceId: ID!) {
  deleteAudience(audienceId: $audienceId)
}
    `;
export type DeleteAudienceMutationFn = Apollo.MutationFunction<DeleteAudienceMutation, DeleteAudienceMutationVariables>;

/**
 * __useDeleteAudienceMutation__
 *
 * To run a mutation, you first call `useDeleteAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudienceMutation, { data, loading, error }] = useDeleteAudienceMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useDeleteAudienceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAudienceMutation, DeleteAudienceMutationVariables>(DeleteAudienceDocument, options);
      }
export type DeleteAudienceMutationHookResult = ReturnType<typeof useDeleteAudienceMutation>;
export type DeleteAudienceMutationResult = Apollo.MutationResult<DeleteAudienceMutation>;
export type DeleteAudienceMutationOptions = Apollo.BaseMutationOptions<DeleteAudienceMutation, DeleteAudienceMutationVariables>;
export const DiscardFailedAudienceCustomerListLoadDocument = gql`
    mutation DiscardFailedAudienceCustomerListLoad($id: ID!) {
  discardFailedAudienceCustomerListLoad(id: $id) {
    id
    processingStatus
  }
}
    `;
export type DiscardFailedAudienceCustomerListLoadMutationFn = Apollo.MutationFunction<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>;

/**
 * __useDiscardFailedAudienceCustomerListLoadMutation__
 *
 * To run a mutation, you first call `useDiscardFailedAudienceCustomerListLoadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardFailedAudienceCustomerListLoadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardFailedAudienceCustomerListLoadMutation, { data, loading, error }] = useDiscardFailedAudienceCustomerListLoadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDiscardFailedAudienceCustomerListLoadMutation(baseOptions?: Apollo.MutationHookOptions<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>(DiscardFailedAudienceCustomerListLoadDocument, options);
      }
export type DiscardFailedAudienceCustomerListLoadMutationHookResult = ReturnType<typeof useDiscardFailedAudienceCustomerListLoadMutation>;
export type DiscardFailedAudienceCustomerListLoadMutationResult = Apollo.MutationResult<DiscardFailedAudienceCustomerListLoadMutation>;
export type DiscardFailedAudienceCustomerListLoadMutationOptions = Apollo.BaseMutationOptions<DiscardFailedAudienceCustomerListLoadMutation, DiscardFailedAudienceCustomerListLoadMutationVariables>;
export const GetConversationMessagesDocument = gql`
    query GetConversationMessages($section: ConversationSection!, $identifier: String!, $first: Int!, $after: String) {
  getConversationMessages(
    section: $section
    identifier: $identifier
    first: $first
    after: $after
  ) {
    nodes {
      id
      body
      role
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    agentSessionId
  }
}
    `;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      section: // value for 'section'
 *      identifier: // value for 'identifier'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
      }
export function useGetConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
export type GetConversationMessagesQueryHookResult = ReturnType<typeof useGetConversationMessagesQuery>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationMessagesLazyQuery>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const PeopleSnapshotDocument = gql`
    query PeopleSnapshot($filters: [PersonFilterInput]!, $parentAudienceId: ID) {
  peopleSnapshot(filters: $filters, parentAudienceId: $parentAudienceId) {
    geoResults {
      count
      postalCodes
    }
    people {
      id
      firstName
      city
    }
    postalCodeCounts {
      count
      postalCode
    }
    totalCount
  }
}
    `;

/**
 * __usePeopleSnapshotQuery__
 *
 * To run a query within a React component, call `usePeopleSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleSnapshotQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      parentAudienceId: // value for 'parentAudienceId'
 *   },
 * });
 */
export function usePeopleSnapshotQuery(baseOptions: Apollo.QueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>(PeopleSnapshotDocument, options);
      }
export function usePeopleSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>(PeopleSnapshotDocument, options);
        }
export type PeopleSnapshotQueryHookResult = ReturnType<typeof usePeopleSnapshotQuery>;
export type PeopleSnapshotLazyQueryHookResult = ReturnType<typeof usePeopleSnapshotLazyQuery>;
export type PeopleSnapshotQueryResult = Apollo.QueryResult<PeopleSnapshotQuery, PeopleSnapshotQueryVariables>;
export const GoogleAuthorizeDocument = gql`
    mutation GoogleAuthorize($input: GoogleAuthorizeInput!) {
  googleAuthorize(input: $input) {
    accessToken
    accountId
    scopes
    expiryDate
  }
}
    `;
export type GoogleAuthorizeMutationFn = Apollo.MutationFunction<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>;

/**
 * __useGoogleAuthorizeMutation__
 *
 * To run a mutation, you first call `useGoogleAuthorizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthorizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleAuthorizeMutation, { data, loading, error }] = useGoogleAuthorizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleAuthorizeMutation(baseOptions?: Apollo.MutationHookOptions<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>(GoogleAuthorizeDocument, options);
      }
export type GoogleAuthorizeMutationHookResult = ReturnType<typeof useGoogleAuthorizeMutation>;
export type GoogleAuthorizeMutationResult = Apollo.MutationResult<GoogleAuthorizeMutation>;
export type GoogleAuthorizeMutationOptions = Apollo.BaseMutationOptions<GoogleAuthorizeMutation, GoogleAuthorizeMutationVariables>;
export const GoogleGenerateAccessTokenDocument = gql`
    mutation GoogleGenerateAccessToken($input: GoogleAccessTokenInput!) {
  googleGenerateAccessToken(input: $input) {
    accessToken
    expiryDate
  }
}
    `;
export type GoogleGenerateAccessTokenMutationFn = Apollo.MutationFunction<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>;

/**
 * __useGoogleGenerateAccessTokenMutation__
 *
 * To run a mutation, you first call `useGoogleGenerateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleGenerateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleGenerateAccessTokenMutation, { data, loading, error }] = useGoogleGenerateAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleGenerateAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>(GoogleGenerateAccessTokenDocument, options);
      }
export type GoogleGenerateAccessTokenMutationHookResult = ReturnType<typeof useGoogleGenerateAccessTokenMutation>;
export type GoogleGenerateAccessTokenMutationResult = Apollo.MutationResult<GoogleGenerateAccessTokenMutation>;
export type GoogleGenerateAccessTokenMutationOptions = Apollo.BaseMutationOptions<GoogleGenerateAccessTokenMutation, GoogleGenerateAccessTokenMutationVariables>;
export const GoogleTokenDocument = gql`
    mutation GoogleToken($input: GoogleTokenInput!) {
  googleToken(input: $input) {
    accessToken
    refreshToken
    tokenType
  }
}
    `;
export type GoogleTokenMutationFn = Apollo.MutationFunction<GoogleTokenMutation, GoogleTokenMutationVariables>;

/**
 * __useGoogleTokenMutation__
 *
 * To run a mutation, you first call `useGoogleTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleTokenMutation, { data, loading, error }] = useGoogleTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleTokenMutation(baseOptions?: Apollo.MutationHookOptions<GoogleTokenMutation, GoogleTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleTokenMutation, GoogleTokenMutationVariables>(GoogleTokenDocument, options);
      }
export type GoogleTokenMutationHookResult = ReturnType<typeof useGoogleTokenMutation>;
export type GoogleTokenMutationResult = Apollo.MutationResult<GoogleTokenMutation>;
export type GoogleTokenMutationOptions = Apollo.BaseMutationOptions<GoogleTokenMutation, GoogleTokenMutationVariables>;
export const IntegrationsDocument = gql`
    query Integrations {
  integrations {
    description
    imageUrl
    integrationType
  }
}
    `;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const SendInviteDocument = gql`
    mutation SendInvite($inviteParams: InviteInput) {
  createInvite(inviteParams: $inviteParams) {
    id
    email
  }
}
    `;
export type SendInviteMutationFn = Apollo.MutationFunction<SendInviteMutation, SendInviteMutationVariables>;

/**
 * __useSendInviteMutation__
 *
 * To run a mutation, you first call `useSendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInviteMutation, { data, loading, error }] = useSendInviteMutation({
 *   variables: {
 *      inviteParams: // value for 'inviteParams'
 *   },
 * });
 */
export function useSendInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendInviteMutation, SendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInviteMutation, SendInviteMutationVariables>(SendInviteDocument, options);
      }
export type SendInviteMutationHookResult = ReturnType<typeof useSendInviteMutation>;
export type SendInviteMutationResult = Apollo.MutationResult<SendInviteMutation>;
export type SendInviteMutationOptions = Apollo.BaseMutationOptions<SendInviteMutation, SendInviteMutationVariables>;
export const DeclineInviteDocument = gql`
    mutation DeclineInvite($declineInviteId: ID!) {
  declineInvite(id: $declineInviteId) {
    status
    organizationId
  }
}
    `;
export type DeclineInviteMutationFn = Apollo.MutationFunction<DeclineInviteMutation, DeclineInviteMutationVariables>;

/**
 * __useDeclineInviteMutation__
 *
 * To run a mutation, you first call `useDeclineInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineInviteMutation, { data, loading, error }] = useDeclineInviteMutation({
 *   variables: {
 *      declineInviteId: // value for 'declineInviteId'
 *   },
 * });
 */
export function useDeclineInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeclineInviteMutation, DeclineInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineInviteMutation, DeclineInviteMutationVariables>(DeclineInviteDocument, options);
      }
export type DeclineInviteMutationHookResult = ReturnType<typeof useDeclineInviteMutation>;
export type DeclineInviteMutationResult = Apollo.MutationResult<DeclineInviteMutation>;
export type DeclineInviteMutationOptions = Apollo.BaseMutationOptions<DeclineInviteMutation, DeclineInviteMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation AcceptInvite($acceptInviteId: ID!) {
  acceptInvite(id: $acceptInviteId) {
    organizationId
    status
  }
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      acceptInviteId: // value for 'acceptInviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const InvoicesDocument = gql`
    query Invoices($organizationId: ID!) {
  invoices(organizationId: $organizationId) {
    totalAmount
    currency
    paidDate
    taxAmount
    productName
    productInterval
    productIntervalUnit
    publicUrl
    payments {
      paymentMethod {
        maskedCardNumber
        cardBrand
      }
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const LookalikesPageDocument = gql`
    query LookalikesPage($pageNumber: Int!, $pageItemsCount: Int!, $audienceId: ID!) {
  audience(id: $audienceId) {
    lookalikesPage(pageNumber: $pageNumber, pageItemsCount: $pageItemsCount) {
      totalCount
      nodes {
        id
        name
        creator {
          id
          imageUrl
          firstName
          lastName
        }
        organization {
          id
          name
        }
        condition
        peopleCount
        organizationId
        parentAudience {
          id
          condition
        }
      }
    }
  }
}
    `;

/**
 * __useLookalikesPageQuery__
 *
 * To run a query within a React component, call `useLookalikesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookalikesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookalikesPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useLookalikesPageQuery(baseOptions: Apollo.QueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookalikesPageQuery, LookalikesPageQueryVariables>(LookalikesPageDocument, options);
      }
export function useLookalikesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookalikesPageQuery, LookalikesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookalikesPageQuery, LookalikesPageQueryVariables>(LookalikesPageDocument, options);
        }
export type LookalikesPageQueryHookResult = ReturnType<typeof useLookalikesPageQuery>;
export type LookalikesPageLazyQueryHookResult = ReturnType<typeof useLookalikesPageLazyQuery>;
export type LookalikesPageQueryResult = Apollo.QueryResult<LookalikesPageQuery, LookalikesPageQueryVariables>;
export const MailchimpListAudiencesDocument = gql`
    query MailchimpListAudiences($input: MailchimpListAudiencesInput!) {
  mailchimpListAudiences(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useMailchimpListAudiencesQuery__
 *
 * To run a query within a React component, call `useMailchimpListAudiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailchimpListAudiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailchimpListAudiencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailchimpListAudiencesQuery(baseOptions: Apollo.QueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>(MailchimpListAudiencesDocument, options);
      }
export function useMailchimpListAudiencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>(MailchimpListAudiencesDocument, options);
        }
export type MailchimpListAudiencesQueryHookResult = ReturnType<typeof useMailchimpListAudiencesQuery>;
export type MailchimpListAudiencesLazyQueryHookResult = ReturnType<typeof useMailchimpListAudiencesLazyQuery>;
export type MailchimpListAudiencesQueryResult = Apollo.QueryResult<MailchimpListAudiencesQuery, MailchimpListAudiencesQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID!) {
  organization(id: $organizationId) {
    addressLine1
    state
    id
    name
    country
    city
    phone
    paidSubscription
    subscriptionOverride
    pixelDomain
    businessDataEnabled
    customerListEnabled
    ...DisableEmailValidationFields
    globalSearchEnabled
    globalSearchLimit
    lookalikeEnabled
    lookalikeSearchLimit
    pulseEnabled
    zip
    hiddenPeopleFields
    pixelMatchingCadence
    userRoles {
      id
      user {
        id
      }
    }
    imageUrl
    audiencesCount
    organizationType
    parentOrganization {
      id
      name
      ... on Organization {
        organizationType
        disableEmailValidationFinal: disableEmailValidation(retrieveFinalValue: true)
        userRoles {
          id
          user {
            id
          }
        }
        parentOrganization {
          id
          ... on Organization {
            organizationType
            userRoles {
              id
              user {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}`;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($input: UpdateOrganizationInput) {
  updateOrganization(input: $input) {
    id
  }
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const AdminUpdateOrganizationDocument = gql`
    mutation AdminUpdateOrganization($input: AdminUpdateOrganizationInput) {
  adminUpdateOrganization(input: $input) {
    id
  }
}
    `;
export type AdminUpdateOrganizationMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;

/**
 * __useAdminUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationMutation, { data, loading, error }] = useAdminUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>(AdminUpdateOrganizationDocument, options);
      }
export type AdminUpdateOrganizationMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationResult = Apollo.MutationResult<AdminUpdateOrganizationMutation>;
export type AdminUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationMutation, AdminUpdateOrganizationMutationVariables>;
export const InvitesOrganizationDocument = gql`
    query InvitesOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    pendingInvites {
      id
      email
      user {
        ...UserFields
      }
      assignedRole {
        ...UserRoleFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserRoleFieldsFragmentDoc}`;

/**
 * __useInvitesOrganizationQuery__
 *
 * To run a query within a React component, call `useInvitesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInvitesOrganizationQuery(baseOptions: Apollo.QueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
      }
export function useInvitesOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>(InvitesOrganizationDocument, options);
        }
export type InvitesOrganizationQueryHookResult = ReturnType<typeof useInvitesOrganizationQuery>;
export type InvitesOrganizationLazyQueryHookResult = ReturnType<typeof useInvitesOrganizationLazyQuery>;
export type InvitesOrganizationQueryResult = Apollo.QueryResult<InvitesOrganizationQuery, InvitesOrganizationQueryVariables>;
export const DeleteSentInviteDocument = gql`
    mutation DeleteSentInvite($deleteInviteId: ID!) {
  deleteInvite(id: $deleteInviteId) {
    status
  }
}
    `;
export type DeleteSentInviteMutationFn = Apollo.MutationFunction<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;

/**
 * __useDeleteSentInviteMutation__
 *
 * To run a mutation, you first call `useDeleteSentInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSentInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSentInviteMutation, { data, loading, error }] = useDeleteSentInviteMutation({
 *   variables: {
 *      deleteInviteId: // value for 'deleteInviteId'
 *   },
 * });
 */
export function useDeleteSentInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>(DeleteSentInviteDocument, options);
      }
export type DeleteSentInviteMutationHookResult = ReturnType<typeof useDeleteSentInviteMutation>;
export type DeleteSentInviteMutationResult = Apollo.MutationResult<DeleteSentInviteMutation>;
export type DeleteSentInviteMutationOptions = Apollo.BaseMutationOptions<DeleteSentInviteMutation, DeleteSentInviteMutationVariables>;
export const MembersOrganizationDocument = gql`
    query MembersOrganization($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    userRoles {
      id
      user {
        ...UserFields
      }
      assignedRole {
        ...UserRoleFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}
${UserRoleFieldsFragmentDoc}`;

/**
 * __useMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMembersOrganizationQuery(baseOptions: Apollo.QueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
      }
export function useMembersOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersOrganizationQuery, MembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersOrganizationQuery, MembersOrganizationQueryVariables>(MembersOrganizationDocument, options);
        }
export type MembersOrganizationQueryHookResult = ReturnType<typeof useMembersOrganizationQuery>;
export type MembersOrganizationLazyQueryHookResult = ReturnType<typeof useMembersOrganizationLazyQuery>;
export type MembersOrganizationQueryResult = Apollo.QueryResult<MembersOrganizationQuery, MembersOrganizationQueryVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: ID!, $userId: ID!) {
  removeMember(id: $organizationId, userId: $userId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($input: UpdateUserRoleInput!) {
  updateUserRole(input: $input) {
    id
    assignedRole {
      ...UserRoleFields
    }
  }
}
    ${UserRoleFieldsFragmentDoc}`;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const OrganizationNameImageDocument = gql`
    query OrganizationNameImage($organizationId: ID!) {
  organization(id: $organizationId) {
    name
    imageUrl
  }
}
    `;

/**
 * __useOrganizationNameImageQuery__
 *
 * To run a query within a React component, call `useOrganizationNameImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNameImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNameImageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationNameImageQuery(baseOptions: Apollo.QueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
      }
export function useOrganizationNameImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>(OrganizationNameImageDocument, options);
        }
export type OrganizationNameImageQueryHookResult = ReturnType<typeof useOrganizationNameImageQuery>;
export type OrganizationNameImageLazyQueryHookResult = ReturnType<typeof useOrganizationNameImageLazyQuery>;
export type OrganizationNameImageQueryResult = Apollo.QueryResult<OrganizationNameImageQuery, OrganizationNameImageQueryVariables>;
export const OrganizationsPageDocument = gql`
    query OrganizationsPage($pageNumber: Int!, $pageItemsCount: Int!, $searchQuery: String, $organizationType: OrganizationType, $ancestorOrganizationId: ID) {
  organizationsPage(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    searchQuery: $searchQuery
    organizationType: $organizationType
    ancestorOrganizationId: $ancestorOrganizationId
  ) {
    nodes {
      addressLine1
      audiencesCount
      addressLine2
      city
      country
      createdAt
      subscriptionOverride
      id
      imageUrl
      legalName
      name
      pixelMatchingCadence
      paidSubscription
      businessDataEnabled
      ...DisableEmailValidationFields
      pulseEnabled
      phone
      state
      updatedAt
      hiddenPeopleFields
      lookalikeEnabled
      zip
      userRoles {
        id
        user {
          id
        }
      }
      organizationType
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    ${DisableEmailValidationFieldsFragmentDoc}`;

/**
 * __useOrganizationsPageQuery__
 *
 * To run a query within a React component, call `useOrganizationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      searchQuery: // value for 'searchQuery'
 *      organizationType: // value for 'organizationType'
 *      ancestorOrganizationId: // value for 'ancestorOrganizationId'
 *   },
 * });
 */
export function useOrganizationsPageQuery(baseOptions: Apollo.QueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsPageQuery, OrganizationsPageQueryVariables>(OrganizationsPageDocument, options);
      }
export function useOrganizationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsPageQuery, OrganizationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsPageQuery, OrganizationsPageQueryVariables>(OrganizationsPageDocument, options);
        }
export type OrganizationsPageQueryHookResult = ReturnType<typeof useOrganizationsPageQuery>;
export type OrganizationsPageLazyQueryHookResult = ReturnType<typeof useOrganizationsPageLazyQuery>;
export type OrganizationsPageQueryResult = Apollo.QueryResult<OrganizationsPageQuery, OrganizationsPageQueryVariables>;
export const ListOrganizationRolesDocument = gql`
    query ListOrganizationRoles($organizationId: ID!) {
  listOrganizationRoles(id: $organizationId) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useListOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useListOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationRolesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationRolesQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>(ListOrganizationRolesDocument, options);
      }
export function useListOrganizationRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>(ListOrganizationRolesDocument, options);
        }
export type ListOrganizationRolesQueryHookResult = ReturnType<typeof useListOrganizationRolesQuery>;
export type ListOrganizationRolesLazyQueryHookResult = ReturnType<typeof useListOrganizationRolesLazyQuery>;
export type ListOrganizationRolesQueryResult = Apollo.QueryResult<ListOrganizationRolesQuery, ListOrganizationRolesQueryVariables>;
export const PeopleCountsDocument = gql`
    query PeopleCounts($field: FilterStringField!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  peopleCounts(
    field: $field
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
  ) {
    key
    count
  }
}
    `;

/**
 * __usePeopleCountsQuery__
 *
 * To run a query within a React component, call `usePeopleCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function usePeopleCountsQuery(baseOptions: Apollo.QueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleCountsQuery, PeopleCountsQueryVariables>(PeopleCountsDocument, options);
      }
export function usePeopleCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleCountsQuery, PeopleCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleCountsQuery, PeopleCountsQueryVariables>(PeopleCountsDocument, options);
        }
export type PeopleCountsQueryHookResult = ReturnType<typeof usePeopleCountsQuery>;
export type PeopleCountsLazyQueryHookResult = ReturnType<typeof usePeopleCountsLazyQuery>;
export type PeopleCountsQueryResult = Apollo.QueryResult<PeopleCountsQuery, PeopleCountsQueryVariables>;
export const PeopleFieldsCountsDocument = gql`
    query PeopleFieldsCounts($field: FilterStringField, $customField: String, $first: Int!, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean, $parentAudienceId: ID, $searchQuery: String, $after: String) {
  peopleFieldCounts(
    field: $field
    customField: $customField
    first: $first
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
    parentAudienceId: $parentAudienceId
    searchQuery: $searchQuery
    after: $after
  ) {
    nodes {
      count
      key
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __usePeopleFieldsCountsQuery__
 *
 * To run a query within a React component, call `usePeopleFieldsCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleFieldsCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleFieldsCountsQuery({
 *   variables: {
 *      field: // value for 'field'
 *      customField: // value for 'customField'
 *      first: // value for 'first'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *      parentAudienceId: // value for 'parentAudienceId'
 *      searchQuery: // value for 'searchQuery'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePeopleFieldsCountsQuery(baseOptions: Apollo.QueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>(PeopleFieldsCountsDocument, options);
      }
export function usePeopleFieldsCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>(PeopleFieldsCountsDocument, options);
        }
export type PeopleFieldsCountsQueryHookResult = ReturnType<typeof usePeopleFieldsCountsQuery>;
export type PeopleFieldsCountsLazyQueryHookResult = ReturnType<typeof usePeopleFieldsCountsLazyQuery>;
export type PeopleFieldsCountsQueryResult = Apollo.QueryResult<PeopleFieldsCountsQuery, PeopleFieldsCountsQueryVariables>;
export const PeopleFieldsDocument = gql`
    query PeopleFields {
  peopleFields {
    category
    filterField
    title
    type
    configuration {
      fieldAudienceTypes
      numberFilterConfiguration {
        from
        to
      }
      stringFilterConfiguration {
        condition
        onlyExistence
        isExtendedStringFilter
      }
    }
  }
}
    `;

/**
 * __usePeopleFieldsQuery__
 *
 * To run a query within a React component, call `usePeopleFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePeopleFieldsQuery(baseOptions?: Apollo.QueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleFieldsQuery, PeopleFieldsQueryVariables>(PeopleFieldsDocument, options);
      }
export function usePeopleFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleFieldsQuery, PeopleFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleFieldsQuery, PeopleFieldsQueryVariables>(PeopleFieldsDocument, options);
        }
export type PeopleFieldsQueryHookResult = ReturnType<typeof usePeopleFieldsQuery>;
export type PeopleFieldsLazyQueryHookResult = ReturnType<typeof usePeopleFieldsLazyQuery>;
export type PeopleFieldsQueryResult = Apollo.QueryResult<PeopleFieldsQuery, PeopleFieldsQueryVariables>;
export const JourneyDocument = gql`
    query Journey($first: Int!, $personId: ID!, $audienceId: ID!, $after: String, $filters: [JourneyFilterInput!]) {
  audience(id: $audienceId) {
    personJourney(
      personId: $personId
      first: $first
      after: $after
      filters: $filters
    ) {
      nodes {
        date
        id
        url
        ip
        os {
          name
          version
        }
        ipLocation {
          countryName
          countryCode
          regionName
          postalCode
          city
        }
        utmCampaign
        tealiumVisitorId
        gaSessionId
        utmMedium
        utmSource
        browser {
          name
          version
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useJourneyQuery__
 *
 * To run a query within a React component, call `useJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJourneyQuery({
 *   variables: {
 *      first: // value for 'first'
 *      personId: // value for 'personId'
 *      audienceId: // value for 'audienceId'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJourneyQuery(baseOptions: Apollo.QueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
      }
export function useJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JourneyQuery, JourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JourneyQuery, JourneyQueryVariables>(JourneyDocument, options);
        }
export type JourneyQueryHookResult = ReturnType<typeof useJourneyQuery>;
export type JourneyLazyQueryHookResult = ReturnType<typeof useJourneyLazyQuery>;
export type JourneyQueryResult = Apollo.QueryResult<JourneyQuery, JourneyQueryVariables>;
export const PersonJourneyGroupsDocument = gql`
    query PersonJourneyGroups($audienceId: ID!, $personId: ID!, $first: Int!, $groupBy: JourneyGroupByInput!) {
  person(audienceId: $audienceId, personId: $personId) {
    journeyGroups(first: $first, groupBy: $groupBy) {
      nodes {
        count
        key
      }
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __usePersonJourneyGroupsQuery__
 *
 * To run a query within a React component, call `usePersonJourneyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonJourneyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonJourneyGroupsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      personId: // value for 'personId'
 *      first: // value for 'first'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function usePersonJourneyGroupsQuery(baseOptions: Apollo.QueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>(PersonJourneyGroupsDocument, options);
      }
export function usePersonJourneyGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>(PersonJourneyGroupsDocument, options);
        }
export type PersonJourneyGroupsQueryHookResult = ReturnType<typeof usePersonJourneyGroupsQuery>;
export type PersonJourneyGroupsLazyQueryHookResult = ReturnType<typeof usePersonJourneyGroupsLazyQuery>;
export type PersonJourneyGroupsQueryResult = Apollo.QueryResult<PersonJourneyGroupsQuery, PersonJourneyGroupsQueryVariables>;
export const PeopleNumberHistogramDocument = gql`
    query PeopleNumberHistogram($field: FilterNumberField!, $interval: Int, $min: Int, $max: Int, $filters: [PersonFilterInput], $takeIntoAccountSameFieldFilters: Boolean) {
  peopleNumberHistogram(
    field: $field
    interval: $interval
    min: $min
    max: $max
    filters: $filters
    takeIntoAccountSameFieldFilters: $takeIntoAccountSameFieldFilters
  ) {
    count
    key
  }
}
    `;

/**
 * __usePeopleNumberHistogramQuery__
 *
 * To run a query within a React component, call `usePeopleNumberHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleNumberHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleNumberHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      interval: // value for 'interval'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      filters: // value for 'filters'
 *      takeIntoAccountSameFieldFilters: // value for 'takeIntoAccountSameFieldFilters'
 *   },
 * });
 */
export function usePeopleNumberHistogramQuery(baseOptions: Apollo.QueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>(PeopleNumberHistogramDocument, options);
      }
export function usePeopleNumberHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>(PeopleNumberHistogramDocument, options);
        }
export type PeopleNumberHistogramQueryHookResult = ReturnType<typeof usePeopleNumberHistogramQuery>;
export type PeopleNumberHistogramLazyQueryHookResult = ReturnType<typeof usePeopleNumberHistogramLazyQuery>;
export type PeopleNumberHistogramQueryResult = Apollo.QueryResult<PeopleNumberHistogramQuery, PeopleNumberHistogramQueryVariables>;
export const PersonDocument = gql`
    query Person($audienceId: ID!, $personId: ID!) {
  person(audienceId: $audienceId, personId: $personId) {
    id
    email
    gender
    firstName
    lastName
    address
    city
    state
    zip
  }
}
    `;

/**
 * __usePersonQuery__
 *
 * To run a query within a React component, call `usePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonQuery(baseOptions: Apollo.QueryHookOptions<PersonQuery, PersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
      }
export function usePersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonQuery, PersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonQuery, PersonQueryVariables>(PersonDocument, options);
        }
export type PersonQueryHookResult = ReturnType<typeof usePersonQuery>;
export type PersonLazyQueryHookResult = ReturnType<typeof usePersonLazyQuery>;
export type PersonQueryResult = Apollo.QueryResult<PersonQuery, PersonQueryVariables>;
export const PeopleDateHistogramDocument = gql`
    query PeopleDateHistogram($field: FilterDateField!, $audienceId: ID!, $min: Date, $max: Date, $interval: DateIntervalInput!) {
  audience(id: $audienceId) {
    peopleDateHistogram(field: $field, min: $min, max: $max, interval: $interval) {
      key
      count
    }
  }
}
    `;

/**
 * __usePeopleDateHistogramQuery__
 *
 * To run a query within a React component, call `usePeopleDateHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleDateHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleDateHistogramQuery({
 *   variables: {
 *      field: // value for 'field'
 *      audienceId: // value for 'audienceId'
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function usePeopleDateHistogramQuery(baseOptions: Apollo.QueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>(PeopleDateHistogramDocument, options);
      }
export function usePeopleDateHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>(PeopleDateHistogramDocument, options);
        }
export type PeopleDateHistogramQueryHookResult = ReturnType<typeof usePeopleDateHistogramQuery>;
export type PeopleDateHistogramLazyQueryHookResult = ReturnType<typeof usePeopleDateHistogramLazyQuery>;
export type PeopleDateHistogramQueryResult = Apollo.QueryResult<PeopleDateHistogramQuery, PeopleDateHistogramQueryVariables>;
export const PixelMatchCountsDocument = gql`
    query PixelMatchCounts($dateRange: DateOperatorsInput, $organizationId: ID) {
  pixelMatchCounts(dateRange: $dateRange, organizationId: $organizationId) {
    matchCount
    lowestTraffic {
      audience {
        id
      }
      count
    }
    highestTraffic {
      audience {
        id
      }
      count
    }
  }
}
    `;

/**
 * __usePixelMatchCountsQuery__
 *
 * To run a query within a React component, call `usePixelMatchCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelMatchCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelMatchCountsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelMatchCountsQuery(baseOptions?: Apollo.QueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>(PixelMatchCountsDocument, options);
      }
export function usePixelMatchCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>(PixelMatchCountsDocument, options);
        }
export type PixelMatchCountsQueryHookResult = ReturnType<typeof usePixelMatchCountsQuery>;
export type PixelMatchCountsLazyQueryHookResult = ReturnType<typeof usePixelMatchCountsLazyQuery>;
export type PixelMatchCountsQueryResult = Apollo.QueryResult<PixelMatchCountsQuery, PixelMatchCountsQueryVariables>;
export const PixelStatusCountDocument = gql`
    query PixelStatusCount($organizationId: ID) {
  pixelStatusCount(organizationId: $organizationId) {
    nearQuotaReached
    quotaReached
    withoutRecentMatches
  }
}
    `;

/**
 * __usePixelStatusCountQuery__
 *
 * To run a query within a React component, call `usePixelStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelStatusCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelStatusCountQuery(baseOptions?: Apollo.QueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PixelStatusCountQuery, PixelStatusCountQueryVariables>(PixelStatusCountDocument, options);
      }
export function usePixelStatusCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PixelStatusCountQuery, PixelStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PixelStatusCountQuery, PixelStatusCountQueryVariables>(PixelStatusCountDocument, options);
        }
export type PixelStatusCountQueryHookResult = ReturnType<typeof usePixelStatusCountQuery>;
export type PixelStatusCountLazyQueryHookResult = ReturnType<typeof usePixelStatusCountLazyQuery>;
export type PixelStatusCountQueryResult = Apollo.QueryResult<PixelStatusCountQuery, PixelStatusCountQueryVariables>;
export const PixelMatchDateHistogramDocument = gql`
    query PixelMatchDateHistogram($min: Date!, $max: Date!, $interval: DateIntervalInput!, $organizationId: ID) {
  pixelMatchDateHistogram(
    min: $min
    max: $max
    interval: $interval
    organizationId: $organizationId
  ) {
    count
    key
  }
}
    `;

/**
 * __usePixelMatchDateHistogramQuery__
 *
 * To run a query within a React component, call `usePixelMatchDateHistogramQuery` and pass it any options that fit your needs.
 * When your component renders, `usePixelMatchDateHistogramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePixelMatchDateHistogramQuery({
 *   variables: {
 *      min: // value for 'min'
 *      max: // value for 'max'
 *      interval: // value for 'interval'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function usePixelMatchDateHistogramQuery(baseOptions: Apollo.QueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>(PixelMatchDateHistogramDocument, options);
      }
export function usePixelMatchDateHistogramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>(PixelMatchDateHistogramDocument, options);
        }
export type PixelMatchDateHistogramQueryHookResult = ReturnType<typeof usePixelMatchDateHistogramQuery>;
export type PixelMatchDateHistogramLazyQueryHookResult = ReturnType<typeof usePixelMatchDateHistogramLazyQuery>;
export type PixelMatchDateHistogramQueryResult = Apollo.QueryResult<PixelMatchDateHistogramQuery, PixelMatchDateHistogramQueryVariables>;
export const AudiencePixelSettingsDocument = gql`
    query AudiencePixelSettings($audienceId: ID!) {
  audience(id: $audienceId) {
    id
    pixelSettings {
      hostAndPath
      location {
        address
        city
        state
      }
      codeSnippets {
        head
        body
      }
      quota {
        enabled
        limit
      }
      billing {
        dayOfMonth
      }
      pixelEnabled
      pixelStatus
    }
    name
    createdAt
  }
}
    `;

/**
 * __useAudiencePixelSettingsQuery__
 *
 * To run a query within a React component, call `useAudiencePixelSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudiencePixelSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudiencePixelSettingsQuery({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useAudiencePixelSettingsQuery(baseOptions: Apollo.QueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>(AudiencePixelSettingsDocument, options);
      }
export function useAudiencePixelSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>(AudiencePixelSettingsDocument, options);
        }
export type AudiencePixelSettingsQueryHookResult = ReturnType<typeof useAudiencePixelSettingsQuery>;
export type AudiencePixelSettingsLazyQueryHookResult = ReturnType<typeof useAudiencePixelSettingsLazyQuery>;
export type AudiencePixelSettingsQueryResult = Apollo.QueryResult<AudiencePixelSettingsQuery, AudiencePixelSettingsQueryVariables>;
export const ProductsDocument = gql`
    query Products {
  products {
    id
    name
    description
    priceInCents
    intervalUnit
    interval
    expirationInterval
    handle
    productFamily {
      name
    }
    publicSignupPages {
      enabled
      url
    }
    components {
      id
      unitName
      unitPrice
    }
    budgetPerPeriod
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const PromptPersonFilterDocument = gql`
    query PromptPersonFilter($promptPersonFilterParams: PromptPersonFilterInput!) {
  promptPersonFilter(promptPersonFilterParams: $promptPersonFilterParams) {
    filters {
      ...BasicFilterFields
      compoundFilter {
        filters {
          ...BasicFilterFields
          compoundFilter {
            filters {
              ...BasicFilterFields
            }
            operator
          }
        }
        operator
      }
    }
    sessionId
  }
}
    ${BasicFilterFieldsFragmentDoc}`;

/**
 * __usePromptPersonFilterQuery__
 *
 * To run a query within a React component, call `usePromptPersonFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptPersonFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptPersonFilterQuery({
 *   variables: {
 *      promptPersonFilterParams: // value for 'promptPersonFilterParams'
 *   },
 * });
 */
export function usePromptPersonFilterQuery(baseOptions: Apollo.QueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>(PromptPersonFilterDocument, options);
      }
export function usePromptPersonFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>(PromptPersonFilterDocument, options);
        }
export type PromptPersonFilterQueryHookResult = ReturnType<typeof usePromptPersonFilterQuery>;
export type PromptPersonFilterLazyQueryHookResult = ReturnType<typeof usePromptPersonFilterLazyQuery>;
export type PromptPersonFilterQueryResult = Apollo.QueryResult<PromptPersonFilterQuery, PromptPersonFilterQueryVariables>;
export const PulseNodesDocument = gql`
    query PulseNodes($first: Int!, $after: String, $parentPaths: [String!], $searchQuery: String) {
  pulseNodes(
    first: $first
    after: $after
    parentPaths: $parentPaths
    searchQuery: $searchQuery
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    nodes {
      id
      name
      signalCount
      paths
    }
  }
}
    `;

/**
 * __usePulseNodesQuery__
 *
 * To run a query within a React component, call `usePulseNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseNodesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      parentPaths: // value for 'parentPaths'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePulseNodesQuery(baseOptions: Apollo.QueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseNodesQuery, PulseNodesQueryVariables>(PulseNodesDocument, options);
      }
export function usePulseNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseNodesQuery, PulseNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseNodesQuery, PulseNodesQueryVariables>(PulseNodesDocument, options);
        }
export type PulseNodesQueryHookResult = ReturnType<typeof usePulseNodesQuery>;
export type PulseNodesLazyQueryHookResult = ReturnType<typeof usePulseNodesLazyQuery>;
export type PulseNodesQueryResult = Apollo.QueryResult<PulseNodesQuery, PulseNodesQueryVariables>;
export const PulseNodesSignalCountDocument = gql`
    query PulseNodesSignalCount {
  pulseNodesSignalCount
}
    `;

/**
 * __usePulseNodesSignalCountQuery__
 *
 * To run a query within a React component, call `usePulseNodesSignalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseNodesSignalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseNodesSignalCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePulseNodesSignalCountQuery(baseOptions?: Apollo.QueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>(PulseNodesSignalCountDocument, options);
      }
export function usePulseNodesSignalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>(PulseNodesSignalCountDocument, options);
        }
export type PulseNodesSignalCountQueryHookResult = ReturnType<typeof usePulseNodesSignalCountQuery>;
export type PulseNodesSignalCountLazyQueryHookResult = ReturnType<typeof usePulseNodesSignalCountLazyQuery>;
export type PulseNodesSignalCountQueryResult = Apollo.QueryResult<PulseNodesSignalCountQuery, PulseNodesSignalCountQueryVariables>;
export const RemoveAudienceMemberDocument = gql`
    mutation RemoveAudienceMember($audienceId: ID!, $userId: ID!) {
  removeAudienceMember(audienceId: $audienceId, userId: $userId)
}
    `;
export type RemoveAudienceMemberMutationFn = Apollo.MutationFunction<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>;

/**
 * __useRemoveAudienceMemberMutation__
 *
 * To run a mutation, you first call `useRemoveAudienceMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAudienceMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAudienceMemberMutation, { data, loading, error }] = useRemoveAudienceMemberMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAudienceMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>(RemoveAudienceMemberDocument, options);
      }
export type RemoveAudienceMemberMutationHookResult = ReturnType<typeof useRemoveAudienceMemberMutation>;
export type RemoveAudienceMemberMutationResult = Apollo.MutationResult<RemoveAudienceMemberMutation>;
export type RemoveAudienceMemberMutationOptions = Apollo.BaseMutationOptions<RemoveAudienceMemberMutation, RemoveAudienceMemberMutationVariables>;
export const ResendInviteDocument = gql`
    mutation ResendInvite($resendInviteId: ID!) {
  resendInvite(id: $resendInviteId) {
    id
  }
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      resendInviteId: // value for 'resendInviteId'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const SegmentsPageDocument = gql`
    query SegmentsPage($pageNumber: Int!, $pageItemsCount: Int!, $audienceId: ID!) {
  audience(id: $audienceId) {
    segmentsPage(pageNumber: $pageNumber, pageItemsCount: $pageItemsCount) {
      totalCount
      nodes {
        id
        name
        creator {
          id
          imageUrl
          firstName
          lastName
        }
        organization {
          id
          name
        }
        condition
        peopleCount
        organizationId
        parentAudience {
          id
          condition
        }
      }
    }
  }
}
    `;

/**
 * __useSegmentsPageQuery__
 *
 * To run a query within a React component, call `useSegmentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsPageQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      audienceId: // value for 'audienceId'
 *   },
 * });
 */
export function useSegmentsPageQuery(baseOptions: Apollo.QueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentsPageQuery, SegmentsPageQueryVariables>(SegmentsPageDocument, options);
      }
export function useSegmentsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentsPageQuery, SegmentsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentsPageQuery, SegmentsPageQueryVariables>(SegmentsPageDocument, options);
        }
export type SegmentsPageQueryHookResult = ReturnType<typeof useSegmentsPageQuery>;
export type SegmentsPageLazyQueryHookResult = ReturnType<typeof useSegmentsPageLazyQuery>;
export type SegmentsPageQueryResult = Apollo.QueryResult<SegmentsPageQuery, SegmentsPageQueryVariables>;
export const SendSupportEmailDocument = gql`
    mutation SendSupportEmail($message: String!) {
  sendSupportEmail(message: $message)
}
    `;
export type SendSupportEmailMutationFn = Apollo.MutationFunction<SendSupportEmailMutation, SendSupportEmailMutationVariables>;

/**
 * __useSendSupportEmailMutation__
 *
 * To run a mutation, you first call `useSendSupportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSupportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSupportEmailMutation, { data, loading, error }] = useSendSupportEmailMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSupportEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSupportEmailMutation, SendSupportEmailMutationVariables>(SendSupportEmailDocument, options);
      }
export type SendSupportEmailMutationHookResult = ReturnType<typeof useSendSupportEmailMutation>;
export type SendSupportEmailMutationResult = Apollo.MutationResult<SendSupportEmailMutation>;
export type SendSupportEmailMutationOptions = Apollo.BaseMutationOptions<SendSupportEmailMutation, SendSupportEmailMutationVariables>;
export const SubscriptionInfoDocument = gql`
    query SubscriptionInfo($organizationId: ID!) {
  subscriptionInfo(organizationId: $organizationId) {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSubscriptionInfoQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
      }
export function useSubscriptionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>(SubscriptionInfoDocument, options);
        }
export type SubscriptionInfoQueryHookResult = ReturnType<typeof useSubscriptionInfoQuery>;
export type SubscriptionInfoLazyQueryHookResult = ReturnType<typeof useSubscriptionInfoLazyQuery>;
export type SubscriptionInfoQueryResult = Apollo.QueryResult<SubscriptionInfoQuery, SubscriptionInfoQueryVariables>;
export const UpdateAudienceDocument = gql`
    mutation updateAudience($audienceUpdateParams: AudienceUpdateInput!) {
  updateAudience(audienceUpdateParams: $audienceUpdateParams) {
    id
    name
  }
}
    `;
export type UpdateAudienceMutationFn = Apollo.MutationFunction<UpdateAudienceMutation, UpdateAudienceMutationVariables>;

/**
 * __useUpdateAudienceMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceMutation, { data, loading, error }] = useUpdateAudienceMutation({
 *   variables: {
 *      audienceUpdateParams: // value for 'audienceUpdateParams'
 *   },
 * });
 */
export function useUpdateAudienceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceMutation, UpdateAudienceMutationVariables>(UpdateAudienceDocument, options);
      }
export type UpdateAudienceMutationHookResult = ReturnType<typeof useUpdateAudienceMutation>;
export type UpdateAudienceMutationResult = Apollo.MutationResult<UpdateAudienceMutation>;
export type UpdateAudienceMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceMutation, UpdateAudienceMutationVariables>;
export const UpdateAudienceCategoriesDocument = gql`
    mutation UpdateAudienceCategories($audienceId: ID!, $categoryCodes: [Int!]!) {
  updateAudienceCategories(audienceId: $audienceId, categoryCodes: $categoryCodes)
}
    `;
export type UpdateAudienceCategoriesMutationFn = Apollo.MutationFunction<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>;

/**
 * __useUpdateAudienceCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceCategoriesMutation, { data, loading, error }] = useUpdateAudienceCategoriesMutation({
 *   variables: {
 *      audienceId: // value for 'audienceId'
 *      categoryCodes: // value for 'categoryCodes'
 *   },
 * });
 */
export function useUpdateAudienceCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>(UpdateAudienceCategoriesDocument, options);
      }
export type UpdateAudienceCategoriesMutationHookResult = ReturnType<typeof useUpdateAudienceCategoriesMutation>;
export type UpdateAudienceCategoriesMutationResult = Apollo.MutationResult<UpdateAudienceCategoriesMutation>;
export type UpdateAudienceCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceCategoriesMutation, UpdateAudienceCategoriesMutationVariables>;
export const UpdateAudienceIntegrationDocument = gql`
    mutation UpdateAudienceIntegration($integrationParams: AudienceIntegrationUpdateInput!) {
  updateAudienceIntegration(integrationParams: $integrationParams) {
    id
  }
}
    `;
export type UpdateAudienceIntegrationMutationFn = Apollo.MutationFunction<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>;

/**
 * __useUpdateAudienceIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateAudienceIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudienceIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudienceIntegrationMutation, { data, loading, error }] = useUpdateAudienceIntegrationMutation({
 *   variables: {
 *      integrationParams: // value for 'integrationParams'
 *   },
 * });
 */
export function useUpdateAudienceIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>(UpdateAudienceIntegrationDocument, options);
      }
export type UpdateAudienceIntegrationMutationHookResult = ReturnType<typeof useUpdateAudienceIntegrationMutation>;
export type UpdateAudienceIntegrationMutationResult = Apollo.MutationResult<UpdateAudienceIntegrationMutation>;
export type UpdateAudienceIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateAudienceIntegrationMutation, UpdateAudienceIntegrationMutationVariables>;
export const UpdateAudiencePixelSettingsDocument = gql`
    mutation updateAudiencePixelSettings($audiencePixelSettingsParams: AudiencePixelSettingsUpdateInput!) {
  updatePixelAudienceSettings(
    audiencePixelSettingsParams: $audiencePixelSettingsParams
  ) {
    id
  }
}
    `;
export type UpdateAudiencePixelSettingsMutationFn = Apollo.MutationFunction<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>;

/**
 * __useUpdateAudiencePixelSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAudiencePixelSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudiencePixelSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudiencePixelSettingsMutation, { data, loading, error }] = useUpdateAudiencePixelSettingsMutation({
 *   variables: {
 *      audiencePixelSettingsParams: // value for 'audiencePixelSettingsParams'
 *   },
 * });
 */
export function useUpdateAudiencePixelSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>(UpdateAudiencePixelSettingsDocument, options);
      }
export type UpdateAudiencePixelSettingsMutationHookResult = ReturnType<typeof useUpdateAudiencePixelSettingsMutation>;
export type UpdateAudiencePixelSettingsMutationResult = Apollo.MutationResult<UpdateAudiencePixelSettingsMutation>;
export type UpdateAudiencePixelSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAudiencePixelSettingsMutation, UpdateAudiencePixelSettingsMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    scopes
    whiteLabelImageUrl
    organizations {
      id
      name
      legalName
      organizationType
      imageUrl
      subscriptionOverride
      paidSubscription
      audiencesCount
      businessDataEnabled
      pulseEnabled
      globalSearchEnabled
      customerListEnabled
      lookalikeEnabled
      phone
      addressLine1
      addressLine2
      city
      hiddenPeopleFields
      state
      country
      zip
    }
    invites {
      id
      email
      organizationId
      createdByUserId
      status
      createdAt
      updatedAt
      acceptedAt
      declinedAt
      deletedAt
      inviter {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
      user {
        id
        firstName
        lastName
        email
        phone
        imageUrl
      }
      organization {
        id
        name
        imageUrl
      }
    }
    userRoles {
      id
      hiddenPeopleFields
      assignedRole {
        id
        name
        permissions
        childOrgExtraPermissions
        hiddenPeopleFields
      }
      organizationId
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($user: UpdateUserInput) {
  updateMe(user: $user) {
    id
    firstName
    lastName
  }
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;